// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const gamesSlugMap = {
    "1_million_fortunes_megaways": {
        name: "1 Million Fortunes Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "1_million_megaways_bc": {
        name: "1 Million Megaways BC",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "10_cash_bisons": {
        name: "10 Cash Bisons",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "10_flaming_bisons": {
        name: "10 Flaming Bisons",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "10_pharaohs": {
        name: "10 Pharaohs",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "10_santas_reindeers": {
        name: "10 Santa's Reindeers",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "10_sparkling_crown": {
        name: "10 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "10_swords": {
        name: "10 Swords",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "100_bit_dice": {
        name: "100 Bit Dice",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "100_blazing_clover": {
        name: "100 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "100_flaring_fruits": {
        name: "100 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "100_super_icy": {
        name: "100 Super Icy",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "10000_bc_2_doublemax": {
        name: "10000 BC 2 Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "10000_bc_doublemax": {
        name: "10000 BC Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "10000_wolves_10k_ways": {
        name: "10,000 Wolves 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "10000_wonders": {
        name: "10,000 Wonders",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "10000_wonders_10k_ways": {
        name: "10,000 Wonders 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "10000_wonders_big_bang": {
        name: "10000 Wonders Big Bang",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "10000_wonders_multimax": {
        name: "10000 Wonders Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "10000x_gold": {
        name: "10000x Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "10000x_gold_2": {
        name: "10000X Gold 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "1000x_busta": {
        name: "1000x Busta",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "1001_mystery_genie_fortunes": {
        name: "1001 Mystery Genie Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "100k_joker": {
        name: "100k Joker",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "101_candies": {
        name: "101 Candies",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "10p_10c_slot": {
        name: "10p 10c Slot",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "10p_roulette": {
        name: "10p Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "10x_rewind": {
        name: "10X Rewind",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "12_burning_baseballs": {
        name: "12 Burning Baseballs",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "12_coins_grand_gold_edition": {
        name: "12 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "12_coins_grand_platinum_edition": {
        name: "12 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "12_trojan_mysteries": {
        name: "12 Trojan Mysteries",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "12_volt_diamonds": {
        name: "12 Volt Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "12_zodiacs": {
        name: "12 Zodiacs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "121_gigawatts": {
        name: "1.21 Gigawatts",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "123_boom": {
        name: "123 Boom",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "13th_trial_hercules_abyssways": {
        name: "13th Trial Hercules Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "15_coins": {
        name: "15 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_coins_grand_diamond_edition": {
        name: "15 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_coins_grand_platinum_edition": {
        name: "15 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_crystal_roses_a_tale_of_love": {
        name: "15 Crystal Roses: A Tale of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "15_dragon_pearls": {
        name: "15 Dragon Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "16_coins": {
        name: "16 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "16_coins_grand_gold_edition": {
        name: "16 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "16_coins_grand_platinum_edition": {
        name: "16 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "16_coins_x5000": {
        name: "16 Coins x5000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "2_can_party_reel_triple": {
        name: "2 Can Party Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "2_fast_2_fruity": {
        name: "2 Fast 2 Fruity",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "2_sweet_4_u": {
        name: "2 Sweet 4 U",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "20_blazing_clover": {
        name: "20 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "20_coins": {
        name: "20 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "20_coins_grand_gold_edition": {
        name: "20 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "20_ember_wilds": {
        name: "20 Ember Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "20_flaring_fruits": {
        name: "20 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "20000_leagues": {
        name: "20000 Leagues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "21_thor_lightning_ways": {
        name: "21 Thor Lightning Ways",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "24_coins": {
        name: "24 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "243_chili": {
        name: "243 Chili",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_christmas_fruits": {
        name: "243 Christmas Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_crystal_fruits": {
        name: "243 Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_crystal_fruits_reversed": {
        name: "243 Crystal Fruits Reversed",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_fire_n_diamonds": {
        name: "243 Fire n Diamonds",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_zeus_fruits": {
        name: "243 Zeus Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "24d_spin": {
        name: "24D Spin",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "24k_dragon": {
        name: "24K Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "24k_gold_jailbreak": {
        name: "24K Gold Jailbreak",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "24k_gold_shamrock_on": {
        name: "24K Gold Shamrock On",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "25_coins": {
        name: "25 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "25_coins_grand_gold_edition": {
        name: "25 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "250k_deluxe": {
        name: "250k Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "3_african_drums": {
        name: "3 African Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_apex_treasures": {
        name: "3 Apex Treasures",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_aztec_temples": {
        name: "3 Aztec Temples",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_blades_and_blessings": {
        name: "3 Blades and Blessings",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_builder_piggies": {
        name: "3 Builder Piggies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_bunny_pots_bonanza": {
        name: "3 Bunny Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "3_buzzing_wilds": {
        name: "3 Buzzing Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_capybaras": {
        name: "3 Capybaras",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_cards": {
        name: "3 Cards",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "3_cards_diwali_special": {
        name: "3 Cards Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "3_charge_buffalo": {
        name: "3 Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_cheeky_chimps": {
        name: "3 Cheeky Chimps",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_china_pots": {
        name: "3 China Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_christmas_fortunes": {
        name: "3 Christmas Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_clover_pots": {
        name: "3 Clover Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_clover_pots_extra": {
        name: "3 Clover Pots Extra",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_clown_monty": {
        name: "3 Clown Monty",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_clown_monty_ii": {
        name: "3 Clown Monty II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_coin_golden_ox": {
        name: "3 Coin Golden Ox",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_coin_treasures": {
        name: "3 Coin Treasures",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_coin_treasures_2": {
        name: "3 Coin Treasures 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_coin_volcanoes": {
        name: "3 Coin Volcanoes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_coin_wild_horse": {
        name: "3 Coin Wild Horse",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_coin_wild_tiger": {
        name: "3 Coin Wild Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_coins": {
        name: "3 Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_crazy_tikis": {
        name: "3 Crazy Tikis",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_crowns_coin_hunt": {
        name: "3 Crowns Coin Hunt",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "3_cursed_chests_hold_and_win": {
        name: "3 Cursed Chests: Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "3_dancing_monkeys": {
        name: "3 Dancing Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_dragon_pots": {
        name: "3 Dragon Pots",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "3_egypt_chests": {
        name: "3 Egypt Chests",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_genie_wishes": {
        name: "3 Genie Wishes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_gods_of_goalympus": {
        name: "3 Gods of Goalympus",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_hand_casino": {
        name: "3 Hand Casino",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_hot_chilli_peppers": {
        name: "3 Hot Chilli Peppers",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_hot_chilli_peppers_extra": {
        name: "3 Hot Chilli Peppers Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_hot_chillies": {
        name: "3 Hot Chillies",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_hot_teapots": {
        name: "3 Hot Teapots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_jewel_crowns": {
        name: "3 Jewel Crowns",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_jungle_beats": {
        name: "3 Jungle Beats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_kingdoms_battle_of_red_cliffs": {
        name: "3 Kingdoms - Battle of Red Cliffs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_kings_scratch": {
        name: "3 Kings Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "3_leprechaun_charms": {
        name: "3 Leprechaun Charms",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_lucky_baozhu": {
        name: "3 Lucky Baozhu",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_lucky_leprechauns": {
        name: "3 Lucky Leprechauns",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "3_lucky_lions": {
        name: "3 Lucky Lions",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_lucky_minecarts_hold_and_win": {
        name: "3 Lucky Minecarts Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "3_lucky_piggy": {
        name: "3 Lucky Piggy",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_lucky_sparks": {
        name: "3 Lucky Sparks",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_lucky_witches": {
        name: "3 Lucky Witches",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "3_mad_frogs": {
        name: "3 Mad Frogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_magic_eggs": {
        name: "3 Magic Eggs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_magic_pots": {
        name: "3 Magic Pots",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "3_mermaids": {
        name: "3 Mermaids",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "3_pinatas": {
        name: "3 Pinatas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_plucky_hens": {
        name: "3 Plucky Hens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_christmas": {
        name: "3 Porky Banks Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_hold_and_win": {
        name: "3 Porky Banks Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_hold_and_win_extra": {
        name: "3 Porky Banks Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_pot_dragons": {
        name: "3 Pot Dragons",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_pots_of_egypt": {
        name: "3 Pots of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_power_bears": {
        name: "3 Power Bears",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_power_dragons": {
        name: "3 Power Dragons",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_power_genies": {
        name: "3 Power Genies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_ribbon_pots": {
        name: "3 Ribbon Pots",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "3_rockin_penguins": {
        name: "3 Rockin Penguins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_runaway_riches": {
        name: "3 Runaway Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_secret_cities": {
        name: "3 Secret Cities",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "3_super_coin_volcanoes": {
        name: "3 Super Coin Volcanoes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_super_hot_chillies": {
        name: "3 Super Hot Chillies",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3_super_porky_banks": {
        name: "3 Super Porky Banks",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_top_dogs": {
        name: "3 Top Dogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_wicked_devils": {
        name: "3 Wicked Devils",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_wild_aliens": {
        name: "3 Wild Aliens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_witchs_lamp": {
        name: "3 Witch's Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "3_wonders_grillmaster_grizzly": {
        name: "3 Wonders Grillmaster Grizzly",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "3_wonders_new_year_carnival": {
        name: "3 Wonders New Year Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "3_wonders_ny_carnival_94": {
        name: "3 Wonders NY Carnival 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "3_wonders_underworld": {
        name: "3 Wonders Underworld",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "30_coins": {
        name: "30 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "30_coins_grand_gold_edition": {
        name: "30 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "36_coins": {
        name: "36 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "36_coins_grand_gold_edition": {
        name: "36 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "3d_baccarat": {
        name: "3D Baccarat",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3d_blackjack": {
        name: "3D Blackjack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3d_european_roulette": {
        name: "3D European Roulette",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "4_african_drums": {
        name: "4 African Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4_clover_pots": {
        name: "4 Clover Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4_crabbin_fortunes": {
        name: "4 Crabbin' Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "4_deals_with_the_devil": {
        name: "4 Deals With The Devil",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_dragon_pots": {
        name: "4 Dragon Pots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "4_fairy_flowers": {
        name: "4 Fairy Flowers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4_fantastic_fish": {
        name: "4 Fantastic Fish",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_fish_amazon_adventure": {
        name: "4 Fantastic Fish Amazon Adventure",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_fish_gigablox": {
        name: "4 Fantastic Fish Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_fish_gold": {
        name: "4 Fantastic Fish Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_fish_in_egypt": {
        name: "4 Fantastic Fish in Egypt",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_vikings_go_fishing": {
        name: "4 Fantastic Vikings Go Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fantastic_vikings_go_ice_fishing": {
        name: "4 Fantastic Vikings Go Ice Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_fortune_clovers": {
        name: "4 Fortune Clovers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4_pirate_chests": {
        name: "4 Pirate Chests",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_pots_of_egypt": {
        name: "4 Pots of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4_secret_pyramids": {
        name: "4 Secret Pyramids",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4_wild_riches": {
        name: "4 Wild Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "4_wolf_drums": {
        name: "4 Wolf Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "40_finest_xxl": {
        name: "40 Finest XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "40_finest_xxl_flaming_link": {
        name: "40 Finest XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "40_hot_diamond_desire": {
        name: "40 Hot Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "40_sparkling_crown": {
        name: "40 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "420_blaze_it": {
        name: "420 Blaze It",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "4tp_book_of_africra": {
        name: "4TP Book of AfricRa",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4tp_guns_n_gold": {
        name: "4TP Guns N Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4tp_pigs_n_pots": {
        name: "4TP Pigs N' Pots",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5_clans": {
        name: "5 Clans",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "5_doggy_dollars": {
        name: "5 Doggy Dollars",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5_ember_wilds": {
        name: "5 Ember Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "5_flaring_fruits": {
        name: "5 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "5_frozen_charms_megaways": {
        name: "5 Frozen Charms Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_hot_diamond_desire": {
        name: "5 Hot Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "5_lions": {
        name: "5 Lions",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_dance": {
        name: "5 Lions Dance",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_gold": {
        name: "5 Lions Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_megaways": {
        name: "5 Lions MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_megaways_2": {
        name: "5 Lions Megaways 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_reborn": {
        name: "5 Lions Reborn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lucky_lions": {
        name: "5 Lucky Lions",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "5_mariachis": {
        name: "5 Mariachis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "5_rabbits_megaways": {
        name: "5 Rabbits MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_wild_buffalo": {
        name: "5 Wild Buffalo",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5_wild_buffalo_2": {
        name: "5 Wild Buffalo 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5_wild_buffalo_3": {
        name: "5 Wild Buffalo 3",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5_wild_wolves": {
        name: "5 Wild Wolves",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "50_flaring_fruits": {
        name: "50 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "500k_heist": {
        name: "500K Heist",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "5k_gold_mine": {
        name: "5K Gold Mine",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "5x_magic": {
        name: "5x Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "6_jokers": {
        name: "6 Jokers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "6_wild_sharks": {
        name: "6 Wild Sharks",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "60_second_heist": {
        name: "60 Second Heist",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "64_gold_coins_hold_and_win": {
        name: "64 Gold Coins Hold and Win ",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_gold_coins_hold_and_win_20000": {
        name: "64 Gold Coins Hold and Win 20000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_gold_coins_hold_and_win_live": {
        name: "64 Gold Coins Hold and Win Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_nuggets_hold_and_win": {
        name: "64 Nuggets Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_presents_hold_and_win": {
        name: "64 Presents Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_presents_hold_and_win_live": {
        name: "64 Presents Hold and Win Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "7_11_21": {
        name: "7 11 21",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "7_clovers_of_fortune": {
        name: "7 Clovers of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_elements": {
        name: "7 Elements",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "7_fates": {
        name: "7 Fates",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "7_gold_fruits": {
        name: "7 Gold Fruits",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "7_gold_gigablox": {
        name: "7 Gold Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "7_lucky_gods": {
        name: "7 Lucky Gods",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "7_monkeys": {
        name: "7 Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_monkeys_jp": {
        name: "7 Monkeys JP",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_piggies": {
        name: "7 Piggies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_piggies_scratch_25000": {
        name: "7 Piggies Scratch 25,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_sins": {
        name: "7 Sins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "7_updown": {
        name: "7 UP-DOWN",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "777": {
        name: "777",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "777_coins": {
        name: "777 Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "777_deluxe": {
        name: "777 Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "777_fruity_coins": {
        name: "777 Fruity Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "777_gems_respin": {
        name: "777 Gems Respin",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "7th_squadron_doublemax": {
        name: "7th Squadron Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "7up": {
        name: "7UP!",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "7up7down": {
        name: "7up7down",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "7x7_thor": {
        name: "7x7 Thor",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "7x7_zeus": {
        name: "7x7 Zeus",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "8_balls_of_fire": {
        name: "8 Balls of Fire",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "8_balls_of_fire_blazing_bounty": {
        name: "8 Balls of Fire Blazing Bounty",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "8_dragons": {
        name: "8 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "8_golden_dragon_challenge": {
        name: "8 Golden Dragon Challenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "8_treasures_luck_of_the_dragon": {
        name: "8 Treasures Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "80spop": {
        name: "80sPOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "81_creepy_circus": {
        name: "81 Creepy Circus",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_frutas_grandes": {
        name: "81 Frutas Grandes",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_frutas_grandes_vip": {
        name: "81 Frutas Grandes VIP",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_joker_x": {
        name: "81 Joker X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "88_ya": {
        name: "88 Ya",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "888_bonanza": {
        name: "888 Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "888_dragons": {
        name: "888 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "888_gold": {
        name: "888 Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "88fa": {
        name: "88FA",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "8k_ultra_gold_ultimate": {
        name: "8K Ultra Gold Ultimate",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "9_balls": {
        name: "9 Balls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_burning_dragons": {
        name: "9 Burning Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_burning_stars": {
        name: "9 Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins": {
        name: "9 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_1000_edition": {
        name: "9 Coins 1000 Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_extremely_light": {
        name: "9 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_diamond_edition": {
        name: "9 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_gold_edition": {
        name: "9 Coins: Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_platinum_edition": {
        name: "9 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_lions": {
        name: "9 Lions",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_lions_hold_the_jackpot": {
        name: "9 Lions Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_tigers": {
        name: "9 Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "90k_yeti_gigablox": {
        name: "90k Yeti Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "9k_kong_in_vegas": {
        name: "9k Kong In Vegas",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "9k_yeti": {
        name: "9k Yeti",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "aarupolis": {
        name: "Aarupolis",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "abduction": {
        name: "Abduction",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "abrakadabra": {
        name: "Abrakadabra",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "acceptance_test": {
        name: "Acceptance Test",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ace_of_spades": {
        name: "Ace of Spades",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ace_round": {
        name: "Ace Round",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "aces_and_eights_1_hand": {
        name: "Aces and Eights 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "aces_and_eights_10_hand": {
        name: "Aces and Eights 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "aces_and_eights_100_hand": {
        name: "Aces and Eights 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "aces_and_eights_5_hand": {
        name: "Aces and Eights 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "aces_and_eights_50_hand": {
        name: "Aces and Eights 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "adrenaline_rush": {
        name: "Adrenaline Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "adrenaline_rush_scratch": {
        name: "Adrenaline Rush Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "adrenaline_rush_super_boost": {
        name: "Adrenaline Rush: Super Boost",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "adrenaline_rush_xcrash": {
        name: "Adrenaline Rush: XCrash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "adventures_beyond_wonderland_magical_maze": {
        name: "Adventures Beyond Wonderland Magical Maze",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "aero_adventure": {
        name: "Aero Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "african_elephant": {
        name: "African Elephant",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "african_rhino": {
        name: "African Rhino",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "age_of_athena": {
        name: "Age of Athena",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "age_of_beasts_infinity_reels": {
        name: "Age of Beasts Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "agent_ace": {
        name: "Agent Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "agent_destiny": {
        name: "Agent Destiny",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "agent_of_hearts": {
        name: "Agent of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ahoy_royale": {
        name: "Ahoy Royale",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "airavat_the_white_elephant": {
        name: "Airavat The White Elephant",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "airavat_white_elephant_scratch": {
        name: "Airavat White Elephant Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "ak47": {
        name: "AK47",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "akne_fruits": {
        name: "Akne Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "aladdin_and_the_sorcerer": {
        name: "Aladdin and The Sorcerer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "alchemy": {
        name: "Alchemy",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "alchemy_gold": {
        name: "Alchemy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "alexandria_fire": {
        name: "Alexandria Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ali_baba": {
        name: "Ali Baba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "alibabas_cave_of_fortune": {
        name: "Alibaba's Cave of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "alibi": {
        name: "Alibi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "alice_in_adventureland": {
        name: "Alice in Adventureland",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "alice_in_winderland": {
        name: "Alice in Winderland",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "alice_wonderluck": {
        name: "Alice Wonderluck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits": {
        name: "Alien Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits_2": {
        name: "Alien Fruits 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits_3": {
        name: "Alien Fruits 3",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_invaders": {
        name: "Alien Invaders",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "alien_sea_turtles_vs_humans": {
        name: "Alien Sea Turtles vs Humans",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "aliens_among_us": {
        name: "Aliens Among Us",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "all_american_poker_1_hand": {
        name: "All American Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_american_poker_10_hand": {
        name: "All American Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_american_poker_100_hand": {
        name: "All American Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_american_poker_5_hand": {
        name: "All American Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_american_poker_50_hand": {
        name: "All American Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_for_one": {
        name: "All For One",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_lucky_clover": {
        name: "All Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "all_men_are_brothers_94": {
        name: "All Men are Brothers 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "all_star_fruits": {
        name: "All Star Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "allstar_fishing": {
        name: "All-star Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "almighty_bear_megaways": {
        name: "Almighty Bear Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "almighty_goddess_zera": {
        name: "Almighty Goddess Zera",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "almighty_hera": {
        name: "Almighty Hera",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "almighty_mustang_express": {
        name: "Almighty Mustang Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "almighty_thunder_ultrahitz_gigablox": {
        name: "Almighty Thunder UltraHitz Gigablox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "aloha_christmas": {
        name: "Aloha! Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "aloha_cluster_pays": {
        name: "Aloha! Cluster Pays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "aloha_cuties_jp": {
        name: "Aloha Cuties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "aloha_king_elvis": {
        name: "Aloha King Elvis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alpha_gold": {
        name: "Alpha Gold",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "always_up": {
        name: "Always Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "always_up_x10000": {
        name: "Always Up x10000",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "amar_akhbar_anthony": {
        name: "Amar Akhbar Anthony",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "amazing_baccarat": {
        name: "Amazing Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "amazing_money_machine": {
        name: "Amazing Money Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "amazing_soda_rush": {
        name: "Amazing Soda Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "amazonia_wins": {
        name: "Amazonia Wins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "american_blackjack": {
        name: "American Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "american_outlaws_multimax": {
        name: "American Outlaws Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "american_party_riches": {
        name: "American Party Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "american_poker_gold": {
        name: "American Poker Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "american_poker_v": {
        name: "American Poker V",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "american_respin": {
        name: "American Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "american_roulette": {
        name: "American Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "american_roulette_3d": {
        name: "American Roulette 3D",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "american_sevens": {
        name: "American Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "amulets_of_horus": {
        name: "Amulets of Horus",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "anacoda_gold": {
        name: "Anacoda Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_blocks": {
        name: "Ancient Blocks",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "ancient_eclipse": {
        name: "Ancient Eclipse",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "ancient_egypt": {
        name: "Ancient Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_egypt_classic": {
        name: "Ancient Egypt Classic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_island_megaways": {
        name: "Ancient Island Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_magic": {
        name: "Ancient Magic",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ancient_riches": {
        name: "Ancient Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ancient_riches_rhfp": {
        name: "Ancient Riches RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ancient_stones": {
        name: "Ancient Stones",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "ancient_tumble": {
        name: "Ancient Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "andar_bahar": {
        name: "Andar Bahar",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "andar_nights": {
        name: "Andar Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "angel_ascend_crash": {
        name: "Angel Ascend Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "angel_vs_sinner": {
        name: "Angel vs Sinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "animafia": {
        name: "Animafia",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "animal_carnival": {
        name: "Animal Carnival",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "animal_madness": {
        name: "Animal Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "animal_quest": {
        name: "Animal Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "animals_strike": {
        name: "Animals Strike",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "anime_mecha_megaways": {
        name: "Anime Mecha Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ankh_of_anubis": {
        name: "Ankh of Anubis",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ankh_of_anubis_awakening": {
        name: "Ankh of Anubis  Awakening",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "annihilator": {
        name: "Annihilator",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "anubis_curse": {
        name: "Anubis Curse",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "anubis_curse_2": {
        name: "Anubis Curse 2",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "anubis_ii_doublemax": {
        name: "Anubis II Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "anubis_moon": {
        name: "Anubis’ Moon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "anubis_wrath": {
        name: "Anubis Wrath",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "apex_strike_lucky_cache": {
        name: "Apex Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "apex_strike_megaways": {
        name: "Apex Strike Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "arabian_spins": {
        name: "Arabian spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "arcade": {
        name: "Arcade",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "arcanapop": {
        name: "ArcanaPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "arcane_elements": {
        name: "Arcane Elements",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "arcane_gems": {
        name: "Arcane Gems",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "arcane_reel_chaos": {
        name: "Arcane: Reel Chaos",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "archangels_salvation": {
        name: "Archangels Salvation",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "arctic_catch": {
        name: "Arctic Catch",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "arctic_fruits": {
        name: "Arctic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "arctic_hunt": {
        name: "Arctic Hunt",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "arctic_sorcerer_gigablox": {
        name: "Arctic Sorcerer Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "arctic_wonders": {
        name: "Arctic Wonders",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "arena_fighter": {
        name: "Arena Fighter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "argonauts": {
        name: "Argonauts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ark_of_mystery": {
        name: "Ark of Mystery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "armageddon_10k_ways": {
        name: "Armageddon 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "army_of_ares": {
        name: "Army of Ares",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "arriba_heat": {
        name: "Arriba Heat",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "arriba_heat_fuego_fortunes": {
        name: "Arriba Heat Fuego Fortunes",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "arriba_heat_megaways": {
        name: "Arriba Heat Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "arriba_heat_salsa_wilds": {
        name: "Arriba Heat Salsa Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "arrow_slot": {
        name: "Arrow Slot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "arrr_10k_ways": {
        name: "ARRR! 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "artemis_vs_medusa": {
        name: "Artemis vs Medusa",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "artifacts": {
        name: "Artifacts",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "arto_and_the_seven_deadly_spins_megaways": {
        name: "Arto and the Seven Deadly Spins MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "asgard": {
        name: "Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "asgard_warriors": {
        name: "Asgard Warriors",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "asgardian_rising": {
        name: "Asgardian Rising",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "asgardian_stones": {
        name: "Asgardian Stones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "asia_wins": {
        name: "Asia Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "astro_luck": {
        name: "Astro Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "astro_newts_megaways": {
        name: "Astro Newts Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "astropop": {
        name: "AstroPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "aswang_attack": {
        name: "Aswang Attack",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "athena_ascending": {
        name: "Athena Ascending",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "atlantic_wilds": {
        name: "Atlantic Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "atlantis": {
        name: "Atlantis",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "atlantis_crush": {
        name: "Atlantis Crush",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "atlantis_megaways": {
        name: "Atlantis Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "atomic_kittens": {
        name: "Atomic Kittens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "atomic_monkey": {
        name: "Atomic Monkey",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "attila_the_hun": {
        name: "Attila The Hun",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "aura_god": {
        name: "Aura God",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "aura_of_jupiter": {
        name: "Aura of Jupiter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "aura_of_jupiter_ccs": {
        name: "Aura of Jupiter CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "aurora": {
        name: "Aurora",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "aussies_vs_emus": {
        name: "Aussies vs Emus",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "auto_mega_roulette": {
        name: "Auto Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "auto_roulette": {
        name: "Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "autoroulette": {
        name: "Auto-Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "avalanche_rainblox": {
        name: "Avalanche Rainblox",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "avalon_the_lost_kingdom": {
        name: "Avalon: The Lost Kingdom",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "avia_rush": {
        name: "Avia Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "aviamasters": {
        name: "Aviamasters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviamasters_2": {
        name: "Aviamasters 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviamasters_xmas": {
        name: "Aviamasters Xmas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviashow": {
        name: "Aviashow",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "aviatrix_fruits": {
        name: "Aviatrix Fruits",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix_mines": {
        name: "Aviatrix Mines",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "awesome_penguin": {
        name: "Awesome Penguin",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "aztec_blaze": {
        name: "Aztec Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_bonanza": {
        name: "Aztec Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_clusters": {
        name: "Aztec Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_fire": {
        name: "Aztec Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "aztec_fire_2": {
        name: "Aztec Fire 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "aztec_gems": {
        name: "Aztec Gems",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_gems_deluxe": {
        name: "Aztec Gems Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_gems_megaways": {
        name: "Aztec Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_gigablox": {
        name: "Aztec Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "aztec_idols": {
        name: "Aztec Idols",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "aztec_king": {
        name: "Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_king_megaways": {
        name: "Aztec King MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_magic_bonanza": {
        name: "Aztec Magic Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_magic_deluxe": {
        name: "Aztec Magic Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_magic_megaways": {
        name: "Aztec Magic Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_powernudge": {
        name: "Aztec Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_priestess": {
        name: "Aztec Priestess",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "aztec_prosperity": {
        name: "Aztec Prosperity",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "aztec_smash": {
        name: "Aztec Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_sun": {
        name: "Aztec Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "aztec_treasure": {
        name: "Aztec Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_treasure_hunt": {
        name: "Aztec Treasure Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_warrior_princess": {
        name: "Aztec Warrior Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "aztec_wilds_megaways": {
        name: "Aztec Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "aztecs_claw_wild_dice": {
        name: "Aztec's Claw Wild Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztecx": {
        name: "Aztec-X",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "azticons_chaos_clusters": {
        name: "Azticons Chaos Clusters",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "aztlans_gold": {
        name: "Aztlan's Gold",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "baba_yaga": {
        name: "Baba Yaga",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "babylon_riches": {
        name: "Babylon Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "baccarat": {
        name: "Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "baccarat_777": {
        name: "Baccarat 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "baccarat_classic": {
        name: "Baccarat Classic",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "baccarat_deluxe": {
        name: "Baccarat Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "baccarat_lobby": {
        name: "Baccarat Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "baccarat_private": {
        name: "Baccarat Private",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "baccarat_supersix": {
        name: "Baccarat SuperSix",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "baccarat_zero_commission": {
        name: "Baccarat Zero Commission",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "back_to_70s": {
        name: "Back to 70's",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "back_to_the_fruits": {
        name: "Back to the Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "back_to_the_fruits_respins_of_amunre": {
        name: "Back to the Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "backyard_grill": {
        name: "Backyard Grill!",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bacon_banker": {
        name: "Bacon Banker",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "bacon_bankroll": {
        name: "Bacon Bankroll",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bad_babushkas": {
        name: "Bad Babushkas",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "bad_bass": {
        name: "Bad Bass",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_bass_cash_haul": {
        name: "Bad Bass Cash Haul",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_bass_cash_towers": {
        name: "Bad Bass Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_santa": {
        name: "Bad Santa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "badge_blitz": {
        name: "Badge Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bait_n_bank": {
        name: "Bait n Bank",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "bakers_treat": {
        name: "Baker's Treat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bakery_bonanza": {
        name: "Bakery Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "baking_bonanza": {
        name: "Baking Bonanza",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "bali_dragon": {
        name: "Bali Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bali_vacation": {
        name: "Bali Vacation",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "balloon_mania": {
        name: "Balloon Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "balloons": {
        name: "Balloons",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bamboo_ways": {
        name: "Bamboo Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "bamboo_wilds": {
        name: "Bamboo Wilds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "banana_rock": {
        name: "Banana Rock",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "banana_rush": {
        name: "Banana Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "banana_split": {
        name: "Banana Split",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "banana_town": {
        name: "Banana Town",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "banana_twist": {
        name: "Banana Twist",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bananaz_10k_ways": {
        name: "Bananaz 10k Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "bandit_bust": {
        name: "Bandit Bust",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bandit_bust_bonus_buy": {
        name: "Bandit Bust Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bandit_megaways": {
        name: "Bandit Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bang_bang": {
        name: "Bang Bang",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bang_bang_reloaded": {
        name: "Bang Bang Reloaded",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bangla_beauty": {
        name: "Bangla Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bank_of_blarney_tophit": {
        name: "Bank of Blarney TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "bank_run": {
        name: "Bank Run",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "bank_wagon_heist": {
        name: "Bank Wagon Heist",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "bankers_and_cash": {
        name: "Bankers & Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bankin_bacon": {
        name: "Bankin' Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bankin_more_bacon": {
        name: "Bankin' More Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "banquet_of_dead": {
        name: "Banquet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bao_boon_chin": {
        name: "Bao boon chin",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bao_shi": {
        name: "Bao Shi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bar_x_colossal": {
        name: "Bar X Colossal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "bar_x_xl": {
        name: "Bar X XL",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "barbarian_gold": {
        name: "Barbarian Gold",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "barbarossa": {
        name: "Barbarossa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "barbarossa_dragon_empire": {
        name: "Barbarossa Dragon Empire",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "barbarossa_revenge": {
        name: "Barbarossa Revenge",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "barn_busters": {
        name: "Barn Busters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "barn_festival": {
        name: "Barn Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "barnstormer_bucks": {
        name: "Barnstormer Bucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "barnyard_megahays_megaways": {
        name: "Barnyard Megahays Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "baron_lord_of_saturday": {
        name: "Baron Lord of Saturday",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bars_and_7s": {
        name: "BARs and 7s",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "barx_safecracker_megaways": {
        name: "Bar-X Safecracker Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bash_bros": {
        name: "Bash Bros",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "basket_bounty": {
        name: "Basket Bounty",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "basketball": {
        name: "Basketball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "battle_dwarf": {
        name: "Battle Dwarf",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_dwarf_2": {
        name: "Battle Dwarf 2",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_dwarf_xmas": {
        name: "Battle Dwarf Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_for_the_throne": {
        name: "Battle for the throne",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "battle_maidens_cleopatra": {
        name: "Battle Maidens: Cleopatra",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "battle_maidens_cleopatra_no_buy_feature": {
        name: "Battle Maidens Cleopatra (No buy feature)",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "battle_rooster": {
        name: "Battle Rooster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "battle_roosters": {
        name: "Battle Roosters",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "battle_roosters_bonus_buy": {
        name: "Battle Roosters Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "battle_royal": {
        name: "Battle Royal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "battle_tanks": {
        name: "Battle Tanks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "battleground_royale": {
        name: "Battleground Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "bball_blitz": {
        name: "B-Ball Blitz",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "beach_invaders": {
        name: "Beach Invaders",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "beach_party": {
        name: "Beach Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "beach_party_hot": {
        name: "Beach Party Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "beach_penalties": {
        name: "Beach Penalties",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "beanstalk_grows_wild": {
        name: "Beanstalk Grows Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "beanstalk_magic_treasures": {
        name: "Beanstalk Magic Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bear_crazy": {
        name: "Bear Crazy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beast_band": {
        name: "Beast Band",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "beast_coinz": {
        name: "Beast Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "beast_gains": {
        name: "Beast Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "beast_mode": {
        name: "Beast Mode",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "beastie_bux": {
        name: "Beastie Bux",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "beastly_burglars": {
        name: "Beastly Burglars",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "beasts_of_fire": {
        name: "Beasts of Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "beasts_of_fire_maximum": {
        name: "Beasts of Fire Maximum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "beat_box": {
        name: "Beat Box",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "beautiful_nature": {
        name: "Beautiful Nature",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "beauty_fruity": {
        name: "Beauty Fruity",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "bee_hive_bonanza": {
        name: "Bee Hive Bonanza",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "bee_keeper": {
        name: "Bee Keeper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beer_bonanza": {
        name: "Beer Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "beer_boost": {
        name: "Beer Boost",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "beer_party": {
        name: "Beer Party",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "before_time_runs_out": {
        name: "Before Time Runs Out",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "behind_bars_master_plan": {
        name: "Behind Bars: Master Plan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "belfry_bliss": {
        name: "Belfry Bliss",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "belfry_bliss_hold_and_win": {
        name: "Belfry Bliss Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bell_wizard": {
        name: "Bell Wizard",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "belle_the_blade_hunter": {
        name: "Belle the Blade Hunter",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "benny_the_beer": {
        name: "Benny the Beer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bermuda_riches": {
        name: "Bermuda Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "berry_burst_max": {
        name: "Berry burst MAX",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "berryburst": {
        name: "Berryburst",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "berserkin_buffalo_power_hit": {
        name: "Berserkin Buffalo Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bet_behind_pro_blackjack": {
        name: "Bet Behind Pro Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "better_barn_house_bonanza": {
        name: "Better Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beware_the_deep_megaways": {
        name: "Beware The Deep Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beyond_dice": {
        name: "Beyond Dice",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "bhanumatis_magic_box": {
        name: "Bhanumatis Magic Box",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "big_apple_wins": {
        name: "Big Apple Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "big_atlantis_frenzy": {
        name: "Big Atlantis Frenzy",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "big_bad_wolf": {
        name: "Big Bad Wolf",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_christmas_special": {
        name: "Big Bad Wolf Christmas Special",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_megaways": {
        name: "Big Bad Wolf Megaways",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_pigs_of_steel": {
        name: "Big Bad Wolf Pigs of Steel",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bam_book": {
        name: "Big Bam Book",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "big_bamboo": {
        name: "Big Bamboo",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "big_bamboo_2": {
        name: "Big Bamboo 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "big_bang_boom": {
        name: "Big Bang Boom",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "big_bass_amazon_xtreme": {
        name: "Big Bass Amazon Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza": {
        name: "Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_1000": {
        name: "Big Bass Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_3_reeler": {
        name: "Big Bass Bonanza 3 Reeler",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_jackpot_play": {
        name: "Big Bass Bonanza Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_keeping_it_reel": {
        name: "Big Bass Bonanza Keeping it Reel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_megaways": {
        name: "Big Bass Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_reel_action": {
        name: "Big Bass Bonanza Reel Action",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_boxing_bonus_round": {
        name: "Big Bass Boxing Bonus Round",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_christmas_bash": {
        name: "Big Bass Christmas Bash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_christmas_frozen_lake": {
        name: "Big Bass Christmas Frozen Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_crash": {
        name: "BIg Bass Crash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_day_at_the_races": {
        name: "Big Bass Day At The Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_floats_my_boat": {
        name: "Big Bass Floats My Boat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_football_bonanza": {
        name: "Big Bass Football Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween": {
        name: "Big Bass Halloween",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween_2": {
        name: "Big Bass Halloween 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween_3": {
        name: "Big Bass Halloween 3",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_hold_and_spinner": {
        name: "Big Bass Hold and Spinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_hold_and_spinner_megaways": {
        name: "Big Bass Hold and Spinner Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_mission_fishin": {
        name: "Big Bass Mission Fishin'",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_raceday_repeat": {
        name: "Big Bass Raceday Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_reel_repeat": {
        name: "Big Bass Reel Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_return_to_the_races": {
        name: "Big Bass Return to the Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_secrets_of_the_golden_lake": {
        name: "Big Bass Secrets of the Golden Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_splash": {
        name: "Big Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_splash_1000": {
        name: "Big Bass Splash 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_splash_jackpot_play": {
        name: "Big Bass Splash Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_trophy_catch": {
        name: "Big Bass Trophy Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_vegas_double_down_deluxe": {
        name: "Big Bass Vegas Double Down Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_xmas_xtreme": {
        name: "Big Bass Xmas Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bite": {
        name: "Big Bite",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "big_bite_push_ways": {
        name: "Big Bite Push Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "big_boat_big_catch": {
        name: "Big Boat Big Catch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "big_bot_crew": {
        name: "Big Bot Crew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bounty_bandits_3_pots": {
        name: "Big Bounty Bandits: 3 Pots",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "big_bucks_bandits_megaways": {
        name: "Big Bucks Bandits Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "big_bucks_bison_10k_ways": {
        name: "Big Bucks Bison 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "big_bucks_buffalo_gigablox": {
        name: "Big Bucks Buffalo Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "big_buffalo_bonanza": {
        name: "Big Buffalo Bonanza",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "big_burger_load_it_up_with_xtra_cheese": {
        name: "Big Burger Load it up with Xtra cheese",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_cat_gold": {
        name: "Big Cat Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_bass_fishing_megaways": {
        name: "Big Catch Bass Fishing Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_craze": {
        name: "Big Catch Craze",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "big_catch_even_bigger_bass": {
        name: "Big Catch Even Bigger Bass",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_even_bigger_bass_2": {
        name: "Big Catch Even Bigger Bass 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_even_bigger_bass_3_megaways": {
        name: "Big Catch Even Bigger Bass 3 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_game": {
        name: "Big Catch Game",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "big_catch_xmas": {
        name: "Big Catch Xmas",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "big_cats_of_india": {
        name: "Big Cats of India",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "big_fishin_bounty": {
        name: "Big Fishin' Bounty",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "big_game_fishing_christmas_catch": {
        name: "Big Game Fishing Christmas Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "big_game_fishing_golden_catch": {
        name: "Big Game Fishing Golden Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "big_game_fishing_rapid_riches": {
        name: "Big Game Fishing Rapid Riches",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "big_game_fishing_tophit": {
        name: "Big Game Fishing TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "big_heist": {
        name: "Big Heist",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "big_hitter": {
        name: "Big Hitter",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "big_juan": {
        name: "Big Juan",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_money_frenzy_cash_gains": {
        name: "Big Money Frenzy Cash Gains",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_money_megaways": {
        name: "Big Money Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_money_wheel": {
        name: "Big Money Wheel",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "big_pot_gaming_table_lobby": {
        name: "Big Pot Gaming Table Lobby",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "big_river_fishing": {
        name: "Big River Fishing",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "big_roar": {
        name: "Big Roar",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "big_sevens_jackpot": {
        name: "Big Sevens Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "big_small": {
        name: "Big Small",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "big_small_baccarat": {
        name: "Big Small Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "big_small_casino_royale": {
        name: "Big Small Casino Royale",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "big_stack_lumberjack": {
        name: "Big Stack Lumberjack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "big_stack_nutcrack": {
        name: "Big Stack Nutcrack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "big_top_terror": {
        name: "Big Top Terror",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "big_win_777": {
        name: "Big Win 777",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "big_win_cat": {
        name: "Big Win Cat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "big_win_city_pawsperity": {
        name: "Big Win City Pawsperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bigbang_spin": {
        name: "BigBang Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigger_barn_house_bonanza": {
        name: "Bigger Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_blizzard_christmas_catch": {
        name: "Bigger Bass Blizzard Christmas Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_bonanza": {
        name: "Bigger Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_splash": {
        name: "Bigger Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_catch_bass_fishing": {
        name: "Bigger Catch Bass Fishing",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "biggy_winnie_feat_the_rich_one": {
        name: "Biggy Winnie feat The Rich One",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "bikini_island": {
        name: "Bikini Island",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bikini_island_deluxe": {
        name: "Bikini Island Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bikini_paradise": {
        name: "Bikini Paradise",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "bikini_queen_dating": {
        name: "Bikini Queen Dating",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bikini_queens": {
        name: "Bikini Queens",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bikini_queens_live": {
        name: "Bikini Queens Live",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bikini_queens_making_waves": {
        name: "Bikini Queens Making Waves",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bikini_queens_xmas": {
        name: "Bikini Queens Xmas",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bill_and_coin": {
        name: "Bill & Coin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bill_and_coin_2": {
        name: "Bill and Coin 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "billionaire_bison": {
        name: "Billionaire Bison",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "billionaire_buffalo": {
        name: "Billionaire Buffalo",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "billionaire_rhino": {
        name: "Billionaire Rhino",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "billionaire_wolf": {
        name: "Billionaire Wolf",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "bills_buck_bonanza": {
        name: "Bill's Buck Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "billy_west_wild_hunt_94": {
        name: "Billy West Wild Hunt 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "bingo": {
        name: "Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "bingo_75": {
        name: "Bingo 75",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "bingo_adventure": {
        name: "Bingo Adventure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bingo_carnaval": {
        name: "Bingo Carnaval",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bingo_fun": {
        name: "Bingo Fun",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bingo_lobby": {
        name: "Bingo Lobby",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bingo_mania": {
        name: "Bingo Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bingo_star": {
        name: "Bingo Star",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "bird_of_thunder": {
        name: "Bird of Thunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bison_battle": {
        name: "Bison Battle",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "bison_bonanza": {
        name: "Bison Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_rising_gold_strike": {
        name: "Bison Rising Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_rising_megaways": {
        name: "Bison Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_rising_reloaded_megaways": {
        name: "Bison Rising Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_vs_buffalo": {
        name: "Bison vs Buffalo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "bison_wilds_doublemax": {
        name: "Bison Wilds Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "blacjkack": {
        name: "Blacjkack",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "black_beauty": {
        name: "Black Beauty",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "black_bull": {
        name: "Black Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "black_friday_cart_craze": {
        name: "Black Friday Cart Craze",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "black_hawk": {
        name: "Black Hawk",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_hawk_deluxe": {
        name: "Black Hawk Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_horse": {
        name: "Black Horse",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_horse_deluxe": {
        name: "Black Horse Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_mamba": {
        name: "Black Mamba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "black_mummy": {
        name: "Black Mummy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "black_wolf": {
        name: "Black Wolf",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "black_wolf_2": {
        name: "Black Wolf 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "blackbeards_bounty": {
        name: "Blackbeard's Bounty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "blackbeards_quest": {
        name: "Blackbeard's Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "blackjack": {
        name: "BlackJack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "blackjack_3_hand": {
        name: "Blackjack 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "blackjack_6_decks": {
        name: "Blackjack 6 Decks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "blackjack_azure": {
        name: "Blackjack - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_bonus": {
        name: "Blackjack Bonus",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "blackjack_classic": {
        name: "Blackjack Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "blackjack_emerald": {
        name: "Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_lobby": {
        name: "Blackjack Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_lucky_7s_xmas": {
        name: "Blackjack Lucky 7s Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "blackjack_lucky_ladies": {
        name: "Blackjack Lucky Ladies",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "blackjack_lucky_sevens": {
        name: "BlackJack: Lucky Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "blackjack_multi_hand": {
        name: "Blackjack Multi Hand",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "blackjack_neo": {
        name: "Blackjack Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "blackjack_ruby": {
        name: "Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_the_club": {
        name: "Blackjack - The Club",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_x_azure": {
        name: "Blackjack X Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_x_ruby": {
        name: "Blackjack X Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjackx": {
        name: "BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blade_and_fangs": {
        name: "Blade & Fangs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blaze_of_ra": {
        name: "Blaze of Ra",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "blazin_bonus": {
        name: "Blazin' Bonus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "blazin_bullfrog": {
        name: "Blazin' Bullfrog",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "blazing_777": {
        name: "Blazing 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "blazing_cash": {
        name: "Blazing Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blazing_fire_balls_spin_win": {
        name: "Blazing Fire Balls Spin Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "blazing_fire_pots_hold_and_spin": {
        name: "Blazing Fire Pots Hold and Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "blazing_fruit_7s": {
        name: "Blazing Fruit 7s",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "blazing_wilds_megaways": {
        name: "Blazing Wilds Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blazn_buffalo": {
        name: "Blazn Buffalo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "blazn_buffalo_super_reels": {
        name: "Blazn Buffalo Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "blender_blitz": {
        name: "Blender Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "blessed_flame": {
        name: "Blessed Flame",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "blessings_of_caishen": {
        name: "Blessings of Caishen",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "bling_blitz_diamond_drop": {
        name: "Bling Blitz Diamond Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "blinged": {
        name: "Blinged",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "blirix_workshop": {
        name: "Blirix workshop",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "blitz_of_olympus": {
        name: "Blitz of Olympus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "blitz_super_wheel": {
        name: "Blitz Super Wheel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blockchain_megaways": {
        name: "Blockchain Megaways",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "blocks": {
        name: "Blocks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "blood_club": {
        name: "Blood Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "blood_moon": {
        name: "Blood Moon",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "blood_moon_hold_and_win": {
        name: "Blood Moon Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "blood_queen_scratch": {
        name: "Blood Queen Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "blood_rage": {
        name: "Blood Rage",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "blood_suckers": {
        name: "Blood Suckers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "blood_suckers_ii": {
        name: "Blood Suckers II",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "bloodaxe": {
        name: "Bloodaxe",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "bloody_brilliant": {
        name: "Bloody Brilliant",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bloody_dawn": {
        name: "Bloody Dawn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blue_fortune": {
        name: "Blue Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "boat_bonanza": {
        name: "Boat Bonanza",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_christmas": {
        name: "Boat Bonanza Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_colossal_catch": {
        name: "Boat Bonanza Colossal Catch",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_croconile": {
        name: "Boat Bonanza Croconile",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_down_under": {
        name: "Boat Bonanza Down Under",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bobs_coffee_shop": {
        name: "Bob's Coffee Shop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bomb_bonanza": {
        name: "Bomb Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bomb_runner": {
        name: "Bomb Runner",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bomb_squad": {
        name: "Bomb Squad",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bombing_fishing": {
        name: "Bombing Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bombs_away": {
        name: "Bombs Away",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonanza_billion": {
        name: "Bonanza Billion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bonanza_billion_xtreme": {
        name: "Bonanza Billion Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bonanza_coins": {
        name: "Bonanza Coins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bonanza_gold": {
        name: "Bonanza Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bonanza_trillion": {
        name: "Bonanza Trillion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bonanza_wheel": {
        name: "Bonanza Wheel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bone_bonanza": {
        name: "Bone Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bone_fortune": {
        name: "Bone Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bone_raiders": {
        name: "Bone Raiders",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bonsai_dragon_blitz": {
        name: "Bonsai Dragon Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bonsai_spins": {
        name: "Bonsai Spins",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "bonus_deuces_wild_1_hand": {
        name: "Bonus Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_deuces_wild_10_hand": {
        name: "Bonus Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_deuces_wild_100_hand": {
        name: "Bonus Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_deuces_wild_5_hand": {
        name: "Bonus Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_deuces_wild_50_hand": {
        name: "Bonus Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_hunter": {
        name: "Bonus Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bonus_poker_1_hand": {
        name: "Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_poker_10_hand": {
        name: "Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_poker_100_hand": {
        name: "Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_poker_5_hand": {
        name: "Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonus_poker_50_hand": {
        name: "Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonza_bucks_hold_and_win_extreme_10000": {
        name: "Bonza Bucks Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boogie_boom": {
        name: "Boogie Boom",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "book_hotfire": {
        name: "Book HOTFIRE",
        provider: "Solvited",
        providerSlug: "solvited"
    },
    "book_of": {
        name: "Book of",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "book_of_ages": {
        name: "Book of Ages",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_alexandria": {
        name: "Book of Alexandria",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "book_of_aztec_king": {
        name: "Book of Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_baal": {
        name: "Book Of Ba'al",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "book_of_blackeyes_bounty": {
        name: "Book of Blackeye's Bounty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "book_of_blarney_gigablox": {
        name: "Book of Blarney Gigablox",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "book_of_books": {
        name: "Book of Books",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "book_of_buffalo": {
        name: "Book of Buffalo",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "book_of_cats": {
        name: "Book of Cats",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_cats_megaways": {
        name: "Book of Cats Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_cleo": {
        name: "Book of Cleo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_crazy_chicken_gdn": {
        name: "Book of Crazy Chicken GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_crystal_fruits": {
        name: "Book of Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_darius": {
        name: "Book of Darius",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_dead": {
        name: "Book of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "book_of_dead_go_collect": {
        name: "Book of Dead Go Collect",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "book_of_destiny": {
        name: "Book of Destiny",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "book_of_duat": {
        name: "Book of Duat",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "book_of_elements": {
        name: "Book of Elements",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_eskimo": {
        name: "Book of Eskimo",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "book_of_eternity_94": {
        name: "Book of Eternity 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "book_of_faith": {
        name: "Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "book_of_fallen": {
        name: "Book of Fallen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_gold": {
        name: "Book of Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "book_of_golden_sands": {
        name: "Book of Golden Sands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_juno": {
        name: "Book of Juno",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_kemet": {
        name: "Book of Kemet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_keno": {
        name: "Book of Keno",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "book_of_kingdoms": {
        name: "Book of Kingdoms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_love": {
        name: "Book of Love",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "book_of_madness": {
        name: "Book of Madness",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_2": {
        name: "Book of Madness 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_deluxe": {
        name: "Book Of Madness Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_flaming_link": {
        name: "Book of Madness Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_respins_of_amunre": {
        name: "Book of Madness Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_monsters": {
        name: "Book of Monsters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_oasis": {
        name: "Book of Oasis",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_panda_megaways": {
        name: "Book of Panda Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_pharaoh": {
        name: "Book of Pharaoh",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "book_of_pharaoh_777jackpot": {
        name: "Book of Pharaoh 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "book_of_power": {
        name: "Book of Power",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "book_of_pyramids": {
        name: "Book of Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_rest": {
        name: "Book of Rest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "book_of_romeo_and_julia": {
        name: "Book of Romeo and Julia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_romeo_and_julia_gdn": {
        name: "Book of Romeo and Julia GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_slingo": {
        name: "Book Of Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "book_of_spells": {
        name: "Book Of Spells",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_sun": {
        name: "Book of Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "book_of_sun_multichance": {
        name: "Book of Sun: Multichance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "book_of_the_fallen": {
        name: "Book of the Fallen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_the_priestess": {
        name: "Book of the Priestess",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "book_of_the_priestess_bonus_buy": {
        name: "Book of the Priestess Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "book_of_time": {
        name: "Book of Time",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "book_of_tombs": {
        name: "Book of Tombs",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "book_of_tut": {
        name: "Book of Tut",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_tut_respin": {
        name: "Book of Tut Respin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_vampires": {
        name: "Book of Vampires",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_wizard_crystal_chance": {
        name: "Book of Wizard: Crystal Chance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "book_of_wizardry": {
        name: "Book of Wizardry",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "book_of_yuletide": {
        name: "Book of Yuletide",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "books_and_bounties": {
        name: "Books & Bounties",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_bulls": {
        name: "Books and Bulls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_bulls_gdn": {
        name: "Books and Bulls GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_bulls_rhfp": {
        name: "Books and Bulls RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_pearls": {
        name: "Books and Pearls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_pearls_respins_of_amunre": {
        name: "Books and Pearls Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_temples": {
        name: "Books and Temples",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "boom_city": {
        name: "Boom City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "boom_farm": {
        name: "Boom Farm",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "boom_legend": {
        name: "Boom Legend",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "boom_time": {
        name: "Boom Time",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "booming_buffalo_hold_and_win_extreme_25000": {
        name: "Booming Buffalo Hold and Win Extreme 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booming_gold": {
        name: "Booming Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booming_seven_deluxe": {
        name: "Booming Seven Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booming_seven_deluxe_legacy": {
        name: "Booming Seven Deluxe Legacy",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booze_bash": {
        name: "Booze Bash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "boracay_beauties": {
        name: "Boracay Beauties",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "born_wild": {
        name: "Born Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "boss_bear": {
        name: "Boss Bear",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "boss_the_lotto": {
        name: "Boss The Lotto",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "bouncy_bombs": {
        name: "Bouncy Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bounty_county": {
        name: "Bounty County",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bounty_gold": {
        name: "Bounty Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bounty_hunter": {
        name: "Bounty Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bounty_hunter_unchained": {
        name: "Bounty Hunter Unchained",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bounty_hunters": {
        name: "Bounty Hunters",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "bounty_pop": {
        name: "Bounty Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "bounty_showdown": {
        name: "Bounty Showdown",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "bow_of_artemis": {
        name: "Bow of Artemis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "boxes": {
        name: "Boxes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "boxing_extravaganza": {
        name: "Boxing Extravaganza",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "boxing_king": {
        name: "Boxing King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "boxing_king_title_match": {
        name: "Boxing King Title Match",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "brain_busters_reel_bingo": {
        name: "Brain Busters Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "branded_book_of": {
        name: "Branded Book Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "branded_coin_vault": {
        name: "Branded Coin Vault",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "branded_megaways": {
        name: "Branded Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "brawlers_bar_cash_collect": {
        name: "Brawlers Bar Cash Collect",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "brawlers_brew": {
        name: "Brawlers Brew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "brazilian_baccarat": {
        name: "Brazilian Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "brazilian_mega_roulette": {
        name: "Brazilian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "brazilian_one_blackjack": {
        name: "Brazilian One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "brazilian_roulette": {
        name: "Brazilian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "brazilian_turbo_baccarat": {
        name: "Brazilian Turbo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "break_bones": {
        name: "Break Bones",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "break_the_ice": {
        name: "Break the Ice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "brew_brothers": {
        name: "Brew Brothers",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "brew_brothers_xmas_brew": {
        name: "Brew Brothers Xmas Brew",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "brick_house_bonanza": {
        name: "Brick House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bronco_spirit": {
        name: "Bronco Spirit",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "brooklyn_bootleggers": {
        name: "Brooklyn Bootleggers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "bruce_bumerang": {
        name: "Bruce Bumerang",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "brutal_santa": {
        name: "Brutal Santa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bubble_beauty": {
        name: "Bubble Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "bubble_pop": {
        name: "Bubble Pop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bubblegum_and_robo": {
        name: "Bubblegum and Robo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "bubblin_riches": {
        name: "Bubblin Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bucks_and_doe_10k_ways": {
        name: "Bucks and Doe 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "buckshot_wilds": {
        name: "Buckshot Wilds",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "budai_reels": {
        name: "Budai Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "budai_reels_bonus_buy": {
        name: "Budai Reels Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "buddha_megaways": {
        name: "Buddha Megaways",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "buffalo_begins": {
        name: "Buffalo Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "buffalo_blow": {
        name: "Buffalo Blow",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "buffalo_blox_gigablox": {
        name: "Buffalo Blox Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "buffalo_hold_and_win": {
        name: "Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_hold_and_win_extreme": {
        name: "Buffalo Hold and Win Extreme",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_hold_and_win_extreme_10000": {
        name: "Buffalo Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_hold_and_win_extreme_10000_live": {
        name: "Buffalo Hold and Win Extreme 10,000 Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_king": {
        name: "Buffalo King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_king_megaways": {
        name: "Buffalo King MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_king_untamed_megaways": {
        name: "Buffalo King Untamed Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_of_wealth": {
        name: "Buffalo of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buffalo_stack_n_sync": {
        name: "Buffalo Stack 'n Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "buffalo_stacknsync": {
        name: "Buffalo Stack'n'Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "buffalo_win": {
        name: "Buffalo Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "buggy_bonus": {
        name: "Buggy Bonus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bugs_money": {
        name: "Bugs Money",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "buildin_bucks": {
        name: "Buildin Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buildin_even_more_bucks": {
        name: "Buildin' Even More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buildin_more_bucks": {
        name: "Buildin More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bull_fafa": {
        name: "Bull FaFa",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "bull_fiesta": {
        name: "Bull Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bull_in_a_china_shop": {
        name: "Bull in a China Shop",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bull_in_a_rodeo": {
        name: "Bull in a Rodeo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bullets_and_bounty": {
        name: "Bullets and Bounty",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bullion_blitz_power_play": {
        name: "Bullion Blitz Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bullion_express": {
        name: "Bullion Express",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bulls_club": {
        name: "Bull's Club",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "bumba_meu_boi_coin": {
        name: "Bumba Meu Boi Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "bunny_heist": {
        name: "Bunny Heist",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "burn_in_hell": {
        name: "Burn in Hell",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "burn_in_love": {
        name: "Burn in Love",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "burning_chilli_243": {
        name: "Burning Chilli 243",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "burning_chilli_x": {
        name: "Burning Chilli X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "burning_classic_2": {
        name: "Burning Classic 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics": {
        name: "Burning Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics_5000": {
        name: "Burning Classics 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics_go_wild": {
        name: "Burning Classics go Wild",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics_royal_edition": {
        name: "Burning Classics Royal Edition",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_love": {
        name: "Burning Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_reels": {
        name: "Burning Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_riot": {
        name: "Burning RIot",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "burning_stars": {
        name: "Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_stars_3": {
        name: "Burning Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_sun": {
        name: "Burning Sun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_sun_extremely_light": {
        name: "Burning Sun Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "buster_hammer_carnival": {
        name: "Buster Hammer Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "busters_bones": {
        name: "Buster's Bones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "busy_bees": {
        name: "Busy Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "butterfly_blossom": {
        name: "Butterfly Blossom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "butterfly_lovers": {
        name: "Butterfly Lovers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "butterfly_staxx": {
        name: "Butterfly Staxx",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "butterfly_staxx_2": {
        name: "Butterfly Staxx 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "cabin_crashers": {
        name: "Cabin Crashers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "caichen_triple_blossom": {
        name: "Caichen Triple Blossom",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "caishen_wins": {
        name: "Caishen Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "caishens_cash": {
        name: "Caishen's Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "caishens_cash_pots": {
        name: "Caishen's Cash Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "caishens_coins": {
        name: "Caishen’s Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "caishens_gold": {
        name: "Caishen's Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cake_valley": {
        name: "Cake Valley",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "calaca_bingo": {
        name: "Calaca Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "calavera_bingo": {
        name: "Calavera Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "calaveras_explosivas": {
        name: "Calaveras Explosivas",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "camelot_cash": {
        name: "Camelot Cash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "camino_de_chili": {
        name: "Camino de Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "camino_de_chili_bonus_buy": {
        name: "Camino de Chili Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_baby": {
        name: "Candy Baby",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "candy_blast": {
        name: "Candy Blast",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "candy_blitz": {
        name: "Candy Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_blitz_bombs": {
        name: "Candy Blitz Bombs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_bonanza": {
        name: "Candy Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "candy_burst": {
        name: "Candy Burst",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "candy_coinz": {
        name: "Candy Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "candy_corner": {
        name: "Candy Corner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_craze": {
        name: "Candy Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_crazed_pandas_double_max": {
        name: "Candy Crazed Pandas Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "candy_dreams": {
        name: "Candy Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_dreams_bingo": {
        name: "Candy Dreams: Bingo",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_dreams_sweet_planet": {
        name: "Candy Dreams: Sweet Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_dreams_sweet_planet_bonus_buy": {
        name: "Candy Dreams: Sweet Planet. Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "candy_glyph": {
        name: "Candy Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "candy_island_princess": {
        name: "Candy Island Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "candy_jar_cluster": {
        name: "Candy Jar Cluster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_jar_clusters": {
        name: "Candy Jar Clusters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_monsta": {
        name: "Candy Monsta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "candy_rocket": {
        name: "Candy Rocket",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "candy_rush": {
        name: "Candy Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_stars": {
        name: "Candy Stars",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_storm_rainbow_rush": {
        name: "Candy Storm Rainbow Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "candy_tower": {
        name: "Candy Tower",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "candy_treasures": {
        name: "Candy Treasures",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "candy_treasures_3_reels": {
        name: "Candy Treasures 3 Reels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "candy_treasures_cash_towers": {
        name: "Candy Treasures Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "candy_village": {
        name: "Candy Village",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candycash": {
        name: "CandyCash",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "candyland_bingo": {
        name: "Candyland Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "canine_carnage": {
        name: "Canine Carnage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "canyon_riches": {
        name: "Canyon Riches",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "captain_glum_pirate_hunter": {
        name: "Captain Glum: Pirate Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "captain_kraken_megaways": {
        name: "Captain Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "captain_moregain": {
        name: "Captain More'gain",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "captain_shark": {
        name: "Captain Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "captain_xenos_earth_adventure": {
        name: "Captain Xeno's Earth Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "captains_bounty": {
        name: "Captain's Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "captains_curse": {
        name: "Captain's Curse",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "capymania_green": {
        name: "Capymania Green",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "capymania_orange": {
        name: "Capymania Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "capymania_yellow": {
        name: "Capymania Yellow",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "caramelo_dog_lucky_run": {
        name: "Caramelo Dog Lucky Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "caravan_of_riches": {
        name: "Caravan of Riches",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "caribbean_holdem": {
        name: "Caribbean Hold'em",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "caribbean_stud": {
        name: "Caribbean Stud",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "carioca_vibes": {
        name: "Carioca Vibes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "carnival_beats": {
        name: "Carnival Beats",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "carnival_bonanza": {
        name: "Carnival Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "carnival_cash": {
        name: "Carnival Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "carnival_cove": {
        name: "Carnival Cove",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "carribean_beach_poker": {
        name: "Carribean Beach Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cartel_chase": {
        name: "Cartel Chase",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "carts_of_cash": {
        name: "Carts of Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "carts_of_cash_xmas": {
        name: "Carts of Cash Xmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "cash_a_cabana": {
        name: "Cash a Cabana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_bonanza": {
        name: "Cash Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_box": {
        name: "Cash Box",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_chips": {
        name: "Cash Chips",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_compass": {
        name: "Cash Compass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_crew": {
        name: "Cash Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_cubes_trio_bonus": {
        name: "Cash Cubes Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cash_defense": {
        name: "Cash Defense",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "cash_elevator": {
        name: "Cash Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_grotto": {
        name: "Cash Grotto",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cash_in_transit": {
        name: "Cash in Transit",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "cash_mania": {
        name: "Cash Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "cash_noire": {
        name: "Cash Noire",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "cash_of_command": {
        name: "Cash of Command",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_pandas": {
        name: "Cash Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "cash_patrol": {
        name: "Cash Patrol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_pig": {
        name: "Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pig_2": {
        name: "Cash Pig 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pig_2_15000": {
        name: "Cash Pig 2 15000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pool": {
        name: "Cash Pool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_pump": {
        name: "Cash Pump",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_quest": {
        name: "Cash Quest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_reef": {
        name: "Cash Reef",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cash_scratch": {
        name: "Cash Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_show": {
        name: "Cash Show",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "cash_stack": {
        name: "Cash Stack",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "cash_strike": {
        name: "Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_hotstepper": {
        name: "Cash Strike Hotstepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_hotstepper_2": {
        name: "Cash Strike Hotstepper 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_hotstepper_megaways": {
        name: "Cash Strike Hotstepper Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_5": {
        name: "Cash Strike Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_force_5": {
        name: "Cash Strike Power Force 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_force_5_megaways": {
        name: "Cash Strike Power force 5 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_up": {
        name: "Cash Strike Power Up",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_triple_fire": {
        name: "Cash Strike Triple Fire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_win_boost": {
        name: "Cash Strike Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_xcash": {
        name: "Cash Strike X-Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_surge": {
        name: "Cash Surge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_truck": {
        name: "Cash Truck",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_2": {
        name: "Cash Truck 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_3_turbo": {
        name: "Cash Truck 3 Turbo",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_begins": {
        name: "Cash Truck Begins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_vandal": {
        name: "Cash Vandal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_vault_i": {
        name: "Cash Vault I",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_vault_ii": {
        name: "Cash Vault II",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cashin_joker": {
        name: "Cashin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cashomatic": {
        name: "Cash-o-Matic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "cashosaurus": {
        name: "Cashosaurus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cashpots_blazinator": {
        name: "Cashpots Blazinator",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "casino_barbut": {
        name: "Casino Barbut",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "casino_heist": {
        name: "Casino Heist",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "casino_heist_megaways": {
        name: "Casino Heist Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "casino_holdem": {
        name: "Casino Hold'em",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "casino_night": {
        name: "Casino Night",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "casino_patience": {
        name: "Casino Patience",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "casino_roulette": {
        name: "Casino Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "casino_scratch": {
        name: "Casino Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "casino_solitaire": {
        name: "Casino Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "castle_cash_megaways": {
        name: "Castle Cash Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "castle_of_fire": {
        name: "Castle of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cat_wilde_and_the_doom_of_dead": {
        name: "Cat Wilde and the Doom of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_incan_quest": {
        name: "Cat Wilde and the Incan Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_lost_chapter": {
        name: "Cat Wilde and the Lost Chapter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_pyramids_of_dead": {
        name: "Cat Wilde and the Pyramids of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_in_the_eclipse_of_the_sun_god": {
        name: "Cat Wilde in the Eclipse of the Sun God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "catch_a_wave": {
        name: "Catch a Wave",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "catch_the_gold_hold_and_win": {
        name: "Catch the Gold Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "catch_the_wind": {
        name: "Catch the Wind",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "catch_the_wind_bonus_buy": {
        name: "Catch the Wind Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "catdiana": {
        name: "Catdiana",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cats_and_cash": {
        name: "Cats and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cats_blessing": {
        name: "Cat's Blessing",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cats_of_olympus": {
        name: "Cats of Olympus",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "cats_soup": {
        name: "Cat's Soup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cauldron": {
        name: "Cauldron",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "caveman_bob": {
        name: "Caveman Bob",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "celestial_goddess": {
        name: "Celestial Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "chained_fighters": {
        name: "Chained Fighters",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "chambers_of_ancients": {
        name: "Chambers of Ancients",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "champions_of_mithrune": {
        name: "Champions of Mithrune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "changing_face": {
        name: "Changing Face",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "chans_treasure": {
        name: "Chan's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "chaos_crew": {
        name: "Chaos Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_crew_2": {
        name: "Chaos Crew 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_crew_3": {
        name: "Chaos Crew 3",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_crew_scratch": {
        name: "Chaos Crew Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_royale": {
        name: "Chaos Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "charge_buffalo": {
        name: "Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "charge_buffalo_ascent": {
        name: "Charge Buffalo Ascent",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "charlie_chance": {
        name: "Charlie Chance",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charlie_chance_and_the_curse_of_cleopatra": {
        name: "Charlie Chance and The Curse of Cleopatra",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charlie_chance_in_hell_to_pay": {
        name: "Charlie Chance in Hell to Pay",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charlies_angel": {
        name: "Charlies Angel",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "charming_hearts": {
        name: "Charming Hearts",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "chase_for_glory": {
        name: "Chase for Glory",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cheeky_emperor": {
        name: "Cheeky Emperor",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cheeky_fruits": {
        name: "Cheeky Fruits",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cheeky_fruits_6_deluxe": {
        name: "Cheeky Fruits 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cheeky_fruits_6_royale": {
        name: "Cheeky Fruits 6 Royale",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cheeky_fruits_split": {
        name: "Cheeky Fruits Split",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cheeky_fruits_trio_bonus": {
        name: "Cheeky Fruits Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cherry_bell": {
        name: "Cherry Bell",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "cherry_blast_scratch": {
        name: "Cherry Blast Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cherry_pop": {
        name: "Cherry Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cherry_pop_deluxe": {
        name: "Cherry Pop Deluxe",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cherrypop_burst": {
        name: "CherryPop Burst",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "chests_of_cai_shen": {
        name: "Chests of Cai Shen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chests_of_cai_shen_2": {
        name: "Chests of Cai Shen 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken": {
        name: "Chicken+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_chase": {
        name: "Chicken Chase",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_crash": {
        name: "Chicken Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "chicken_dash": {
        name: "Chicken Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "chicken_dash_1000": {
        name: "Chicken Dash 1000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "chicken_drop": {
        name: "Chicken Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_rush": {
        name: "Chicken Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "chicken_shot": {
        name: "Chicken Shot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "chicken_smash": {
        name: "Chicken Smash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "chicken_x": {
        name: "Chicken X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "chicken_x_and_friends": {
        name: "Chicken X and Friends",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "chicky_run": {
        name: "Chicky Run",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "chief_hawks_spirit_walk": {
        name: "Chief Hawks Spirit Walk",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "chili_coins": {
        name: "Chili Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "chilli_bandits": {
        name: "Chilli Bandits",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "chilli_champions_ultrahitz": {
        name: "Chilli Champions UltraHitz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "chilli_heat": {
        name: "Chilli Heat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_heat_megaways": {
        name: "Chilli Heat MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_heat_spicy_spins": {
        name: "Chilli Heat Spicy Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_picante_megaways": {
        name: "Chilli Picante Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "chin_shi_huang": {
        name: "Chin Shi Huang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "china_festival": {
        name: "China Festival",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "china_shores_slingo": {
        name: "China Shores Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "chinese_new_year": {
        name: "Chinese New Year",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "chinese_speed_baccarat": {
        name: "Chinese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "chip_spin": {
        name: "Chip Spin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "choco_reels": {
        name: "Choco Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "chocolate_deluxe": {
        name: "Chocolate Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "chocolossus": {
        name: "Chocolossus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "choi_sun_yeah_jp": {
        name: "Choi Sun Yeah JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "chomplings": {
        name: "Chomplings",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "chosen_by_the_gods": {
        name: "Chosen by the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "christmas_big_bass_bonanza": {
        name: "Christmas Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "christmas_carol_megaways": {
        name: "Christmas Carol MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "christmas_combo": {
        name: "Christmas Combo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "christmas_crash": {
        name: "Christmas Crash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "christmas_deal": {
        name: "Christmas Deal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "christmas_gift_rush": {
        name: "Christmas Gift Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "christmas_in_papertown": {
        name: "Christmas in Papertown",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "christmas_megaways": {
        name: "Christmas Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "christmas_reach": {
        name: "Christmas Reach",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "christmas_reach_bonus_buy": {
        name: "Christmas Reach Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "chronos_joker": {
        name: "Chronos Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "circle_of_life": {
        name: "Circle of Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "circle_of_sylvan": {
        name: "Circle of Sylvan",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "circus_delight": {
        name: "Circus Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "circus_jackpot": {
        name: "Circus Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "circus_joker_4096": {
        name: "Circus Joker 4096",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "city_of_sound": {
        name: "City of Sound",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clash_of_camelot": {
        name: "Clash of Camelot",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clash_of_claws": {
        name: "Clash of Claws",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "clash_of_gods_anubis_vs_hades": {
        name: "Clash of Gods Anubis vs Hades",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "clash_of_pirates": {
        name: "Clash of Pirates",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "classic_coins": {
        name: "Classic Coins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "classic_fantastic": {
        name: "Classic Fantastic",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "classic_fruits": {
        name: "Classic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "classic_multihand_blackjack": {
        name: "Classic Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "classico": {
        name: "Classico",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cleocatra": {
        name: "Cleocatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cleopatra_wilds_hold_and_win": {
        name: "Cleopatra Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "cleopatras_code": {
        name: "Cleopatra's Code",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "cleopatras_fortune": {
        name: "Cleopatra's Fortune",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cleos_fortune": {
        name: "Cleo’s Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "cloud_princess": {
        name: "Cloud Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cloud_quest": {
        name: "Cloud Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clover_bonanza": {
        name: "Clover Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "clover_coins_3x3": {
        name: "Clover Coins 3x3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "clover_coins_4x4": {
        name: "Clover Coins 4x4",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "clover_fortunes": {
        name: "Clover Fortunes",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "clover_gold": {
        name: "Clover Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "clover_lady": {
        name: "Clover Lady",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "clover_rainbow": {
        name: "Clover Rainbow",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "clover_rainbow_6_deluxe": {
        name: "Clover Rainbow 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cloverland_riches": {
        name: "Cloverland Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "club_tropicana": {
        name: "Club Tropicana",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "club_tropicana_happy_hour": {
        name: "Club Tropicana Happy Hour",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "clucking_hell": {
        name: "Clucking Hell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cluster_tumble": {
        name: "Cluster Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "cocktail_nights": {
        name: "Cocktail Nights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "coco_rush": {
        name: "Coco Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "codex_of_fortune": {
        name: "Codex of Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "coffee_wild": {
        name: "Coffee Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "coils_of_cash": {
        name: "Coils of Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "coin_blox": {
        name: "Coin Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "coin_conqueror": {
        name: "Coin Conqueror",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "coin_crusher_hold_and_win": {
        name: "Coin Crusher Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "coin_express": {
        name: "Coin Express",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_field": {
        name: "Coin Field",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "coin_flip": {
        name: "Coin Flip",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "coin_lamp": {
        name: "Coin Lamp",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_of_lightning": {
        name: "Coin of Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "coin_princess_x1000": {
        name: "Coin Princess x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_quest": {
        name: "Coin Quest",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coin_quest_2": {
        name: "Coin Quest 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coin_rush": {
        name: "Coin Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "coin_tank": {
        name: "Coin Tank",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "coin_tree": {
        name: "Coin Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "coin_up_hot_fire": {
        name: "Coin UP: Hot Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_up_lightning": {
        name: "Coin Up: Lightning",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_vault": {
        name: "Coin Vault",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "coin_volcano": {
        name: "Coin Volcano",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coin_volcano_2": {
        name: "Coin Volcano 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "coins": {
        name: "Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "coins_and_cannons": {
        name: "Coins and Cannons",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coins_of_cleo": {
        name: "Coins of Cleo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "coins_of_egypt": {
        name: "Coins of Egypt",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "coinsweeper": {
        name: "Coinsweeper",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "colin_the_cat": {
        name: "Colin The Cat",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "collapsed_castle": {
        name: "Collapsed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "collapsed_castle_bonus_buy": {
        name: "Collapsed Castle Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "color_game": {
        name: "Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "color_prediction": {
        name: "Color Prediction",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "colors": {
        name: "Colors",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "colossal_cash_zone": {
        name: "Colossal Cash Zone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "colossal_gems": {
        name: "Colossal Gems",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "colt_lightning": {
        name: "Colt Lightning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "colt_lightning_firestorm": {
        name: "Colt Lightning Firestorm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "combo_drop": {
        name: "Combo Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "congo_cash": {
        name: "Congo Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "congo_cash_xl": {
        name: "Congo Cash XL",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "conquer_babylon": {
        name: "Conquer Babylon",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "contact": {
        name: "Contact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cop_the_lot_megaways_power_play": {
        name: "Cop the Lot Megaways Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "copsnrobbers": {
        name: "Cops'n'Robbers",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cornelius": {
        name: "Cornelius",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "cornelius_milk_hunter_megaways": {
        name: "Cornelius Milk Hunter Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "corrida_romance": {
        name: "Corrida Romance",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "corrida_romance_deluxe": {
        name: "Corrida Romance Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cosmic_cash": {
        name: "Cosmic Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cosmic_clusters": {
        name: "Cosmic Clusters!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cosmic_crystals_scratch": {
        name: "Cosmic Crystals Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cosmic_jokers": {
        name: "Cosmic Jokers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cosmo_saga": {
        name: "Cosmo Saga",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "cosmonaut": {
        name: "Cosmonaut",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "cosmos_cash": {
        name: "Cosmos Cash",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "cougar_gold": {
        name: "Cougar Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "cougar_roar": {
        name: "Cougar Roar",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "count_jokula": {
        name: "Count Jokula",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "courier_sweeper": {
        name: "Courier Sweeper",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "court_of_hearts": {
        name: "Court of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cowboy_coins": {
        name: "Cowboy Coins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cowboy_showdown": {
        name: "Cowboy Showdown",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cowboys_gold": {
        name: "Cowboys Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "coyote_crash": {
        name: "Coyote Crash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "coyote_gold": {
        name: "Coyote Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "coywolf_cash": {
        name: "Coywolf Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crab_trap": {
        name: "Crab Trap",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "crabbin_for_cash_extra_big_splash": {
        name: "Crabbin For Cash Extra Big Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbin_for_cash_megaways": {
        name: "Crabbin' For Cash Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbin_for_christmas": {
        name: "Crabbin For Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbys_gold": {
        name: "Crabby's Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crabbys_gold_ii": {
        name: "Crabby's Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crack_the_bank_hold_and_win": {
        name: "Crack the Bank Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "crank_it_up": {
        name: "Crank It Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crash": {
        name: "Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "crash_bonus": {
        name: "Crash Bonus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crash_fruit": {
        name: "Crash Fruit",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crash_puck": {
        name: "Crash Puck",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crash_squad": {
        name: "Crash Squad",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "crash_squad_winter_party": {
        name: "Crash Squad Winter Party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "crash_touchdown": {
        name: "Crash Touchdown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crash_trader": {
        name: "Crash Trader",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crash_wonder_blonde": {
        name: "Crash Wonder Blonde",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "crasher": {
        name: "Crasher",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "crashout_firework": {
        name: "Crashout - Firework",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "crazy_777_2": {
        name: "Crazy 777 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crazy_cars": {
        name: "Crazy Cars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "crazy_chilli_party": {
        name: "Crazy Chilli Party",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "crazy_cows": {
        name: "Crazy Cows",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crazy_crops": {
        name: "Crazy Crops",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "crazy_diamonds": {
        name: "Crazy Diamonds",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "crazy_donuts": {
        name: "Crazy Donuts",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "crazy_fafafa": {
        name: "Crazy FaFaFa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crazy_horses": {
        name: "Crazy Horses",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "crazy_hunter": {
        name: "Crazy Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crazy_hunter_2": {
        name: "Crazy Hunter 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crazy_mart_bonanza": {
        name: "Crazy Mart Bonanza",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crazy_pusher": {
        name: "Crazy Pusher",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crazy_tiki_hold_and_win": {
        name: "Crazy Tiki Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "crazy777": {
        name: "Crazy777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "creature_from_the_black_lagoon": {
        name: "Creature from the Black Lagoon",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "creature_of_mythology": {
        name: "Creature of Mythology",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "creepy_christmas": {
        name: "Creepy Christmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "cricket_duel": {
        name: "Cricket Duel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cricket_king_18": {
        name: "Cricket King 18",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "cricket_mania": {
        name: "Cricket Mania",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "cricket_roulette": {
        name: "Cricket Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "cricket_sah_75": {
        name: "Cricket Sah 75",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crimson_crown": {
        name: "Crimson Crown",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "criss_cross_81": {
        name: "Criss Cross 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "critter_pop": {
        name: "Critter Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cross_it": {
        name: "Cross It",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "crown_and_anchor": {
        name: "Crown & Anchor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "crown_flag": {
        name: "Crown Flag",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "crown_of_avalon": {
        name: "Crown of Avalon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "crown_of_fire": {
        name: "Crown of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crown_of_fire_jackpot_play": {
        name: "Crown of Fire Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crown_of_fortune": {
        name: "Crown of Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crown_of_valor": {
        name: "Crown of Valor",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crowns_legacy": {
        name: "Crown's Legacy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "cruise_royale": {
        name: "Cruise Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "crypto_bro": {
        name: "Crypto Bro",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_10": {
        name: "Crypto Crown 10",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_20": {
        name: "Crypto Crown 20",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_40": {
        name: "Crypto Crown 40",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_5": {
        name: "Crypto Crown 5",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_gold": {
        name: "Crypto Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "crystal_777_deluxe": {
        name: "Crystal 777 Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "crystal_ball": {
        name: "Crystal Ball",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_deluxe": {
        name: "Crystal Ball Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_flaming_link": {
        name: "Crystal Ball Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_gdn": {
        name: "Crystal Ball GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_multi_symbols": {
        name: "Crystal Ball Multi Symbols",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_rhfp": {
        name: "Crystal Ball RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_burst_xxl": {
        name: "Crystal Burst XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_catcher": {
        name: "Crystal Catcher",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "crystal_caverns_megaways": {
        name: "Crystal Caverns MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crystal_clusters": {
        name: "Crystal Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "crystal_falls": {
        name: "Crystal Falls",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "crystal_fruits_bonanza": {
        name: "Crystal Fruits Bonanza",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "crystal_golem": {
        name: "Crystal Golem",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "crystal_hall": {
        name: "Crystal Hall",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crystal_prince": {
        name: "Crystal Prince",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_queen": {
        name: "Crystal Queen",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_queen_coins": {
        name: "Crystal Queen Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_roulette": {
        name: "Crystal Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "crystal_scarabs": {
        name: "Crystal Scarabs",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "crystal_strike": {
        name: "Crystal Strike",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_sun": {
        name: "Crystal Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crystopia": {
        name: "Crystopia",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cthulhu": {
        name: "Cthulhu",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "cube_mania": {
        name: "Cube Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cube_mania_deluxe": {
        name: "Cube Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cubes": {
        name: "Cubes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cubes_2": {
        name: "Cubes 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cult": {
        name: "CULT",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cupcakes": {
        name: "Cupcakes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "curse_of_pharaoh": {
        name: "Curse of Pharaoh",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "curse_of_ra": {
        name: "Curse of Ra",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "curse_of_the_mummies": {
        name: "Curse of The Mummies",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "curse_of_the_pharaoh": {
        name: "Curse of the Pharaoh",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "curse_of_the_pharaoh_bonus_buy": {
        name: "Curse of the Pharaoh Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "curse_of_the_werewolf_megaways": {
        name: "Curse of the Werewolf MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cursed_can": {
        name: "Cursed Can",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cursed_can_bonus_buy": {
        name: "Cursed Can Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cursed_castle": {
        name: "Cursed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cursed_crypt": {
        name: "Cursed Crypt",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cursed_seas": {
        name: "Cursed Seas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cursed_treasure": {
        name: "Cursed treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "cut_the_grass": {
        name: "Cut the Grass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cutie_cat": {
        name: "Cutie Cat",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "cutie_cat_ccs": {
        name: "Cutie Cat CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "cyber_doom": {
        name: "Cyber Doom",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "cyber_heist": {
        name: "Cyber Heist",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cyber_pup_megaways": {
        name: "Cyber Pup Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cyber_runner": {
        name: "Cyber Runner",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "cyber_slot": {
        name: "Cyber slot",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "cyber_vault": {
        name: "Cyber Vault",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "cyberheist_city": {
        name: "Cyberheist City",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cycle_of_luck": {
        name: "Cycle of Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cycle_of_luck_bonus_buy": {
        name: "Cycle of Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "cyclops_smash": {
        name: "Cyclops Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "da_vincis_treasure": {
        name: "Da Vinci's Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dabanggg": {
        name: "Dabanggg",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dan_marino_gunslinger": {
        name: "Dan Marino Gunslinger",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dan_marino_perfect_pass": {
        name: "Dan Marino Perfect Pass",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dance_of_the_dead": {
        name: "Dance Of The Dead",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "dance_party": {
        name: "Dance Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dancing_joker": {
        name: "Dancing Joker",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "dandy_diamonds": {
        name: "Dandy Diamonds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "danny_dollar": {
        name: "Danny Dollar",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dansband_pa_turne": {
        name: "Dansband Pa Turne",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "danssser": {
        name: "Danssser",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dark_forge": {
        name: "Dark Forge",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "dark_king_forbidden_riches": {
        name: "Dark King: Forbidden Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dark_spiral": {
        name: "Dark Spiral",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dark_summoning": {
        name: "Dark Summoning",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "darkness": {
        name: "Darkness",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "darts_180": {
        name: "Darts 180",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "daruma_impact": {
        name: "Daruma Impact",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "davincis_treasure": {
        name: "DaVinci's Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "davy_jones_locker_with_tsunami_reels": {
        name: "Davy Jones Locker with Tsunami Reels",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dawn_of_egypt": {
        name: "Dawn of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dawn_of_kings": {
        name: "Dawn of Kings",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "day_of_dead": {
        name: "Day of Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dazzle_me": {
        name: "Dazzle Me",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dazzle_me_megaways": {
        name: "Dazzle Me Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dcirque": {
        name: "Dcirque",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "dead_by_noon": {
        name: "Dead By Noon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dead_legion": {
        name: "Dead Legion",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "dead_lucky_duomax": {
        name: "Dead Lucky DuoMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "dead_mans_drop": {
        name: "Dead Man's Drop",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "dead_mans_fingers": {
        name: "Dead Man's Fingers",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "dead_mans_riches": {
        name: "Dead Man's Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dead_mans_trail": {
        name: "Dead Man's Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "dead_or_alive": {
        name: "Dead or Alive",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dead_or_alive_2": {
        name: "Dead or Alive 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dead_or_alive_2_feature_buy": {
        name: "Dead or Alive 2 Feature Buy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dead_or_alive_3": {
        name: "Dead or Alive 3",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dead_riders_trail": {
        name: "Dead Riders Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "dead_west": {
        name: "Dead West",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "deadly_5": {
        name: "Deadly 5",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "deadly_west": {
        name: "Deadly West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "deal_with_death": {
        name: "Deal with Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "death_becomes_you": {
        name: "Death Becomes You",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "deck_of_scurra": {
        name: "Deck of Scurra",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "deep_descent": {
        name: "Deep Descent",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "deep_sea": {
        name: "Deep Sea",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "deep_sea_dollars": {
        name: "Deep Sea Dollars",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "deep_sea_dollars_reel_bingo": {
        name: "Deep Sea Dollars Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "deep_sea_dollars_reel_triple": {
        name: "Deep Sea Dollars Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "deep_sea_wild": {
        name: "Deep Sea Wild",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "deep_seas_dollars_super_reels": {
        name: "Deep Seas Dollars Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "deep_treasure_gold": {
        name: "Deep Treasure Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dega_baby": {
        name: "Dega Baby",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "demon": {
        name: "Demon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "demon_jack_27": {
        name: "Demon Jack 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "demon_pots": {
        name: "Demon Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "demon_queen": {
        name: "Demon Queen",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "demon_slayer": {
        name: "Demon Slayer",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "demons_gate": {
        name: "Demon's Gate",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "densho": {
        name: "Densho",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "depths_of_fortune": {
        name: "Depths of Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "derby_dash": {
        name: "Derby Dash",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "derby_rush": {
        name: "Derby Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "derby_wheel": {
        name: "Derby Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "desert_shark": {
        name: "Desert Shark",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "desparate_dawgs": {
        name: "Desparate Dawgs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "desperate_dawgs": {
        name: "Desperate Dawgs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "desperate_dawgs_2_gigablox": {
        name: "Desperate Dawgs 2 Gigablox",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "destiny_of_sun_and_moon": {
        name: "Destiny of Sun and Moon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "detectives_dream": {
        name: "Detective’s Dream",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "deuces_wild": {
        name: "Deuces Wild",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "deuces_wild_1_hand": {
        name: "Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "deuces_wild_10_hand": {
        name: "Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "deuces_wild_100_hand": {
        name: "Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "deuces_wild_5_hand": {
        name: "Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "deuces_wild_50_hand": {
        name: "Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "devil_fire": {
        name: "Devil Fire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "devil_fire_2": {
        name: "Devil Fire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "devil_fire_twins": {
        name: "Devil Fire Twins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "devilicious": {
        name: "Devilicious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "devils_13": {
        name: "Devil's 13",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "devils_kitchen_94": {
        name: "Devil's Kitchen 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dia_de_los_muertos": {
        name: "Dia De Los Muertos",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "diamond_777_plus": {
        name: "Diamond 777 Plus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "diamond_blackjack": {
        name: "Diamond Blackjack",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "diamond_cascade": {
        name: "Diamond Cascade",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamond_charge_extra": {
        name: "Diamond Charge Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_charge_hold_and_win": {
        name: "Diamond Charge Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_charge_megaways": {
        name: "Diamond Charge Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_deal": {
        name: "Diamond Deal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "diamond_desire": {
        name: "Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_desire_deluxe": {
        name: "Diamond Desire Deluxe",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_desire_flame": {
        name: "Diamond Desire Flame",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_dez": {
        name: "Diamond Dez",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "diamond_digger": {
        name: "Diamond Digger",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "diamond_duke": {
        name: "Diamond Duke",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "diamond_forge_link_and_loot": {
        name: "Diamond Forge Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_hill": {
        name: "Diamond Hill",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "diamond_hits": {
        name: "Diamond Hits",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_hits_trio_instastrike": {
        name: "Diamond Hits Trio Instastrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_hustle": {
        name: "Diamond Hustle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "diamond_love_777": {
        name: "Diamond Love 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "diamond_mask": {
        name: "Diamond Mask",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "diamond_mine_extra_gold": {
        name: "Diamond Mine Extra Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "diamond_mine_megaways": {
        name: "Diamond Mine Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "diamond_miner_duomax": {
        name: "Diamond Miner Duomax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "diamond_multiplier_respin": {
        name: "Diamond Multiplier Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "diamond_of_jungle": {
        name: "Diamond of Jungle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "diamond_riches": {
        name: "Diamond Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_rush": {
        name: "Diamond Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "diamond_storm": {
        name: "Diamond Storm",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "diamond_storm_jewel_blast": {
        name: "Diamond Storm Jewel Blast",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "diamond_strike": {
        name: "Diamond Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamond_strike_scratch_250000": {
        name: "Diamond Strike Scratch 250,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamond_supercharge": {
        name: "Diamond Supercharge",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_supernova_100": {
        name: "Diamond Supernova 100",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "diamond_supernova_20": {
        name: "Diamond Supernova 20",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "diamond_supernova_40": {
        name: "Diamond Supernova 40",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "diamond_supernova_5": {
        name: "Diamond Supernova 5",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "diamond_surge": {
        name: "Diamond Surge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "diamond_symphony_doublemax": {
        name: "Diamond Symphony Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "diamond_vortex": {
        name: "Diamond Vortex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "diamondparty": {
        name: "DiamondParty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "diamonds_4_the_win": {
        name: "Diamonds 4 the Win",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "diamonds_are_forever_3_lines": {
        name: "Diamonds are Forever 3 Lines",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamonds_diamonds_diamonds_hold_and_win": {
        name: "Diamonds Diamonds Diamonds Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamonds_of_egypt": {
        name: "Diamonds of Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamonds_of_liberty": {
        name: "Diamonds of Liberty",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamonds_of_the_realm": {
        name: "Diamonds of the Realm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "diamonds_scratch": {
        name: "Diamonds Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "dice": {
        name: "Dice",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dice_bonanza": {
        name: "Dice Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dice_city": {
        name: "Dice City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dice_million": {
        name: "Dice Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dig_dig_digger": {
        name: "Dig Dig Digger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dig_it": {
        name: "Dig it",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "diner_delights": {
        name: "Diner Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "diner_frenzy_spins": {
        name: "Diner Frenzy Spins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ding_dong_christmas_bells": {
        name: "Ding Dong Christmas Bells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dino_pd": {
        name: "Dino P.D",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "dino_reels_81": {
        name: "Dino Reels 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dinopolis": {
        name: "Dinopolis",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "dinosaur_rage": {
        name: "Dinosaur Rage",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dinosaur_tycoon": {
        name: "Dinosaur Tycoon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dinosaur_tycoon_ii": {
        name: "Dinosaur Tycoon II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dio_killing_the_dragon": {
        name: "DIO Killing the Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "disc_of_athena": {
        name: "Disc of Athena",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "disco_777": {
        name: "Disco 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "disco_beats": {
        name: "Disco Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "disco_danny": {
        name: "Disco Danny",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "disco_diamonds": {
        name: "Disco Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "disco_funk": {
        name: "Disco Funk",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "disco_lady": {
        name: "Disco Lady",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "disco_party": {
        name: "Disco Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "divina_commedia_i_nove_cerchi": {
        name: "Divina Commedia I Nove Cerchi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "divine_divas": {
        name: "Divine Divas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "divine_dreams": {
        name: "Divine Dreams",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "divine_drop": {
        name: "Divine Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "divine_fire": {
        name: "Divine Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "divine_fortune_black": {
        name: "Divine Fortune Black",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "divine_fortune_gold": {
        name: "Divine Fortune Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "divine_fortune_megaways": {
        name: "Divine Fortune Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "divine_fruits": {
        name: "Divine Fruits",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "divine_links": {
        name: "Divine Links",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "divine_queen_heart_of_ice": {
        name: "Divine Queen Heart of Ice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "divine_showdown": {
        name: "Divine Showdown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dj_cat": {
        name: "DJ Cat",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "dj_fox": {
        name: "DJ Fox",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "dj_tiger_x1000": {
        name: "DJ Tiger x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "dolla_dolla_bill": {
        name: "Dolla Dolla Bill",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "dolla_dolla_bill_mo_money": {
        name: "Dolla Dolla Bill Mo Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "dolphin_bay": {
        name: "Dolphin Bay",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "dolphin_hot_1": {
        name: "Dolphin Hot 1",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "domnitors_treasure": {
        name: "Domnitor's Treasure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "don_juan_peppers": {
        name: "Don Juan Peppers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "don_juans_peppers": {
        name: "Don Juan's Peppers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "donkey_and_the_goats": {
        name: "Donkey & The Goats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "donny_and_danny": {
        name: "Donny and Danny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "donny_dough": {
        name: "Donny Dough",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dont_eat_the_candy": {
        name: "Don’t Eat The Candy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "donut_division": {
        name: "Donut Division",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "doom_of_egypt": {
        name: "Doom of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "doomsday_rampage": {
        name: "Doomsday Rampage",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "doomsday_saloon": {
        name: "Doomsday Saloon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dork_unit": {
        name: "Dork Unit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dorks_of_the_deep": {
        name: "Dorks of the Deep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "double_bonus_poker_1_hand": {
        name: "Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_bonus_poker_10_hand": {
        name: "Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_bonus_poker_100_hand": {
        name: "Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_bonus_poker_5_hand": {
        name: "Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_bonus_poker_50_hand": {
        name: "Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_cash_mummy": {
        name: "Double Cash Mummy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "double_double_bonus_poker_1_hand": {
        name: "Double Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_double_bonus_poker_10_hand": {
        name: "Double Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_double_bonus_poker_100_hand": {
        name: "Double Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_double_bonus_poker_5_hand": {
        name: "Double Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_double_bonus_poker_50_hand": {
        name: "Double Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_dragons": {
        name: "Double Dragons",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "double_exposure_3_hand": {
        name: "Double Exposure 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_exposure_blackjack": {
        name: "Double Exposure Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "double_fortune": {
        name: "Double Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "double_fruit_frenzy_doublemax": {
        name: "Double Fruit Frenzy Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "double_lucky_mushrooms_doublemax": {
        name: "Double Lucky Mushrooms DoubleMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "double_o_dollars": {
        name: "Double O Dollars",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_race": {
        name: "Double Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "double_rainbow": {
        name: "Double Rainbow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "double_salary_1_year": {
        name: "Double Salary 1 Year",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "double_stacks": {
        name: "Double Stacks",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "double_tigers": {
        name: "Double Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "down_the_chimney": {
        name: "Down The Chimney",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "down_the_rails": {
        name: "Down the Rails",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dr_feelgood": {
        name: "Dr Feelgood",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dr_shocker": {
        name: "Dr. Shocker",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "dr_toonz": {
        name: "Dr. Toonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dracula": {
        name: "Dracula",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "draculas_castle": {
        name: "Dracula's Castle",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "drago_jewels_of_fortune": {
        name: "Drago - Jewels of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_50000": {
        name: "Dragon 50000",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "dragon_age_hold_and_win_dragon_age": {
        name: "Dragon Age Hold and Win (Dragon Age)",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragon_and_dragons": {
        name: "Dragon and Dragons",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "dragon_and_tiger": {
        name: "Dragon and Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dragon_blox": {
        name: "Dragon Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "dragon_bonus_baccarat": {
        name: "Dragon Bonus Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_castle": {
        name: "Dragon Castle",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragon_chase": {
        name: "Dragon Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dragon_egg": {
        name: "Dragon Egg",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragon_emperor": {
        name: "Dragon Emperor",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragon_fortune": {
        name: "Dragon Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dragon_gold_88": {
        name: "Dragon Gold 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_hatch": {
        name: "Dragon Hatch",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_hero": {
        name: "Dragon Hero",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_hopper": {
        name: "Dragon Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "dragon_hot_hold_and_spin": {
        name: "Dragon Hot Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_king_hot_pots": {
        name: "Dragon King Hot Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_kingdom": {
        name: "Dragon Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_kingdom_eyes_of_fire": {
        name: "Dragon Kingdom Eyes of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_legend": {
        name: "Dragon Legend",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_lore_gigarise": {
        name: "Dragon Lore Gigarise",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "dragon_maiden": {
        name: "Dragon Maiden",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragon_of_the_princess": {
        name: "Dragon of the Princess",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "dragon_pearls": {
        name: "Dragon Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "dragon_pots_megaways": {
        name: "Dragon Pots Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_queens_megaways": {
        name: "Dragon Queens Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragon_reborn": {
        name: "Dragon Reborn",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragon_reborn_rush": {
        name: "Dragon Reborn Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragon_riches": {
        name: "Dragon Riches",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragon_ship": {
        name: "Dragon Ship",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragon_shrine": {
        name: "Dragon Shrine",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dragon_tiger": {
        name: "Dragon Tiger",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dragon_tiger_fortunes": {
        name: "Dragon Tiger Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_tiger_gate": {
        name: "Dragon Tiger Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragon_tiger_lobby": {
        name: "Dragon Tiger Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dragon_tiger_luck": {
        name: "Dragon Tiger Luck",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_treasure": {
        name: "Dragon Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dragon_trio_bonus": {
        name: "Dragon: Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "dragon_vs_phoenix": {
        name: "Dragon VS Phoenix",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragon_x_tiger": {
        name: "Dragon X Tiger",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragon_x_tiger_ii": {
        name: "Dragon X Tiger II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragonfall": {
        name: "Dragonfall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "dragonfates_favour": {
        name: "Dragonfate's Favour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragons_awakening": {
        name: "Dragons' Awakening",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "dragons_crash": {
        name: "Dragon's Crash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragons_domain": {
        name: "Dragon's Domain",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dragons_gate_bonus_choice": {
        name: "Dragon's Gate Bonus Choice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragons_gold_100": {
        name: "Dragon's Gold 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragons_hoard": {
        name: "Dragon's Hoard",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragons_legend": {
        name: "Dragons Legend",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "dragons_lucky_8": {
        name: "Dragons Lucky 8",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dragons_playground": {
        name: "Dragons Playground",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "dragons_pot": {
        name: "Dragon's Pot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dragons_realm": {
        name: "Dragon's Realm",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragons_tavern": {
        name: "Dragon's Tavern",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "dragons_tavern_bonus_buy": {
        name: "Dragon's Tavern Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "dragons_throne": {
        name: "Dragon's Throne",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragons_treasure_quest": {
        name: "Dragon's Treasure Quest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragons_vs_gigablox": {
        name: "Dragons vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "dragons_win_multiplier": {
        name: "Dragon's Win Multiplier",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dragontiger": {
        name: "DragonTiger",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "draw_sevens": {
        name: "Draw Sevens",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "dreadworks": {
        name: "Dreadworks",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "dream_car_speed": {
        name: "Dream Car Speed",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dream_car_suv": {
        name: "Dream Car SUV",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dream_car_urban": {
        name: "Dream Car Urban",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dreams_of_gold": {
        name: "Dreams of Gold",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_gold_delight": {
        name: "Dreams of Gold Delight",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_gold_jackpot": {
        name: "Dreams of Gold Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_macau": {
        name: "Dreams of Macau",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "drfrankens_lab": {
        name: "Dr.Franken’s Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "drfrankens_lab_777jackpot": {
        name: "Dr.Franken’s Lab 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "drill_that_gold": {
        name: "Drill that Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "drive_multiplier_mayhem": {
        name: "Drive: Multiplier Mayhem",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "drop_ball": {
        name: "Drop Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "dropem": {
        name: "Drop'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "druids_dream": {
        name: "Druids' Dream",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "druids_drop": {
        name: "Druid's Drop",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "druids_magic": {
        name: "Druid's Magic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "drunken_sailors": {
        name: "Drunken Sailors",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "dublin_up": {
        name: "Dublin Up",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "dublin_up_pots_o_gold_double_max": {
        name: "Dublin Up Pots O' Gold Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "duck_hunt_500": {
        name: "Duck Hunt 500",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "duck_king": {
        name: "Duck King",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "duck_shooter": {
        name: "Duck Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "duck_shooter_ccs": {
        name: "Duck Shooter CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "duel_at_dawn": {
        name: "Duel at Dawn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "duel_of_night_and_day": {
        name: "Duel of Night and Day",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dungeon_immortal_evil": {
        name: "Dungeon: Immortal Evil",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "dungeon_tower": {
        name: "Dungeon Tower",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "durian_dynamite": {
        name: "Durian Dynamite",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dusk_princess": {
        name: "Dusk Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dusty_duel": {
        name: "Dusty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dwarf_and_dragon": {
        name: "Dwarf and Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dwarfs_fortune": {
        name: "Dwarfs Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dwarfs_gone_wild": {
        name: "Dwarfs Gone Wild",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dwarven_gems_megaways": {
        name: "Dwarven Gems Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "dwarven_gold_deluxe": {
        name: "Dwarven Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dwarves_treasure_race": {
        name: "Dwarves Treasure Race",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "dyna_mule": {
        name: "Dyna Mule",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "dynamite_diggin_doug": {
        name: "Dynamite Diggin Doug",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dynamite_trio": {
        name: "Dynamite Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "dynasty_of_death": {
        name: "Dynasty of Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eagle_storm": {
        name: "Eagle Storm",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eagle_strike": {
        name: "Eagle Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "eagle_strike_extra": {
        name: "Eagle Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "eagle_strike_lucky_cache": {
        name: "Eagle Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "east_sea_dragon_king": {
        name: "East Sea Dragon King",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "east_west_wild": {
        name: "East West Wild",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "easter_classics": {
        name: "Easter Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "easter_eggs": {
        name: "Easter Eggs",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "easter_eggspedition": {
        name: "Easter Eggspedition",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "easter_heist": {
        name: "Easter Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "easter_plinko": {
        name: "Easter Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "eastern_emeralds": {
        name: "Eastern Emeralds",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "eastern_gold": {
        name: "Eastern Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "eastern_gold_6_deluxe": {
        name: "Eastern Gold 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "egg_hustler": {
        name: "Egg Hustler",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "egg_rush_jackpot_play": {
        name: "Egg Rush Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eggomatic": {
        name: "EggOMatic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "eggs_of_fortune": {
        name: "Eggs of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "eggstra_cash": {
        name: "Eggstra Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "egypt_fire": {
        name: "Egypt Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "egypt_fire_2": {
        name: "Egypt Fire 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "egypt_gods": {
        name: "Egypt Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "egypt_power_x1000": {
        name: "Egypt Power x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "egyptian_dreams": {
        name: "Egyptian Dreams",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "egyptian_dreams_deluxe": {
        name: "Egyptian Dreams Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "egyptian_fortunes": {
        name: "Egyptian Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "egypts_book_of_mystery": {
        name: "Egypt's Book of Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "egypts_glow": {
        name: "Egypt's Glow",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "el_diablo": {
        name: "El Diablo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "el_dorado": {
        name: "El Dorado",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "el_dorado_infinity_reels": {
        name: "El Dorado Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "el_jackpotto": {
        name: "El Jackpotto",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eldritch_dungeon": {
        name: "Eldritch Dungeon",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "electric_rush": {
        name: "Electric Rush",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "electric_wilds": {
        name: "Electric Wilds",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "electro_cubes": {
        name: "Electro Cubes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "elemental_gems_megaways": {
        name: "Elemental Gems MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "elemento": {
        name: "Elemento",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "elements_of_power": {
        name: "Elements of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "elements_the_awakening": {
        name: "Elements: The Awakening",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "elephant": {
        name: "Elephant",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "elephants_vs_tigers": {
        name: "Elephants vs Tigers",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "elf_bingo": {
        name: "Elf Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "elite_of_evil_portal_of_gold": {
        name: "Elite of Evil - Portal of Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "elite_of_evil_the_first_quest": {
        name: "Elite of Evil: The First Quest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "elizabeths_lab": {
        name: "Elizabeth's Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "elk_hunter": {
        name: "Elk Hunter",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "ellens_fortune": {
        name: "Ellen's Fortune",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "elven_princesses": {
        name: "Elven Princesses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "elven_princesses_crown_quest": {
        name: "Elven Princesses: Crown Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "elves": {
        name: "Elves",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "elves_kingdom": {
        name: "Elves Kingdom",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "elvis_frog_in_vegas": {
        name: "Elvis Frog in Vegas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "elvis_frog_trueways": {
        name: "Elvis Frog TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "emberfall": {
        name: "Emberfall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "emberfall_40k": {
        name: "Emberfall 40K",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "emerald_brewer": {
        name: "Emerald Brewer",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "emerald_king": {
        name: "Emerald King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emerald_king_rainbow_road": {
        name: "Emerald King Rainbow Road",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emerald_king_wheel_of_wealth": {
        name: "Emerald King Wheel of Wealth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emeralds_infinity_reels": {
        name: "Emerald's Infinity Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "emoji_riches": {
        name: "Emoji Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "emotional_damage": {
        name: "Emotional Damage",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "emperor_caishen": {
        name: "Emperor Caishen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emperors_favour": {
        name: "Emperor's Favour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "emperors_rise": {
        name: "Emperor's Rise",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "empty_the_bank": {
        name: "Empty the Bank!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "enchanted_crystals": {
        name: "Enchanted Crystals",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "enchanted_meadow": {
        name: "Enchanted Meadow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "end_of_edo": {
        name: "End Of Edo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "end_of_us_zombie_respin": {
        name: "End of Us Zombie Respin",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "energoonz": {
        name: "Energoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "engeki_rising_x50": {
        name: "Engeki Rising x50",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "epic_bullets_and_bounty_94": {
        name: "Epic Bullets and Bounty 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "epic_crystal": {
        name: "Epic Crystal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "epic_crystal_deluxe": {
        name: "Epic Crystal Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "epic_dreams": {
        name: "Epic Dreams",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "epic_fish_adventure": {
        name: "Epic Fish Adventure",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_fish_marlin_madness": {
        name: "Epic Fish Marlin Madness",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_fish_net_of_fortune": {
        name: "Epic Fish Net of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_gems": {
        name: "Epic Gems",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "epic_gladiators": {
        name: "Epic Gladiators",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "epic_hellas": {
        name: "Epic Hellas",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "epic_joker": {
        name: "Epic Joker",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "epic_legends": {
        name: "Epic Legends",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "epic_phoenix": {
        name: "Epic Phoenix",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "erik_the_red": {
        name: "Erik the Red",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "escape_the_pyramid_fire_and_ice": {
        name: "Escape the Pyramid Fire and Ice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "et_lost_socks": {
        name: "E.T. Lost Socks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "eternal_dawn": {
        name: "Eternal Dawn",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "eternal_duel_94": {
        name: "Eternal Duel 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eternal_dusk": {
        name: "Eternal Dusk",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "eternal_empress_freeze_time": {
        name: "Eternal Empress Freeze Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eternal_phoenix_megaways": {
        name: "Eternal Phoenix Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "ethan_grand_mayan_diaries": {
        name: "Ethan Grand: Mayan Diaries",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "europe_transit": {
        name: "Europe Transit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "europe_transit_bonus_buy": {
        name: "Europe Transit Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "europe_transit_snowdrift": {
        name: "Europe Transit Snowdrift",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "european_blackjack": {
        name: "European Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "european_christmas_roulette": {
        name: "European Christmas Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "european_roulette": {
        name: "European Roulette",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "european_roulette_dark_mode": {
        name: "European Roulette - Dark Mode",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "everest": {
        name: "Everest",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "everest_avalanche": {
        name: "Everest Avalanche",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "evil_devil": {
        name: "Evil Devil",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "evil_eyes": {
        name: "Evil Eyes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "evoji": {
        name: "Evoji",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "excalibur": {
        name: "Excalibur",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "excalibur_unleashed": {
        name: "Excalibur Unleashed",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "excalibur_vs_gigablox": {
        name: "Excalibur vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "expanding_fireworks": {
        name: "Expanding Fireworks",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "expanding_master": {
        name: "Expanding Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "explodiac": {
        name: "Explodiac",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "explodiac_rhfp": {
        name: "Explodiac RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "exploding_fruits": {
        name: "Exploding Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "express_200_scratch": {
        name: "Express 200 Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "extra_bingo": {
        name: "Extra Bingo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "extra_juicy": {
        name: "Extra Juicy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "extra_juicy_megaways": {
        name: "Extra Juicy MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "extreme_color_game": {
        name: "Extreme Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "extreme_pay": {
        name: "Extreme Pay",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "eye_of_atum": {
        name: "Eye of Atum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "eye_of_cleopatra": {
        name: "Eye of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eye_of_gold": {
        name: "Eye of Gold",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "eye_of_horus_megaways": {
        name: "Eye of Horus Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_horus_rise_of_egypt": {
        name: "Eye of Horus Rise of Egypt",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_horus_tablets_of_destiny": {
        name: "Eye of Horus Tablets of Destiny",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_horus_tablets_of_destiny_megaways": {
        name: "Eye of Horus Tablets of Destiny Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_medusa": {
        name: "Eye of Medusa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eye_of_persia_2": {
        name: "Eye of Persia 2",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "eye_of_spartacus": {
        name: "Eye of Spartacus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eye_of_the_kraken": {
        name: "Eye of the Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "eye_of_the_panda": {
        name: "Eye of the Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eye_of_the_storm": {
        name: "Eye of the Storm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fa_cai_shen": {
        name: "Fa Cai Shen",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fa_cai_shen_deluxe": {
        name: "Fa Cai Shen Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fa_choi_tree_jp": {
        name: "Fa Choi Tree JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fa_fa_fa": {
        name: "Fa Fa Fa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "face_off": {
        name: "Face Off",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fairy_gate": {
        name: "Fairy Gate",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "fairytale_fortune": {
        name: "Fairytale Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fairytale_legends_hansel_and_gretel": {
        name: "Fairytale Legends: Hansel and Gretel",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fairytale_legends_mirror_mirror": {
        name: "Fairytale Legends: Mirror Mirror",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fairytale_legends_red_riding_hood": {
        name: "Fairytale Legends: Red Riding Hood",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "family_feud": {
        name: "Family Feud",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fancy_alice": {
        name: "Fancy Alice",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fancy_fruits": {
        name: "Fancy Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_ccs": {
        name: "Fancy Fruits CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_deluxe": {
        name: "Fancy Fruits Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_flaming_link": {
        name: "Fancy Fruits Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_gdn": {
        name: "Fancy Fruits GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_respins_of_amunre": {
        name: "Fancy Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_rhfp": {
        name: "Fancy Fruits RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fang_city": {
        name: "Fang City",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fangs_and_fire": {
        name: "Fangs and Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fangs_inferno": {
        name: "Fang's Inferno",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "fangtastic_freespins": {
        name: "Fangtastic Freespins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fantastic_fairies": {
        name: "Fantastic Fairies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "farm_frenzy": {
        name: "Farm Frenzy",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "farming_frenzy": {
        name: "Farming Frenzy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "farmyard_fortunes": {
        name: "Farmyard Fortunes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fashiontv_diamonds": {
        name: "FashionTV Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fast_fortune": {
        name: "Fast Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "fast_fruits_doublemax": {
        name: "Fast Fruits Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "fat_banker": {
        name: "Fat Banker",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fat_drac": {
        name: "Fat Drac",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fat_frankies": {
        name: "Fat Frankies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fat_panda": {
        name: "Fat Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fat_rabbit": {
        name: "Fat Rabbit",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fat_santa": {
        name: "Fat Santa",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fat_stacks_miami_cash": {
        name: "Fat Stacks Miami Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fate_of_dead_blitzways": {
        name: "Fate of Dead Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fate_of_the_gods": {
        name: "Fate of The Gods",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fates_fortune": {
        name: "Fate's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "favela_boyz": {
        name: "Favela Boyz",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fear_of_the_dark": {
        name: "Fear of the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fear_the_dark": {
        name: "Fear the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "feasting_fox": {
        name: "Feasting Fox",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "feather_fury": {
        name: "Feather Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "feeding_fury": {
        name: "Feeding Fury",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "feel_the_beat": {
        name: "Feel the Beat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "feline_fury": {
        name: "Feline Fury",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "feng_fu": {
        name: "Feng Fu",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fenghuang": {
        name: "Fenghuang",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fengs_fortune": {
        name: "Feng's Fortune",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fengshen": {
        name: "Fengshen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fenix_play": {
        name: "Fenix Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_27": {
        name: "Fenix Play 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_27_deluxe": {
        name: "Fenix Play 27 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_deluxe": {
        name: "Fenix Play Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "festival_10k_ways": {
        name: "Festival 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "festival_of_the_dead": {
        name: "Festival of the Dead",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "fever_las_vegas": {
        name: "Fever Las Vegas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fields_of_clover": {
        name: "Fields of clover",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fiesta_clusters": {
        name: "Fiesta Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fiesta_explosiva_duomax": {
        name: "Fiesta Explosiva DuoMax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "fiesta_fortune": {
        name: "Fiesta Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fiesta_frenzy": {
        name: "Fiesta Frenzy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "fight_or_die_crew": {
        name: "Fight or Die Crew",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "fighter_pit": {
        name: "Fighter Pit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "figoal": {
        name: "Figoal",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "finger_lickn_free_spins": {
        name: "Finger Lick'n Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "finn_and_the_candy_spin": {
        name: "Finn and The Candy Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "finn_and_the_dragon_tales": {
        name: "Finn and the Dragon Tales",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "finn_and_the_swirly_spin": {
        name: "Finn and the Swirly Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "finns_golden_tavern": {
        name: "Finn's Golden Tavern",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fire_88": {
        name: "Fire 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_archer": {
        name: "Fire Archer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_bird": {
        name: "Fire Bird",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fire_dragon": {
        name: "Fire dragon",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fire_hopper": {
        name: "Fire Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fire_horse_fortune": {
        name: "Fire Horse Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "fire_hot_100": {
        name: "Fire Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_100_jackpot_play": {
        name: "Fire Hot 100 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_20": {
        name: "Fire Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_20_jackpot_play": {
        name: "Fire Hot 20 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_40": {
        name: "Fire Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_40_jackpot_play": {
        name: "Fire Hot 40 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_5": {
        name: "Fire Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_5_jackpot_play": {
        name: "Fire Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_joker": {
        name: "Fire Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_100": {
        name: "Fire Joker 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_blitz": {
        name: "Fire Joker Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_freeze": {
        name: "Fire Joker Freeze",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_lightning": {
        name: "Fire Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fire_my_laser": {
        name: "Fire My Laser",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fire_pig_push_ways": {
        name: "Fire Pig Push Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fire_portals": {
        name: "Fire Portals",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_rooster": {
        name: "Fire Rooster",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fire_stampede": {
        name: "Fire Stampede",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_stampede_2": {
        name: "Fire Stampede 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_stampede_ultimate": {
        name: "Fire Stampede Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_strike": {
        name: "Fire Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_strike_2": {
        name: "Fire Strike 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_toad": {
        name: "Fire Toad",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_toad_2": {
        name: "Fire Toad 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_wilds": {
        name: "Fire Wilds",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "firebird_spirit_connect_and_collect": {
        name: "Firebird Spirit Connect and Collect",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "firefly_frenzy": {
        name: "Firefly Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "firenhot": {
        name: "Fire'n'Hot",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "firewins_factory": {
        name: "FireWins Factory",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "fireworks_of_fortune": {
        name: "Fireworks of Fortune",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fish_eye": {
        name: "Fish Eye",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fish_n_nudge": {
        name: "Fish 'n' Nudge",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fish_n_nudge_big_catch": {
        name: "Fish n Nudge Big Catch",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "fish_tales_colossal_catch_link_and_loot": {
        name: "Fish Tales Colossal Catch Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_double_catch": {
        name: "Fish Tales Double Catch",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_double_catch_max_scatter": {
        name: "Fish Tales: Double Catch Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_halloween": {
        name: "Fish Tales Halloween",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_monster_bass": {
        name: "Fish Tales Monster Bass",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_monster_bass_10000": {
        name: "Fish Tales Monster Bass 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fishermans_luck": {
        name: "Fisherman's Luck",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fishin_bear": {
        name: "Fishin' Bear",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "fishin_frenzy_big_catch_megaways": {
        name: "Fishin Frenzy Big Catch Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_megaways": {
        name: "Fishin' Frenzy Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_power_4_slots": {
        name: "Fishin Frenzy Power 4 Slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_prize_lines": {
        name: "Fishin' Frenzy Prize Lines",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_the_big_catch_megaways": {
        name: "Fishin Frenzy The Big Catch Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_reels": {
        name: "Fishin' Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fishing_club": {
        name: "Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fishing_club_2": {
        name: "Fishing Club 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fishing_time": {
        name: "Fishing Time",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fishing_trawler": {
        name: "Fishing Trawler",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "fist_of_destruction": {
        name: "Fist of Destruction",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "five_clans": {
        name: "Five Clans",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "flame_of_ra": {
        name: "Flame of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "flaming_chillies": {
        name: "Flaming Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "flaming_fruit": {
        name: "Flaming Fruit",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "flip_n_spin": {
        name: "Flip n Spin",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "flirting_scholar": {
        name: "Flirting Scholar",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "floating_dragon": {
        name: "Floating Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_dragon_boat_festival": {
        name: "Floating Dragon Dragon Boat Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_megaways": {
        name: "Floating Dragon Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_new_year_festival_ultra_megaways": {
        name: "Floating Dragon New Year Festival Ultra Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_wild_horses": {
        name: "Floating Dragon Wild Horses",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_year_of_the_snake": {
        name: "Floating Dragon Year of the Snake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "flock_me": {
        name: "Flock Me",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "floridaman": {
        name: "Floridaman",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "flower_fortunes_supreme": {
        name: "Flower Fortunes Supreme",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "flowers": {
        name: "Flowers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "flowers_christmas_edition": {
        name: "Flowers Christmas Edition",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fluffy_rangers": {
        name: "Fluffy Rangers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fluxberry": {
        name: "Fluxberry",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fly": {
        name: "Fly!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fly_on": {
        name: "Fly On!",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fmines": {
        name: "Fmines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "fogo_do_brasil_777": {
        name: "Fogo Do Brasil 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fonzos_feline_fortunes": {
        name: "Fonzo's Feline Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "food_feast": {
        name: "Food Feast",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "football": {
        name: "Football",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "football_3x3": {
        name: "Football 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "football_bet": {
        name: "Football Bet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "football_blitz_top_card": {
        name: "Football Blitz Top Card",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "football_champions_cup": {
        name: "Football: Champions Cup",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "football_golden_cup": {
        name: "Football Golden Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "football_hold_and_blitz": {
        name: "Football Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "football_hooligans": {
        name: "Football Hooligans",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "football_manager": {
        name: "Football Manager",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "football_mania": {
        name: "Football Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "football_mania_deluxe": {
        name: "Football Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "football_plinko": {
        name: "Football Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "football_rush": {
        name: "Football Rush",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "football_scratch": {
        name: "Football Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "football_super_spins": {
        name: "Football Super Spins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "forbidden_alchemy": {
        name: "Forbidden Alchemy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "forbidden_temple_power_hit": {
        name: "Forbidden Temple Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "forest_dreams": {
        name: "Forest Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "forest_fortune": {
        name: "Forest Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "forever_diamonds": {
        name: "Forever Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "forge_of_fortunes": {
        name: "Forge of Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "forge_of_gems": {
        name: "Forge of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "forge_of_olympus": {
        name: "Forge of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "forge_of_the_gods": {
        name: "Forge of the Gods",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "forge_of_wealth": {
        name: "Forge of Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "forging_wilds": {
        name: "Forging Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "forgotten": {
        name: "Forgotten",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "forgotten_fable": {
        name: "Forgotten Fable",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fort_brave": {
        name: "Fort Brave",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fortuna_trueways": {
        name: "Fortuna TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_ace": {
        name: "Fortune Ace",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_ace_scatter": {
        name: "Fortune Ace Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_and_finery": {
        name: "Fortune and Finery",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fortune_babies": {
        name: "Fortune Babies",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fortune_babies_harmony": {
        name: "Fortune Babies Harmony",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fortune_baccarat": {
        name: "Fortune Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "fortune_bells": {
        name: "Fortune Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_bingo": {
        name: "Fortune Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_coins": {
        name: "Fortune Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_coins_2": {
        name: "Fortune Coins 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_dogs": {
        name: "Fortune Dogs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fortune_dragon": {
        name: "Fortune Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_dragon_3": {
        name: "Fortune Dragon 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fortune_dragon_ii": {
        name: "Fortune Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fortune_dragon_joy": {
        name: "Fortune Dragon Joy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fortune_dragon_riches": {
        name: "Fortune Dragon Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "fortune_fairies_holdandwin": {
        name: "Fortune Fairies Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "fortune_fish": {
        name: "Fortune Fish",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fortune_gartuda_500": {
        name: "Fortune Gartuda 500",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_gems": {
        name: "Fortune Gems",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_gems_2": {
        name: "Fortune Gems 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_gems_3": {
        name: "Fortune Gems 3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_gems_scratch": {
        name: "Fortune Gems Scratch",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_globe": {
        name: "Fortune Globe",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "fortune_gods": {
        name: "Fortune Gods",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_hitn_roll": {
        name: "Fortune Hit'n Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_hook_boom": {
        name: "Fortune Hook Boom",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_horse": {
        name: "Fortune Horse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_king_jackpot": {
        name: "Fortune King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_llama": {
        name: "Fortune Llama",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fortune_lucky_jp": {
        name: "Fortune Lucky JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fortune_monkey": {
        name: "Fortune Monkey",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_mouse": {
        name: "Fortune Mouse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_of_giza": {
        name: "Fortune of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_of_olympus": {
        name: "Fortune of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_ox": {
        name: "Fortune Ox",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_pandas": {
        name: "Fortune Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "fortune_paw": {
        name: "Fortune Paw",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fortune_rabbit": {
        name: "Fortune Rabbit",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_rangers": {
        name: "Fortune Rangers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fortune_red_packets": {
        name: "Fortune Red Packets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_reels": {
        name: "Fortune Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fortune_rewind": {
        name: "Fortune Rewind",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortune_roulette": {
        name: "Fortune Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "fortune_scratch": {
        name: "Fortune Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "fortune_snake": {
        name: "Fortune Snake",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_spin": {
        name: "Fortune Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_teller": {
        name: "Fortune Teller",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortune_tiger": {
        name: "Fortune Tiger",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_tree": {
        name: "Fortune Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortune_zombie": {
        name: "Fortune Zombie",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortunepig": {
        name: "FortunePig",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fortunes_of_ali_baba": {
        name: "Fortunes of Ali Baba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortunes_of_aztec": {
        name: "Fortunes of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "forty_fruity_million": {
        name: "Forty Fruity Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "four_aces": {
        name: "Four Aces",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "four_divine_beasts": {
        name: "Four Divine Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "four_lucky_clover": {
        name: "Four Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "four_lucky_diamonds": {
        name: "Four Lucky Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "four_sacred_souls": {
        name: "Four Sacred Souls",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "four_saint_treasure": {
        name: "Four Saint Treasure",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fox_mayhem": {
        name: "Fox Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "frankenstein_wild_surge": {
        name: "Frankenstein Wild Surge",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "frankensteins_fortune": {
        name: "Frankenstein's Fortune",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "franks_diner": {
        name: "Frank's Diner",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "franks_farm": {
        name: "Frank's Farm",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "freaked_out_fish": {
        name: "Freaked Out Fish",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "freakshow_hotel": {
        name: "Freakshow Hotel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "frednfire": {
        name: "Fred-Nfire",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "freds_food_truck": {
        name: "Fred's Food Truck",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "free_bet_blackjack_1": {
        name: "Free Bet Blackjack 1",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "free_reelin_joker": {
        name: "Free Reelin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "free_reelin_joker_1000": {
        name: "Free Reelin' Joker 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "freedom_frenzy": {
        name: "Freedom Frenzy",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "french_roulette": {
        name: "French Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "french_roulette_classic": {
        name: "French Roulette Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "frenzy_clusters": {
        name: "Frenzy Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "frequent_flyer": {
        name: "Frequent Flyer",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "frightening_frankie": {
        name: "Frightening Frankie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frkn_bananas": {
        name: "FRKN Bananas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "frog_dash": {
        name: "Frog Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "frogs_and_bugs": {
        name: "Frogs & Bugs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frogs_scratch": {
        name: "Frogs Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "front_runner_odds_on": {
        name: "Front Runner Odds On",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frontier_fortunes": {
        name: "Frontier Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "frooty_troupe_game_on_94": {
        name: "Frooty Troupe Game On 94",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "frooty_troupe_gold_club": {
        name: "Frooty Troupe Gold Club",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "frooty_troupe_sun_splash": {
        name: "Frooty Troupe Sun Splash",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "frozen_age": {
        name: "Frozen Age",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "frozen_blade": {
        name: "Frozen Blade",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "frozen_fruit": {
        name: "Frozen Fruit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "frozen_gems": {
        name: "Frozen Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "frozen_queen": {
        name: "Frozen Queen",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "frozen_tropics": {
        name: "Frozen Tropics",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_blaze": {
        name: "Fruit Blaze",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_burst": {
        name: "Fruit Burst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_candy": {
        name: "Fruit Candy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fruit_case": {
        name: "Fruit Case",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_coins_hold_and_win": {
        name: "Fruit Coins Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "fruit_combinator": {
        name: "Fruit Combinator",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "fruit_disco": {
        name: "Fruit Disco",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_double_wins": {
        name: "Fruit Double Wins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "fruit_duel": {
        name: "Fruit Duel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fruit_fiesta": {
        name: "Fruit Fiesta",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruit_fusion": {
        name: "Fruit Fusion",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fruit_gemz_splitz": {
        name: "Fruit Gemz Splitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "fruit_heaven_hold_and_win": {
        name: "Fruit Heaven Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fruit_lightning": {
        name: "Fruit Lightning",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruit_lightning_3x5": {
        name: "Fruit Lightning 3x5",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruit_lines": {
        name: "Fruit Lines",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fruit_lines_winter": {
        name: "Fruit Lines Winter",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fruit_love": {
        name: "Fruit Love",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania": {
        name: "Fruit Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania_deluxe": {
        name: "Fruit Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruit_mania_flaming_link": {
        name: "Fruit Mania Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania_gdn": {
        name: "Fruit Mania GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania_rhfp": {
        name: "Fruit Mania RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_million": {
        name: "Fruit Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fruit_nova": {
        name: "Fruit Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_party": {
        name: "Fruit Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_party_2": {
        name: "Fruit Party 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_party_jackpot_play": {
        name: "Fruit Party Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_punch_up": {
        name: "Fruit Punch Up",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "fruit_rainbow": {
        name: "Fruit Rainbow",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_rush": {
        name: "Fruit Rush",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_saga": {
        name: "Fruit Saga",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fruit_shop": {
        name: "Fruit Shop",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_shop_christmas_edition": {
        name: "Fruit Shop Christmas Edition",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_shop_frenzy": {
        name: "Fruit Shop Frenzy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_shop_grand_reopening": {
        name: "Fruit Shop Grand Re-Opening",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_shop_megaways": {
        name: "Fruit Shop Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_smash": {
        name: "Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "fruit_snapz": {
        name: "Fruit Snapz",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fruit_spin": {
        name: "Fruit Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "fruit_splash": {
        name: "Fruit Splash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fruit_super_nova": {
        name: "Fruit Super Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_super_nova_100": {
        name: "Fruit Super Nova 100",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_super_nova_30": {
        name: "Fruit Super Nova 30",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_super_nova_40": {
        name: "Fruit Super Nova 40",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_super_nova_60": {
        name: "Fruit Super Nova 60",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruit_super_nova_80": {
        name: "Fruit Super Nova 80",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruitburst": {
        name: "Fruitburst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "fruitillionaire": {
        name: "Fruitillionaire",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "fruitopolis_fortune_play": {
        name: "Fruitopolis Fortune Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fruits_go_bananas": {
        name: "Fruits Go Bananas",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruits_go_pop": {
        name: "Fruits Go Pop!",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fruity_3x3": {
        name: "Fruity 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fruity_fiesta": {
        name: "Fruity Fiesta",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "fruity_flurry": {
        name: "Fruity Flurry",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "fruity_halloween": {
        name: "Fruity Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fruity_hold_and_blitz": {
        name: "Fruity Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruity_mayan": {
        name: "Fruity Mayan",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fruity_megaways": {
        name: "Fruity Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruity_treats": {
        name: "Fruity Treats",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruity_wheel": {
        name: "Fruity Wheel",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "fruity_wilds": {
        name: "Fruity Wilds",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "frutopia": {
        name: "Frutopia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "frutz": {
        name: "Frutz",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fu_er_dai": {
        name: "Fu Er Dai",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fu_fu_fu": {
        name: "Fu Fu Fu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fu_ren_wu": {
        name: "Fu Ren Wu",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "fufu_fa_jp": {
        name: "Fufu Fa JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "fujisan": {
        name: "Fujisan",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "full_moon_fever": {
        name: "Full Moon Fever",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fulong_88": {
        name: "Fulong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "funk_master": {
        name: "Funk Master",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "funkfest_bonanza": {
        name: "Funkfest Bonanza",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "funky_buddha": {
        name: "Funky Buddha",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "funky_fortunez": {
        name: "Funky Fortunez",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "funny_faces_hoglet_moglet": {
        name: "Funny Faces Hoglet Moglet",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "furry_bonanza_megaways": {
        name: "Furry Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fury_fighters": {
        name: "Fury Fighters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "fury_of_anubis": {
        name: "Fury of Anubis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fury_of_odin_megaways": {
        name: "Fury of Odin MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "futebol_fever": {
        name: "Futebol Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "galactic_cash": {
        name: "Galactic Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "galactic_gems": {
        name: "Galactic Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "galaxsys_leaderboard": {
        name: "Galaxsys Leaderboard",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxy_miner": {
        name: "Galaxy Miner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gamblelicious_hold_and_win": {
        name: "Gamblelicious Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "game_of_gladiators": {
        name: "Game of Gladiators",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "game_of_gladiators_uprising": {
        name: "Game of Gladiators: Uprising",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "game_of_thrones_jackpot_king": {
        name: "Game of Thrones Jackpot King",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "game_show_lobby": {
        name: "Game Show Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "game_shows": {
        name: "Game Shows",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "gameshow_party_jackpot_play": {
        name: "Gameshow Party Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ganesha_fortune": {
        name: "Ganesha Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ganesha_gold": {
        name: "Ganesha Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ganesha_lucky": {
        name: "Ganesha Lucky",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "ganesha_shine": {
        name: "Ganesha Shine",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "gangsta_piggy_hold_and_win": {
        name: "Gangsta Piggy Hold and Win",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "gangsters": {
        name: "Gangsters",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "gangsterz": {
        name: "Gangsterz",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gargantoonz": {
        name: "Gargantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gargoyle_infinity_reels": {
        name: "Gargoyle Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "garuda_gems": {
        name: "Garuda Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gates_of_asgard_nine_realms": {
        name: "Gates of Asgard Nine Realms",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "gates_of_aztec": {
        name: "Gates of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca": {
        name: "Gates of Gatot Kaca",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca_1000": {
        name: "Gates of Gatot Kaca 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca_super_scatter": {
        name: "Gates of Gatot Kaca Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_hades": {
        name: "Gates of Hades",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympia": {
        name: "Gates of Olympia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "gates_of_olympus": {
        name: "Gates of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_1000": {
        name: "Gates of Olympus 1,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_dice": {
        name: "Gates of Olympus Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_jackpot_play": {
        name: "Gates of Olympus Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_roulette": {
        name: "Gates of Olympus Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "gates_of_olympus_super_scatter": {
        name: "Gates of Olympus Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_xmas_1000": {
        name: "Gates of Olympus Xmas 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_persia": {
        name: "Gates of Persia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gates_of_power": {
        name: "Gates of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gates_of_pyroth": {
        name: "Gates of Pyroth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_troy": {
        name: "Gates of Troy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gates_of_valhalla": {
        name: "Gates of Valhalla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gatot_kacas_fury": {
        name: "Gatot Kaca's Fury",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gatsby_gold_booster_bar": {
        name: "Gatsby Gold Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "gears_of_horus": {
        name: "Gears of Horus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "geishas_fan": {
        name: "Geisha's Fan",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "geishas_revenge": {
        name: "Geisha's Revenge",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_crush": {
        name: "Gem Crush",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gem_elevator": {
        name: "Gem Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gem_fire_fortune": {
        name: "Gem Fire Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gem_hunter": {
        name: "Gem Hunter",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "gem_hunter_crash": {
        name: "Gem Hunter Crash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "gem_miner": {
        name: "Gem Miner",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "gem_party": {
        name: "Gem Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "gem_princess": {
        name: "Gem Princess",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "gem_rush": {
        name: "Gem Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "gem_saviour": {
        name: "Gem Saviour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_saviour_conquest": {
        name: "Gem Saviour Conquest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_saviour_sword": {
        name: "Gem Saviour Sword",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_splitter": {
        name: "Gem Splitter",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "gem_trio": {
        name: "Gem Trio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gemhalla": {
        name: "Gemhalla",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gemhalla_xtreme": {
        name: "Gemhalla Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gemix": {
        name: "GEMiX",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gemix_100": {
        name: "Gemix 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gemix_2": {
        name: "Gemix 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gempops": {
        name: "GemPOPs",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "gems_bonanza": {
        name: "Gems Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gems_infinity_reels": {
        name: "Gems Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "gems_of_ra": {
        name: "Gems of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "gems_of_serengeti": {
        name: "Gems of Serengeti",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gemstone": {
        name: "Gemstone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gemstones_cascade": {
        name: "Gemstones Cascade",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "gemstones_gold": {
        name: "Gemstones Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gemza": {
        name: "Gemza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "generous_jack": {
        name: "Generous Jack",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "genie_jackpot_combo_frenzy": {
        name: "Genie Jackpot Combo Frenzy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "genie_jackpots_wishmaker": {
        name: "Genie Jackpots Wishmaker",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "genies_3_wishes": {
        name: "Genie's 3 Wishes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "genies_gem_bonanza": {
        name: "Genie's Gem Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "genies_showtime": {
        name: "Genie's Showtime",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "genies_touch": {
        name: "Genies Touch",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "gerards_gambit": {
        name: "Gerard's Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "german_roulette": {
        name: "German Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "get_the_cheese": {
        name: "Get the Cheese",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ghetto_gold": {
        name: "Ghetto Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "ghost_father": {
        name: "Ghost Father",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "ghost_glyph": {
        name: "Ghost Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ghost_harbour": {
        name: "Ghost Harbour",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "ghost_huntin": {
        name: "Ghost Huntin",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "ghost_of_dead": {
        name: "Ghost of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ghost_pirates": {
        name: "Ghost Pirates",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "ghostfather_awakened": {
        name: "Ghostfather Awakened",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "giant_king": {
        name: "Giant King",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "giants_and_sheep": {
        name: "Giants and Sheep",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gift_rush": {
        name: "Gift Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gift_x": {
        name: "Gift X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gifts_of_ostara_scratch": {
        name: "Gifts of Ostara Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "giga_bass_gigablox": {
        name: "Giga Bass GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "giga_jar": {
        name: "Giga Jar",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "gigantoonz": {
        name: "Gigantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ginger_wins_wild_jungle": {
        name: "Ginger Wins: Wild Jungle",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "gingerbread_joy": {
        name: "Gingerbread Joy",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "gingerdead": {
        name: "Gingerdead",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "give_me_the_money": {
        name: "Give Me The Money",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "giza_infinity_reels": {
        name: "Giza Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "gizas_portals": {
        name: "Giza's Portals",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "gladiator_clash": {
        name: "Gladiator Clash",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gladiator_legends": {
        name: "Gladiator Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "gladiator_royal": {
        name: "Gladiator Royal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "gladiators_glory": {
        name: "Gladiator's Glory",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "glam_rock": {
        name: "Glam Rock",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "glamorous_times": {
        name: "Glamorous Times",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gloria_invicta": {
        name: "Gloria Invicta",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "glory_of_rome": {
        name: "Glory Of Rome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "glyph_of_gods": {
        name: "Glyph of Gods",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gnawn_gold": {
        name: "Gnaw'n Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gnomes_and_giants": {
        name: "Gnomes and Giants",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "go_bananas": {
        name: "Go Bananas!",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "go_craps": {
        name: "Go Craps",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "go_for_champion": {
        name: "Go for Champion",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "go_goal_bingo": {
        name: "Go Goal BIngo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "go_panda": {
        name: "Go Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "go_rush": {
        name: "Go Rush",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "goal_blitz": {
        name: "Goal Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "goal_blitz_shootout": {
        name: "Goal Blitz Shootout",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "goal_rush_deluxe": {
        name: "Goal Rush Deluxe",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "goat_getter": {
        name: "Goat Getter",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "goblin_brew": {
        name: "Goblin Brew",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "goblin_grand": {
        name: "Goblin Grand",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "goblin_heist_powernudge": {
        name: "Goblin Heist Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "goblin_run": {
        name: "Goblin Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "goblins_bargain_multimax": {
        name: "Goblin's Bargain MultiMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "god_of_coins": {
        name: "God of Coins",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "god_of_martial": {
        name: "God Of Martial",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "god_of_wealth_hold_and_win": {
        name: "God of Wealth Hold And Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "godbreaker": {
        name: "Godbreaker",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "goddess_of_the_night": {
        name: "Goddess of the Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "goddess_of_the_night_bonus_buy": {
        name: "Goddess of the Night Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "godfather_megaways": {
        name: "Godfather Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "gods_gone_wild": {
        name: "Gods Gone Wild",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "gods_of_asgard_megaways": {
        name: "Gods Of Asgard Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_giza": {
        name: "Gods of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gods_of_glory": {
        name: "Gods of Glory",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "gods_of_gold_infinireels": {
        name: "Gods Of Gold: InfiniReels",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gods_of_olympus_3_megaways": {
        name: "Gods Of Olympus 3 Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_olympus_ii": {
        name: "Gods of Olympus II",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_olympus_iv": {
        name: "Gods of Olympus IV",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_vs_gigablox": {
        name: "Gods VS Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "gold_and_glamour_hold_and_win": {
        name: "Gold and Glamour Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_coins": {
        name: "Gold Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "gold_diggin": {
        name: "Gold Diggin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "gold_diggin_super_spinner": {
        name: "Gold Diggin’ Super Spinner",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "gold_dragon": {
        name: "Gold Dragon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "gold_express": {
        name: "Gold Express",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "gold_fever": {
        name: "Gold Fever",
        provider: "Solvited",
        providerSlug: "solvited"
    },
    "gold_gold_gold": {
        name: "Gold Gold Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_gold_gold_5000": {
        name: "Gold Gold Gold 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_gold_gold_hold_and_win": {
        name: "Gold Gold Gold Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_is_all_mine_10k_ways": {
        name: "Gold is All Mine 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "gold_king": {
        name: "Gold King",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_koi_fortune": {
        name: "Gold Koi Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "gold_magnate": {
        name: "Gold Magnate",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_mine_rush": {
        name: "Gold Mine Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "gold_n_spin": {
        name: "Gold n Spin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "gold_nuggets": {
        name: "Gold Nuggets",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "gold_oasis": {
        name: "Gold Oasis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_of_fortune_god": {
        name: "Gold of Fortune God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_of_minos": {
        name: "Gold of Minos",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_of_sirens": {
        name: "Gold of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "gold_of_sirens_bonus_buy": {
        name: "Gold of Sirens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "gold_of_the_king": {
        name: "Gold of the King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "gold_party": {
        name: "Gold Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_party_2_after_hours": {
        name: "Gold Party 2 After Hours",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_roulette": {
        name: "Gold Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "gold_rush": {
        name: "Gold Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_rush_frenzy_megaways": {
        name: "Gold Rush Frenzy Megaways",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "gold_rush_johnny_cash": {
        name: "Gold Rush - Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_rush_scratch_500000": {
        name: "Gold Rush Scratch 500,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_rush_with_johnny_cash": {
        name: "Gold Rush with Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_silver_diamond": {
        name: "Gold Silver Diamond",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "gold_strike": {
        name: "Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_2": {
        name: "Gold Strike 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_bonanza": {
        name: "Gold Strike Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_express": {
        name: "Gold Strike Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_train": {
        name: "Gold Train",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "gold_trophy_2": {
        name: "Gold Trophy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_volcano": {
        name: "Gold Volcano",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_x": {
        name: "Gold X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "golden_avalanche": {
        name: "Golden Avalanche",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_avalon_hold_and_win": {
        name: "Golden Avalon Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_bank": {
        name: "Golden Bank",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_bank_2": {
        name: "Golden Bank 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_beauty": {
        name: "Golden Beauty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "golden_buffalo_rush": {
        name: "Golden Buffalo Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_caravan": {
        name: "Golden Caravan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_castle_titanways": {
        name: "Golden Castle TitanWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "golden_chase_booster_bar": {
        name: "Golden Chase Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "golden_colts": {
        name: "Golden Colts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_dragon_ii": {
        name: "Golden Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_egg": {
        name: "Golden Egg",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "golden_egg_invaders": {
        name: "Golden Egg Invaders",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "golden_egg_of_crazy_chicken": {
        name: "Golden Egg of Crazy Chicken",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "golden_egg_of_crazy_chicken_ccs": {
        name: "Golden Egg of Crazy Chicken CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "golden_egypt": {
        name: "Golden Egypt",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_elephant": {
        name: "Golden Elephant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "golden_empire": {
        name: "Golden Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_empire_2": {
        name: "Golden Empire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_gals": {
        name: "Golden Gal's",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_gals_3_reels": {
        name: "Golden Gal's 3 Reels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_gals_cash_towers": {
        name: "Golden Gal's Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_gals_hen_hunt": {
        name: "Golden Gals Hen Hunt",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_glyph": {
        name: "Golden Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_glyph_2": {
        name: "Golden Glyph 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_glyph_3": {
        name: "Golden Glyph 3",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_grimoire": {
        name: "Golden Grimoire",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "golden_horn": {
        name: "Golden Horn",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_joker": {
        name: "Golden Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_kitty": {
        name: "Golden Kitty",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "golden_koi": {
        name: "Golden Koi",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "golden_land": {
        name: "Golden Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_legend": {
        name: "Golden Legend",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_mouse": {
        name: "Golden Mouse",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_mouse_3": {
        name: "Golden Mouse 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_osiris": {
        name: "Golden Osiris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_ox": {
        name: "Golden Ox",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "golden_panda": {
        name: "Golden Panda",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "golden_paw_hold_and_win": {
        name: "Golden Paw Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_pig": {
        name: "Golden Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "golden_pinata_hold_and_win": {
        name: "Golden Pinata Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_pride": {
        name: "Golden Pride",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_queen": {
        name: "Golden Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_ra": {
        name: "Golden Ra",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "golden_realms": {
        name: "Golden Realms",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "golden_sabre": {
        name: "Golden Sabre",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "golden_scrolls": {
        name: "Golden Scrolls",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "golden_sea": {
        name: "Golden Sea",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_sphinx": {
        name: "Golden Sphinx",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "golden_taj_mahal": {
        name: "Golden Taj Mahal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "golden_teapot": {
        name: "Golden Teapot",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "golden_temple": {
        name: "Golden Temple",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_ticket": {
        name: "Golden Ticket",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_ticket_2": {
        name: "Golden Ticket 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_touch": {
        name: "Golden Touch",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "golden_treasure": {
        name: "Golden Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_treasure_lightning": {
        name: "Golden Treasure Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "golden_triad": {
        name: "Golden Triad",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "golden_try": {
        name: "Golden Try",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "golden_unicorn": {
        name: "Golden Unicorn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "golden_unicorn_deluxe": {
        name: "Golden Unicorn Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "golden_wheels_of_egypt": {
        name: "Golden Wheels of Egypt",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "goldilocks": {
        name: "Goldilocks",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "goldstar_express": {
        name: "Goldstar Express",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "goldwins": {
        name: "GoldWins",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "golfing_glory": {
        name: "Golfing Glory",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "gonzos_gold": {
        name: "Gonzo's Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gonzos_quest": {
        name: "Gonzo's Quest",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gonzos_quest_2_return_to_el_dorado": {
        name: "Gonzo's Quest 2 Return to El Dorado",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "good_luck_40": {
        name: "Good Luck 40",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "good_luck_and_good_fortune": {
        name: "Good Luck and Good Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "good_luck_money": {
        name: "Good Luck Money",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "good_luck_spell": {
        name: "Good Luck Spell",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "good_old_7s": {
        name: "Good Old 7's",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gordon_ramsay_hells_kitchen": {
        name: "Gordon Ramsay Hell’s Kitchen",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gorilla_gold_megaways_power_4_slots": {
        name: "Gorilla Gold Megaways: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gorilla_kingdom": {
        name: "Gorilla Kingdom",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "gorilla_mayhem": {
        name: "Gorilla Mayhem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "grab_more_gold": {
        name: "Grab more Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "grab_the_gold": {
        name: "Grab the Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "grace_of_ebisu": {
        name: "Grace of Ebisu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "graffiti_rush": {
        name: "Graffiti Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "grand": {
        name: "Grand",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "grand_ahoy": {
        name: "Grand Ahoy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "grand_buffalo_hold_and_win": {
        name: "Grand Buffalo Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grand_mustang": {
        name: "Grand Mustang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grand_ocean_megaways": {
        name: "Grand Ocean Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "grand_patron": {
        name: "Grand Patron",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grand_spinn": {
        name: "Grand Spinn",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "grannys_wild": {
        name: "Granny's Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gravity_bonanza": {
        name: "Gravity Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_beauties_of_china": {
        name: "Great Beauties of China",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "great_book_of_magic": {
        name: "Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "great_book_of_magic_deluxe": {
        name: "Great Book of Magic Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "great_game_rockies": {
        name: "Great Game Rockies",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "great_ghosts": {
        name: "Great Ghosts!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_grizzly": {
        name: "Great Grizzly",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "great_lagoon": {
        name: "Great Lagoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_luck": {
        name: "Great Luck",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "great_reef": {
        name: "Great Reef",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino": {
        name: "Great Rhino",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino_deluxe": {
        name: "Great Rhino Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino_megaways": {
        name: "Great Rhino MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_warrior": {
        name: "Great Warrior",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "greedy_alice": {
        name: "Greedy Alice",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "greedy_for_gold_hold_and_win": {
        name: "Greedy for Gold: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "greedy_for_gold_power_hit": {
        name: "Greedy for Gold Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "greedy_fortune_pig": {
        name: "Greedy Fortune Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greedy_wolf": {
        name: "Greedy Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greek_goddess_siege_of_olympus_megaways": {
        name: "Greek Goddess: Siege of Olympus Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "greek_gods": {
        name: "Greek Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greek_legends": {
        name: "Greek Legends",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "greek_roulette": {
        name: "Greek Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "green_chilli": {
        name: "Green Chilli",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "green_chilli_2": {
        name: "Green Chilli 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "grim_muerto": {
        name: "Grim Muerto",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "grimms_bounty_hanset_and_gretel": {
        name: "Grimms Bounty Hanset and Gretel",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "grinning_harvest": {
        name: "Grinning Harvest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "grizzly_strike": {
        name: "Grizzly Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "grizzly_strike_lucky_cache": {
        name: "Grizzly Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gronks_gems": {
        name: "Gronk's Gems",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "grug_make_fire": {
        name: "Grug Make Fire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "guardian_of_athens": {
        name: "Guardian of athens",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "guardians_of_glory": {
        name: "Guardians of Glory",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "guardians_of_ice_and_fire": {
        name: "Guardians of Ice and Fire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "guitar_quest": {
        name: "Guitar Quest",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gun_powder": {
        name: "Gun Powder",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "guns_n_roses_video_slots": {
        name: "Guns N' Roses video Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "hades_river_of_souls": {
        name: "Hades: River of Souls",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "hall_of_the_mountain_king": {
        name: "Hall of the Mountain King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "halloween_bonanza": {
        name: "Halloween Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "halloween_ghost": {
        name: "Halloween Ghost",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "halloween_horrors_megaways": {
        name: "Halloween Horrors Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "halloween_jack": {
        name: "Halloween Jack",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "halloween_queen": {
        name: "Halloween Queen",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "hammer_of_gods": {
        name: "Hammer of Gods",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "hammer_of_vulcan": {
        name: "Hammer of Vulcan",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hammerstorm": {
        name: "Hammerstorm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hamster_mania": {
        name: "Hamster Mania",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "hand_of_anubis": {
        name: "Hand of Anubis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hand_of_midas_2": {
        name: "Hand of Midas 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "happiest_christmas_tree": {
        name: "Happiest Christmas Tree",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happily_ever_after": {
        name: "Happily Ever After",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "happily_ever_after_once_upon_a_multiplier_94": {
        name: "Happily Ever After Once Upon a Multiplier 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "happy_ape": {
        name: "Happy Ape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happy_bamboo": {
        name: "Happy Bamboo",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "happy_fishing": {
        name: "Happy Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "happy_fortune": {
        name: "Happy Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "happy_halloween": {
        name: "Happy Halloween",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "happy_hatchlings": {
        name: "Happy Hatchlings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happy_holidays": {
        name: "Happy Holidays",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "happy_lucky": {
        name: "Happy Lucky",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "happy_riches": {
        name: "Happy Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "happy_scratch": {
        name: "Happy Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "happy_taxi": {
        name: "Happy Taxi",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "hard_cash": {
        name: "Hard Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "hard_eight_poker": {
        name: "Hard Eight Poker",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "harvest_wilds": {
        name: "Harvest Wilds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "haunted_coins_x1000": {
        name: "Haunted Coins x1000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "haunted_crypt": {
        name: "Haunted Crypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "haunted_harbor": {
        name: "Haunted Harbor",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "haunted_hospital": {
        name: "Haunted Hospital",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "haunted_house": {
        name: "Haunted House",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "haunted_reels": {
        name: "Haunted Reels",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hawaii_beauty": {
        name: "Hawaii Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "hawaii_fever": {
        name: "Hawaii Fever",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hawaiian_diva": {
        name: "Hawaiian Diva",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream": {
        name: "Hawaiian Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_gold": {
        name: "Hawaiian Dream GOLD",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_jackpot": {
        name: "Hawaiian Dream Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_xmas": {
        name: "Hawaiian Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_tiki": {
        name: "Hawaiian Tiki",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hazakura_ways": {
        name: "Hazakura Ways",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "headhunter": {
        name: "Headhunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "heads_and_tails": {
        name: "Heads and Tails",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "heads_and_tails_xy": {
        name: "Heads and Tails XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "heart_of_africa_lion_way": {
        name: "Heart of Africa: Lion Way",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "heart_of_cleopatra": {
        name: "Heart of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heart_of_rio": {
        name: "Heart of Rio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heart_of_tiki": {
        name: "Heart of Tiki",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "heartbreakers": {
        name: "Heartbreakers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hearts_highway": {
        name: "Hearts Highway",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "heist_for_the_golden_nuggets": {
        name: "Heist for the Golden Nuggets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heist_stakes": {
        name: "Heist Stakes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "heliopopolis": {
        name: "HelioPOPolis",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "helios_fury": {
        name: "Helios' Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hell_butcher": {
        name: "Hell Butcher",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hellcatraz": {
        name: "Hellcatraz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hellfire": {
        name: "Hellfire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "hells_hogs": {
        name: "Hell's Hogs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "hells_hogs_2_squealin_wheels": {
        name: "Hell's Hogs 2 Squealin' Wheels",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "hellvis_wild": {
        name: "Hellvis Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "henry_the_ape": {
        name: "Henry the Ape",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "hercules_10k_ways": {
        name: "Hercules 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "hercules_and_pegasus": {
        name: "Hercules and Pegasus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hercules_son_of_zeus": {
        name: "Hercules Son of Zeus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hercules_sports_legend": {
        name: "Hercules: Sports Legend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "heroes_gathering": {
        name: "Heroes Gathering",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "heroes_hunt_2": {
        name: "Heroes Hunt 2",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "heroes_hunt_megaways": {
        name: "Heroes Hunt MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "heroic_spin": {
        name: "Heroic Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heroic_spins": {
        name: "Heroic Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hex": {
        name: "Hex",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hey_fu_cai": {
        name: "Hey Fu Cai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "hey_sushi": {
        name: "Hey Sushi",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hi_lo": {
        name: "Hi Lo",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "hidden_city": {
        name: "Hidden City",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "hidden_valley_120": {
        name: "Hidden Valley 120",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "high_flyer": {
        name: "High Flyer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "high_low": {
        name: "High Low",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "high_street_heist": {
        name: "High Street Heist",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "high_striker": {
        name: "High Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "high_up": {
        name: "High UP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "highschool_manga": {
        name: "Highschool Manga",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "highway_legends": {
        name: "Highway Legends",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "highway_to_hell": {
        name: "Highway To Hell",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "highway_to_hell_deluxe": {
        name: "Highway to Hell Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hikaru_super_live_bazooka": {
        name: "Hikaru Super Live BAZOOKA",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hillbilly_vegas": {
        name: "Hillbilly Vegas",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "hilo": {
        name: "HILO",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "hilo_baccarat": {
        name: "Hi-Lo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "himalayan_wild": {
        name: "Himalayan Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hip_hop_panda": {
        name: "Hip Hop Panda",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hiphop_pop": {
        name: "Hip-Hop Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "hippo_pop": {
        name: "Hippo Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "hit_mahjong_wins": {
        name: "Hit Mahjong Wins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "hit_more_gold": {
        name: "Hit more Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "hit_the_gold": {
        name: "Hit the Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "hit_the_route": {
        name: "Hit The Route",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ho_ho_ho": {
        name: "Ho Ho Ho",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "hockey_attack": {
        name: "Hockey Attack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hockey_shootout": {
        name: "Hockey Shootout",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hocus_pocus_sorcery": {
        name: "Hocus Pocus Sorcery",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hokkaido_wolf": {
        name: "Hokkaido Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "holi_hai": {
        name: "Holi Hai",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "holiday_ride": {
        name: "Holiday Ride",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "holiday_season": {
        name: "Holiday Season",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "holiday_spirits": {
        name: "Holiday Spirits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "holly_jolly_bonanza": {
        name: "Holly Jolly Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holly_jolly_bonanza_2": {
        name: "Holly Jolly Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holly_jolly_cash_pig": {
        name: "Holly Jolly Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holy_hand_grenade": {
        name: "Holy Hand Grenade",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "holy_hand_grenade_2": {
        name: "Holy Hand Grenade 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "holy_knight": {
        name: "Holy Knight",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "honey_honey_honey": {
        name: "Honey Honey Honey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "honey_hunters": {
        name: "Honey Hunters",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "honey_rush": {
        name: "Honey Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_rush_100": {
        name: "Honey Rush 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_rush_black_and_yellow": {
        name: "Honey Rush Black and Yellow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_trap_of_diao_chan": {
        name: "Honey Trap of Diao Chan",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "honeylocks_pots": {
        name: "Honeylocks Pots",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hood_vs_wolf": {
        name: "Hood vs Wolf",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hook_the_fortune": {
        name: "Hook the Fortune",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hooks_heroes": {
        name: "Hook's Heroes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "hooligan_hustle": {
        name: "Hooligan Hustle",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hope_unleashed_fortune_reels": {
        name: "Hope Unleashed Fortune Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "horror_hotel": {
        name: "Horror Hotel",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "horse_trio_bonus": {
        name: "Horse Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "horseshoe": {
        name: "Horseshoe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "hot_777": {
        name: "Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_777_deluxe": {
        name: "Hot 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_blizzard": {
        name: "Hot Blizzard",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hot_blizzard_deluxe": {
        name: "Hot Blizzard Deluxe",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hot_charge": {
        name: "Hot Charge",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "hot_chilli": {
        name: "Hot Chilli",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_chilli_bells": {
        name: "Hot Chilli Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_chilli_bells_100": {
        name: "Hot Chilli Bells 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_dog_heist": {
        name: "Hot Dog Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hot_fiesta": {
        name: "Hot Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_fire_fruits": {
        name: "Hot Fire Fruits",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "hot_gear": {
        name: "Hot Gear",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "hot_heads": {
        name: "Hot Heads",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "hot_hot_fruit": {
        name: "Hot Hot Fruit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_hot_halloween": {
        name: "Hot Hot Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_hot_summer": {
        name: "Hot Hot Summer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_joker_fruits": {
        name: "Hot Joker Fruits",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "hot_joker_fruits_20": {
        name: "Hot Joker Fruits 20",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "hot_joker_fruits_hold_and_win": {
        name: "Hot Joker Fruits Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "hot_joker_fruits_scatter_pays": {
        name: "Hot Joker Fruits Scatter Pays",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "hot_joker_fruits_stacks": {
        name: "Hot Joker Fruits Stacks",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "hot_mania": {
        name: "Hot Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_party": {
        name: "Hot Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_party_deluxe": {
        name: "Hot Party Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_pepper": {
        name: "Hot Pepper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_rio_nights": {
        name: "Hot Rio Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_rio_nights_bonus_buy": {
        name: "Hot Rio Nights Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_rio_samba": {
        name: "Hot Rio Samba",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_rocket_5x_3x_2x": {
        name: "Hot Rocket 5x 3x 2x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_rod_racers": {
        name: "Hot Rod Racers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hot_ross": {
        name: "Hot Ross",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hot_safari": {
        name: "Hot Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_safari_run": {
        name: "Hot Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "hot_safari_scratch_75000": {
        name: "Hot Safari Scratch 75,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_slice": {
        name: "Hot Slice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_slot_777_cash_out": {
        name: "Hot Slot: 777 Cash Out",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_extremely_light": {
        name: "Hot Slot: 777 Cash Out Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_diamond_edition": {
        name: "Hot Slot: 777 Cash Out Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_gold_edition": {
        name: "Hot Slot: 777 Cash Out Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_platinum_edition": {
        name: "Hot Slot: 777 Cash Out Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_coins_extremely_light": {
        name: "Hot Slot 777 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_crown": {
        name: "Hot Slot: 777 Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_crown_extremely_light": {
        name: "Hot Slot: 777 Crown Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_diamond_crown": {
        name: "Hot Slot 777 Diamond Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_gold_crown": {
        name: "Hot Slot 777 Gold Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_hold_the_jackpot": {
        name: "Hot Slot 777 Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_platinum_crown": {
        name: "Hot Slot 777 Platinum Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_rubies": {
        name: "Hot Slot: 777 Rubies",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_rubies_extremely_light": {
        name: "Hot Slot: 777 Rubies Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_stars": {
        name: "Hot Slot: 777 Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_diamond_coins": {
        name: "Hot Slot Diamond Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_gold_coins": {
        name: "Hot Slot Gold Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_great_book_of_magic": {
        name: "Hot Slot: Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_magic_bombs": {
        name: "Hot Slot: Magic Bombs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_magic_pearls": {
        name: "Hot Slot: Magic Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_mystery_jackpot_joker": {
        name: "Hot Slot: Mystery Jackpot Joker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_platinum_coins": {
        name: "Hot Slot Platinum Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_sync": {
        name: "Hot Sync",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hot_to_burn": {
        name: "Hot to Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_7_deadly_free_spins": {
        name: "Hot to Burn 7 Deadly Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_extreme": {
        name: "Hot to Burn Extreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_hold_and_spin": {
        name: "Hot to Burn Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_jackpot_play": {
        name: "Hot to Burn Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_multiplier": {
        name: "Hot to Burn Multiplier",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_triple_sevens": {
        name: "Hot Triple Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_triple_sevens_hold_and_win": {
        name: "Hot Triple Sevens Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_triple_sevens_special": {
        name: "Hot Triple Sevens Special",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_tuna": {
        name: "Hot Tuna",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_volcano": {
        name: "Hot Volcano",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hot_volcano_bonus_buy": {
        name: "Hot Volcano Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hotel_yetiway": {
        name: "Hotel Yeti-Way",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hotline": {
        name: "Hotline",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "hotline_2": {
        name: "Hotline 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "hotnfruity": {
        name: "Hot'n'Fruity",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hotpot": {
        name: "Hotpot",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hottest_666": {
        name: "Hottest 666",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hotties_paradise": {
        name: "Hottie's Paradise",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "hotties_vacation": {
        name: "Hottie's Vacation",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "house_of_doom": {
        name: "House of Doom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "house_of_doom_2_the_crypt": {
        name: "House of Doom 2: The Crypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "howling_for_gold": {
        name: "Howling for Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "howling_inferno_hold_and_win_3x3": {
        name: "Howling Inferno Hold and Win 3x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "howling_inferno_hold_and_win_5x3": {
        name: "Howling Inferno Hold and Win 5x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "howling_wolves_megaways": {
        name: "Howling Wolves Megaways",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "hundreds_and_thousands": {
        name: "Hundreds and Thousands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hungry_night": {
        name: "Hungry Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "hungry_shark": {
        name: "Hungry Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hungry_wolf": {
        name: "Hungry Wolf",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "hunters_moon": {
        name: "Hunters Moon",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "hunters_moon_gigablox": {
        name: "Hunters Moon Gigablox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "huntress_wild_vengeance": {
        name: "Huntress Wild Vengeance",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "hyper_burst": {
        name: "Hyper Burst",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "hyper_hues": {
        name: "Hyper Hues",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hyper_respins": {
        name: "Hyper Respins",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "hyperbars": {
        name: "Hyperbars",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "hypernova_10k_ways": {
        name: "Hypernova 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "hypernova_infinity_reels": {
        name: "Hypernova Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "hypernova_megaways": {
        name: "Hypernova Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "hypernova_radial_reels": {
        name: "Hypernova Radial Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "icarus_wilds": {
        name: "Icarus Wilds",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "ice_joker": {
        name: "Ice Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ice_lobster": {
        name: "Ice Lobster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ice_mania": {
        name: "Ice Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ice_mint": {
        name: "Ice Mint",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ice_queen": {
        name: "Ice Queen",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "ice_scratch_bronze": {
        name: "Ice Scratch Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ice_scratch_gold": {
        name: "Ice Scratch Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ice_scratch_silver": {
        name: "Ice Scratch Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "idol_of_fortune": {
        name: "Idol of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "idol_pop_fever": {
        name: "Idol Pop Fever",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ignis_rex": {
        name: "Ignis Rex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ignite_the_night": {
        name: "Ignite the Night",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "illuminous": {
        name: "Illuminous",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "immersive_roulette_deluxe": {
        name: "Immersive Roulette Deluxe",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "immortails_of_egypt": {
        name: "Immortails of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "immortal_5": {
        name: "Immortal 5",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "imperial_coins": {
        name: "Imperial Coins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "imperial_opera": {
        name: "Imperial Opera",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "imperial_relics_three_pots": {
        name: "Imperial Relics Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "in_and_out": {
        name: "In and Out",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "in_the_forest": {
        name: "In the Forest",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "inca_queen": {
        name: "Inca Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "incan_wonders": {
        name: "Incan Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "incas_treasure": {
        name: "Inca's Treasure",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "indi": {
        name: "Indi",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "indian_cash_catcher": {
        name: "Indian Cash Catcher",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "indian_fortune": {
        name: "Indian Fortune",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "indiana_wolf": {
        name: "Indiana Wolf",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "indianas_quest": {
        name: "Indiana's Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "indonesia_roulette": {
        name: "Indonesia Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "indonesian_blackjackx": {
        name: "Indonesian BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "indonesian_roulette": {
        name: "Indonesian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "indonesian_speed_baccarat": {
        name: "Indonesian Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "infective_wild": {
        name: "Infective Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "infernal_fury": {
        name: "Infernal Fury",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "inferno_fortune": {
        name: "Inferno Fortune",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "inferno_fortune_instastrike": {
        name: "Inferno Fortune InstaStrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "inferno_fortune_power_hit": {
        name: "Inferno Fortune Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "inferno_joker": {
        name: "Inferno Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "inferno_mayhem": {
        name: "Inferno Mayhem",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "inferno_star": {
        name: "Inferno Star",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "infinite_x": {
        name: "Infinite X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "infinity": {
        name: "Infinity",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "infinity_hero": {
        name: "Infinity Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "infinity_pull": {
        name: "Infinity Pull",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "inner_fire": {
        name: "Inner Fire",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "inner_fire_bonus_buy": {
        name: "Inner Fire Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "inspector_wilds": {
        name: "Inspector Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "instant_bingo": {
        name: "Instant Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "instant_keno": {
        name: "Instant Keno",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "instant_soccer": {
        name: "Instant Soccer",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "instawin": {
        name: "Instawin",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "invading_vegas": {
        name: "Invading Vegas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invading_vegas_las_christmas": {
        name: "Invading Vegas: Las Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invading_vegas_revenge_on_mars": {
        name: "Invading Vegas Revenge on Mars",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invictus": {
        name: "Invictus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "irich_bingo": {
        name: "iRich Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "irish_charms": {
        name: "Irish Charms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "irish_crown": {
        name: "Irish Crown",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "irish_gold": {
        name: "Irish Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "irish_pot_luck": {
        name: "Irish Pot Luck",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "irish_pots_multimax": {
        name: "Irish Pots Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "irish_reels": {
        name: "Irish Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "irish_weekend": {
        name: "Irish Weekend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "irish_weekend_bonus_buy": {
        name: "Irish Weekend Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "iron_bank": {
        name: "Iron Bank",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "iron_bank_2": {
        name: "Iron Bank 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "iron_girl": {
        name: "Iron Girl",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "iron_phoenix": {
        name: "Iron Phoenix",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "isibaya_queens": {
        name: "Isibaya Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "island_ices": {
        name: "Island Ices",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "italia_3x3": {
        name: "Italia 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "italian_mega_roulette": {
        name: "Italian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "itero": {
        name: "Itero",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "its_alive": {
        name: "It's Alive",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "its_bananas": {
        name: "It's Bananas!",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "its_time": {
        name: "It's Time",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "ivan_and_the_immortal_king": {
        name: "Ivan and the Immortal King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "jack_and_the_beanstalk_remastered": {
        name: "Jack and the Beanstalk Remastered",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jack_and_the_giant": {
        name: "Jack and the Giant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jack_frosts_winter": {
        name: "Jack Frost's Winter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jack_hammer": {
        name: "Jack Hammer",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jack_hammer_2_fishy_business": {
        name: "Jack Hammer 2: Fishy Business",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jack_hammer_3_diamond_affair": {
        name: "Jack Hammer 3: Diamond Affair",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jack_hammer_4_chasing_the_dragon": {
        name: "Jack Hammer 4: Chasing the Dragon",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jack_on_hold": {
        name: "Jack on Hold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jack_the_giant_hunter": {
        name: "Jack the Giant Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jack_win": {
        name: "Jack win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jackmaster_fruits": {
        name: "Jackmaster Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jackpot_3x3": {
        name: "Jackpot 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jackpot_bingo": {
        name: "Jackpot Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jackpot_blaze": {
        name: "Jackpot Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jackpot_builders": {
        name: "Jackpot Builders",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jackpot_fishing": {
        name: "Jackpot Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jackpot_fishing_2_shoot_and_win": {
        name: "Jackpot Fishing 2 Shoot and Win",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jackpot_football": {
        name: "Jackpot Football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jackpot_hits": {
        name: "Jackpot Hits",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jackpot_hunter": {
        name: "Jackpot Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jackpot_joker": {
        name: "Jackpot Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jackpot_joker_fever": {
        name: "Jackpot Joker Fever",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jacks_beanstalk_bonanza": {
        name: "Jack's Beanstalk Bonanza",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "jacks_or_better_1_hand": {
        name: "Jacks or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jacks_or_better_10_hand": {
        name: "Jacks or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jacks_or_better_100_hand": {
        name: "Jacks or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jacks_or_better_5_hand": {
        name: "Jacks or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jacks_or_better_50_hand": {
        name: "Jacks or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jacks_or_better_double_up": {
        name: "Jacks or Better Double Up",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jacks_ride": {
        name: "Jack's Ride",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jade_butterfly": {
        name: "Jade Butterfly",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jade_magician": {
        name: "Jade Magician",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jaguar_drop": {
        name: "Jaguar Drop",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "jaguar_super_ways": {
        name: "Jaguar Super Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "jam_bonanza": {
        name: "Jam Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jam_crush": {
        name: "Jam Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "jammin_jars": {
        name: "Jammin' Jars",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "jammin_jars_2": {
        name: "Jammin' Jars 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "jane_hunter_and_the_mask_of_montezuma": {
        name: "Jane Hunter and the Mask of Montezuma",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "japanese_mask": {
        name: "Japanese Mask",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "japanese_speed_baccarat": {
        name: "Japanese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "jasmine_dreams": {
        name: "Jasmine Dreams",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jaws_of_justice": {
        name: "Jaws of Justice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "jeepney_scatter": {
        name: "Jeepney Scatter",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "jekyllz_wild_ultranudge": {
        name: "Jekyllz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "jelly_belly_megaways": {
        name: "Jelly Belly Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jelly_boom": {
        name: "Jelly Boom",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jelly_express": {
        name: "Jelly Express",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jelly_reels": {
        name: "Jelly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jelly_slice": {
        name: "Jelly Slice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "jellyfish_flow": {
        name: "Jellyfish Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jellyfish_flow_ultra": {
        name: "Jellyfish Flow Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jesters_bells_bonanza": {
        name: "Jester's Bells Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jesters_riches": {
        name: "Jesters Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jesters_wilds": {
        name: "Jesters Wilds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jewel_boom_super_drop": {
        name: "Jewel Boom Super Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jewel_box": {
        name: "Jewel Box",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jewel_of_athena": {
        name: "Jewel of Athena",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jewel_rush": {
        name: "Jewel Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jewelling_diamonds": {
        name: "Jewelling Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jewelry_spin": {
        name: "Jewelry Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "jewels_of_prosperity": {
        name: "Jewels of Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jhana_of_god": {
        name: "Jhana of God",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jhana_of_god_bonus_buy": {
        name: "Jhana of God Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jhana_of_god_scratch": {
        name: "Jhana of God: Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jhandi_munda": {
        name: "Jhandi Munda",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "jili_caishen": {
        name: "JILI CAISHEN",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jimi_hendrix_online_slot": {
        name: "Jimi Hendrix Online Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jingle_bells_bonanza": {
        name: "Jingle Bells Bonanza",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jingle_spin": {
        name: "Jingle Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jingle_up": {
        name: "Jingle Up",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "jinglepop": {
        name: "JinglePOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jogo_do_bicho": {
        name: "Jogo do Bicho",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jogo_do_bicho_simple": {
        name: "Jogo Do Bicho Simple",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "john_hunter_and_galileos_secrets": {
        name: "John Hunter and Galileo's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_aztec_treasure": {
        name: "John Hunter and the Aztec Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut": {
        name: "John Hunter and the Book of Tut",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut_jackpot_play": {
        name: "John Hunter and the Book of Tut Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut_megaways": {
        name: "John Hunter and the Book of Tut Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut_respin": {
        name: "John Hunter and the Book of Tut Respin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_mayan_gods": {
        name: "John Hunter and the Mayan Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_quest_for_bermuda_riches": {
        name: "John Hunter and the Quest for Bermuda Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_tomb_of_the_scarab_queen": {
        name: "John Hunter and the Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_tomb_of_the_scarab_queen": {
        name: "John Hunter - Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "johnan_legendarian": {
        name: "Johnan Legendarian",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "johnny_cash": {
        name: "Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_bombs": {
        name: "Joker Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "joker_coins": {
        name: "Joker Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "joker_explosion": {
        name: "Joker Explosion",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "joker_flip": {
        name: "Joker Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "joker_glitz_x1000": {
        name: "Joker Glitz x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "joker_jackpots": {
        name: "Joker Jackpots",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "joker_jane": {
        name: "Joker Jane",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "joker_jewels_dice": {
        name: "Joker Jewels Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_king": {
        name: "Joker King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_poker": {
        name: "Joker Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "joker_poker_1_hand": {
        name: "Joker Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "joker_poker_10_hand": {
        name: "Joker Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "joker_poker_100_hand": {
        name: "Joker Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "joker_poker_5_hand": {
        name: "Joker Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "joker_poker_50_hand": {
        name: "Joker Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "joker_pro": {
        name: "Joker Pro",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "joker_queen": {
        name: "Joker Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_race": {
        name: "Joker Race",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_reelz": {
        name: "Joker Reelz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "joker_split": {
        name: "Joker Split",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "joker_strike": {
        name: "Joker Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "joker_super_reels": {
        name: "Joker Super Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "joker_troupe": {
        name: "Joker Troupe",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "joker_vs_joker": {
        name: "Joker vs Joker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_x_love": {
        name: "Joker X Love",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jokers_bar": {
        name: "Joker's Bar",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "jokers_dice": {
        name: "Joker’s Dice",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "jokers_edge": {
        name: "Joker's Edge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "jokers_jewel_hot": {
        name: "Joker's Jewel Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels": {
        name: "Joker's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_cash": {
        name: "Joker's Jewels Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_hold_and_spin": {
        name: "Joker's Jewels Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_hot": {
        name: "Joker's Jewels Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_jackpot_play": {
        name: "Joker's Jewels Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_wild": {
        name: "Joker's Jewels Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_million": {
        name: "Joker's Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jokers_revenge": {
        name: "Joker's Revenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokersontop": {
        name: "JokersOnTop",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jokrz_wild_ultranudge": {
        name: "Jokrz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "jokrz_wild_ultranudge_gigablox": {
        name: "Jokrz Wild Ultranudge GigaBlox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "jolly_bonus_wins": {
        name: "Jolly Bonus Wins",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jolly_casino": {
        name: "Jolly casino",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jolly_roger": {
        name: "Jolly Roger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jolly_roger_2": {
        name: "Jolly Roger 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jolly_roger_wild_kraken": {
        name: "Jolly Roger Wild Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jolly_treasures": {
        name: "Jolly Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "jolt_circuit": {
        name: "Jolt Circuit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "journey_to_paris": {
        name: "Journey to Paris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "journey_to_the_abyss": {
        name: "Journey to the Abyss",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "journey_to_the_gold": {
        name: "Journey to the Gold",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "journey_to_the_wealth": {
        name: "Journey to the Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "journey_to_the_west": {
        name: "Journey to the West",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "journey_west_m": {
        name: "Journey West M",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jugglenaut": {
        name: "Jugglenaut",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "juice_trio_bonus": {
        name: "J.U.I.C.E Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "juiced_duomax": {
        name: "Juiced Duomax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "juicy_explosion": {
        name: "Juicy Explosion",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "juicy_fruit_coins_hold_and_win": {
        name: "Juicy Fruit Coins Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "juicy_fruits": {
        name: "Juicy Fruits",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "juicy_fruits_multihold": {
        name: "Juicy Fruits Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "juicy_gems": {
        name: "Juicy Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "juicy_gems_bonus_buy": {
        name: "Juicy Gems Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "juicy_joker": {
        name: "Juicy Joker",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "juicy_reels": {
        name: "Juicy Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "juicypop": {
        name: "JuicyPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jumanji": {
        name: "Jumanji",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jumbo_jellies": {
        name: "Jumbo Jellies",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "jumbo_juicy": {
        name: "Jumbo Juicy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "jumbo_safari": {
        name: "Jumbo Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jump": {
        name: "Jump!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jump_2": {
        name: "Jump! 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jumping_frog": {
        name: "Jumping Frog",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "jumping_fruits": {
        name: "Jumping Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jungle_delight": {
        name: "Jungle Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jungle_fever_reel_triple": {
        name: "Jungle Fever Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jungle_fever_super_reels": {
        name: "Jungle Fever Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jungle_fever_v2_reel_bingo": {
        name: "Jungle Fever V2 Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jungle_fortune_build_your_bonus": {
        name: "Jungle Fortune Build Your Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "jungle_gorilla": {
        name: "Jungle Gorilla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jungle_hunt": {
        name: "Jungle Hunt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jungle_jango": {
        name: "Jungle Jango",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "jungle_jive_v2_snakes_and_ladders": {
        name: "Jungle Jive V2 Snakes and Ladders",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "jungle_king": {
        name: "Jungle King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jungle_pop": {
        name: "Jungle Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jungle_queen": {
        name: "Jungle Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jungle_rumble": {
        name: "Jungle Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jungle_spirit_call_of_the_wild": {
        name: "Jungle Spirit: Call of the Wild",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jungle_spirit_megaways": {
        name: "Jungle Spirit Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "jungle_volcano": {
        name: "Jungle Volcano",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "jungle_wheel": {
        name: "Jungle Wheel",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "jupiters_choice": {
        name: "Jupiters Choice",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "jurassic_kingdom": {
        name: "Jurassic Kingdom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jurassic_party": {
        name: "Jurassic Party",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "justice_machine_scratch": {
        name: "Justice Machine Scratch",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "kaboom": {
        name: "Kaboom",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "kaiser": {
        name: "Kaiser",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "kanes_inferno": {
        name: "Kane's Inferno",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "karens_merry_meltdown": {
        name: "Karen's Merry Meltdown",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "keep_em": {
        name: "Keep Em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "keep_em_cool": {
        name: "Keep 'em Cool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "keepem": {
        name: "Keep'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "keepers_of_the_secret": {
        name: "Keepers Of The Secret",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "keno": {
        name: "Keno",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "keno_10_1_minute": {
        name: "Keno 10 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "keno_10_2_minutes": {
        name: "Keno 10 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "keno_8_1_minute": {
        name: "Keno 8 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "keno_8_2_minutes": {
        name: "Keno 8 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "keno_bonus_number": {
        name: "Keno Bonus Number",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "keno_express": {
        name: "Keno Express",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "keno_extra_bet": {
        name: "Keno Extra Bet",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "keno_multiplay": {
        name: "Keno Multiplay",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "keno8_1": {
        name: "Keno8_1",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "kicker_mania": {
        name: "Kicker Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "kickoff": {
        name: "KickOff",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "kill_road_66": {
        name: "Kill Road 66",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "killer_sharks": {
        name: "Killer Sharks",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "king_and_queen": {
        name: "King and Queen",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_arthur": {
        name: "King Arthur",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "king_arthur_10k_ways": {
        name: "King Arthur 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "king_carrot": {
        name: "King Carrot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "king_cobra": {
        name: "King Cobra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "king_colossus": {
        name: "King Colossus",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "king_kerching": {
        name: "King Kerching",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "king_kong_cash": {
        name: "King Kong Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_dj_prime8": {
        name: "King Kong Cash DJ Prime8",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas": {
        name: "King Kong Cash Even Bigger Bananas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas_2": {
        name: "King Kong Cash Even Bigger Bananas 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas_4": {
        name: "King Kong Cash Even Bigger Bananas 4",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_full_house": {
        name: "King Kong Cash Full House",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_prize_lines": {
        name: "King Kong Cash Prize Lines",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_splash": {
        name: "King Kong Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_lion": {
        name: "King Lion",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "king_of_3_kingdoms": {
        name: "King of 3 Kingdoms",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "king_of_kings": {
        name: "King of Kings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "king_of_ocean": {
        name: "King of Ocean",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "king_of_samba": {
        name: "King of Samba",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "king_of_slots": {
        name: "King of Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "king_of_spear": {
        name: "King of Spear",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "king_of_sweets": {
        name: "King of Sweets",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "king_of_the_jungle": {
        name: "King of the Jungle",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_of_the_jungle_gdn": {
        name: "King of the Jungle GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_of_the_jungle_rhfp": {
        name: "King of the Jungle RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_of_the_pig": {
        name: "King of the Pig",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "king_of_the_streets": {
        name: "King of the Streets",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "king_of_the_west": {
        name: "King of the West",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_power": {
        name: "King Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "king_treasure": {
        name: "King Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "king_tuts_tomb": {
        name: "King Tut's Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "kingdom_below": {
        name: "Kingdom Below",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kingdom_of_asgard": {
        name: "Kingdom of Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kingdom_of_atlantis_jackpot_play": {
        name: "Kingdom of Atlantis Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kingdom_of_the_dead": {
        name: "Kingdom of The Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kings_and_jewels": {
        name: "Kings & Jewels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "kings_mask": {
        name: "King's Mask",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kings_mask_eclipse_of_gods": {
        name: "King's Mask Eclipse of Gods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kings_relics": {
        name: "King's Relics",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "kitty_cash_scratch": {
        name: "Kitty Cash Scratch",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "kitty_puzzle": {
        name: "Kitty Puzzle",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "kittypopins": {
        name: "KittyPOPins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "klowns": {
        name: "Klowns",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "kluster_krystals_megaclusters": {
        name: "Kluster Krystals MegaClusters",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "knife_drop": {
        name: "Knife Drop",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "knight_hot_spotz": {
        name: "Knight Hot Spotz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "knight_rider": {
        name: "Knight Rider",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "knights_the_siege": {
        name: "Knights: The Siege",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "knights_vs_barbarians": {
        name: "Knights vs Barbarians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "knockout_football": {
        name: "Knockout Football",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "knockout_football_rush": {
        name: "Knockout Football Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "knockout_riches": {
        name: "Knockout Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "kohinoor": {
        name: "Koh-i-noor",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "koi_cash": {
        name: "Koi Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "koi_gate": {
        name: "Koi Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "koi_koi_treasure": {
        name: "Koi Koi Treasure",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "koi_pond": {
        name: "Koi Pond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "koi_princess": {
        name: "Koi Princess",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "kokeshi": {
        name: "Kokeshi",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "kokeshi_pop": {
        name: "Kokeshi Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "kong_3_even_bigger_bonus": {
        name: "Kong 3 Even Bigger Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kong_even_bigger_balls": {
        name: "Kong Even Bigger Balls",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kong_even_bigger_christmas": {
        name: "Kong Even Bigger Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kongo_bongo": {
        name: "Kongo Bongo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "korean_blackjackx": {
        name: "Korean BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "korean_roulette": {
        name: "Korean Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "korean_speed_baccarat": {
        name: "Korean Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "kraken_gold_rush": {
        name: "Kraken Gold Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "krakens_cove": {
        name: "Kraken's Cove",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "krakens_hunger": {
        name: "Kraken's Hunger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "krakens_sky_bounty": {
        name: "Kraken's Sky Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "krazy_klimber": {
        name: "Krazy Klimber",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "la_copa_grande": {
        name: "La Copa Grande",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "la_dolce_vita": {
        name: "La Dolce Vita",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_2": {
        name: "La Dolce Vita 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_deluxe": {
        name: "La Dolce Vita Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_flaming_link": {
        name: "La Dolce Vita Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_gdn": {
        name: "La Dolce Vita GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_rhfp": {
        name: "La Dolce Vita RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_fiesta": {
        name: "La Fiesta",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "la_romantica": {
        name: "La Romantica",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "la_tomatina": {
        name: "La Tomatina",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "lab_of_madness": {
        name: "Lab of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_fortune": {
        name: "Lady Fortune",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lady_godiva": {
        name: "Lady Godiva",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lady_lucky_gun": {
        name: "Lady Lucky Gun",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lady_merlin_multimax": {
        name: "Lady Merlin Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "lady_of_fortune": {
        name: "Lady of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_of_fortune_destiny_spins": {
        name: "Lady of Fortune Destiny Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_of_fortune_remastered": {
        name: "Lady of Fortune Remastered",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_wolf_moon": {
        name: "Lady Wolf Moon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lady_wolf_moon_megaways": {
        name: "Lady Wolf Moon Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lamp_of_infinity": {
        name: "Lamp Of Infinity",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "land_of_heroes": {
        name: "Land of Heroes",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "land_of_heroes_gdn": {
        name: "Land of Heroes GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "land_of_zenith": {
        name: "Land of Zenith",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "lantern_luck": {
        name: "Lantern Luck",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "larry_the_leprechaun": {
        name: "Larry the Leprechaun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "last_man_standing": {
        name: "Last Man Standing",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "last_valkyrie": {
        name: "Last Valkyrie",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "laughing_buddha": {
        name: "Laughing Buddha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "launch_to_riches": {
        name: "Launch to Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lava_balls": {
        name: "Lava Balls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lava_burst": {
        name: "Lava Burst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lava_coins": {
        name: "Lava Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lava_coins_2": {
        name: "Lava Coins 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lava_lions": {
        name: "Lava Lions",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "lawn_n_disorder": {
        name: "Lawn N' Disorder",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "le_bandit": {
        name: "Le Bandit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_bunny": {
        name: "Le Bunny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_digger": {
        name: "Le Digger",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_fisherman": {
        name: "Le Fisherman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_football_fan": {
        name: "Le Football Fan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_hooligan": {
        name: "Le Hooligan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_king": {
        name: "Le King",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_pharaoh": {
        name: "Le Pharaoh",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_prachaun": {
        name: "Le Prachaun",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_santa": {
        name: "Le Santa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_soccer": {
        name: "Le Soccer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_viking": {
        name: "Le Viking",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_zeus": {
        name: "Le Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "league_of_conquerors": {
        name: "League of Conquerors",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "legacy_of_anubis": {
        name: "Legacy of Anubis",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "legacy_of_dead": {
        name: "Legacy of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_dynasties": {
        name: "Legacy of Dynasties",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_egypt": {
        name: "Legacy of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_egypt_jp": {
        name: "Legacy of Egypt JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "legacy_of_gems_blitzways": {
        name: "Legacy of Gems Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_gods_megaways": {
        name: "Legacy of Gods Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "legacy_of_inca": {
        name: "Legacy of Inca",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_midas": {
        name: "Legacy of Midas",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "legacy_of_ra_megaways": {
        name: "Legacy Of Ra Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "legacy_of_ramses_book": {
        name: "Legacy of Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "legacy_of_the_sages": {
        name: "Legacy of the Sages",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "legacy_of_the_sages_bonus_buy": {
        name: "Legacy of the Sages Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "legacy_of_undead_dragon_abyssways": {
        name: "Legacy of Undead Dragon Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legend_of_atlantis": {
        name: "Legend of Atlantis",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "legend_of_dragon_wins_doublemax": {
        name: "Legend of Dragon Wins Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "legend_of_heroes_megaways": {
        name: "Legend of Heroes MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "legend_of_hou_yi": {
        name: "Legend of Hou Yi",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legend_of_nezha": {
        name: "Legend Of Nezha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "legend_of_perseus": {
        name: "Legend of Perseus",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legend_of_piggies_royal_edition": {
        name: "Legend of Piggies Royal Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "legend_of_ra": {
        name: "Legend of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "legend_of_tarzan": {
        name: "Legend of Tarzan",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "legend_of_the_ice_dragon": {
        name: "Legend of the Ice Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legendary_beasts": {
        name: "Legendary Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "legendary_diamonds": {
        name: "Legendary Diamonds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "legendary_monkey_king": {
        name: "Legendary Monkey King",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legion_gold": {
        name: "Legion Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_and_the_sphinx_of_dead": {
        name: "Legion Gold and the Sphinx of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_and_the_throne_of_dead": {
        name: "Legion Gold And The Throne Of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_reckoning": {
        name: "Legion Gold Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_unleashed": {
        name: "Legion Gold Unleashed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_victory": {
        name: "Legion Gold Victory",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_carol": {
        name: "Leprechaun Carol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "leprechaun_charms": {
        name: "Leprechaun Charms",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "leprechaun_charms_hold_and_win": {
        name: "Leprechaun Charms Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "leprechaun_charms_rainbow_jackpot": {
        name: "Leprechaun Charms Rainbow Jackpot",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "leprechaun_goes_egypt": {
        name: "Leprechaun goes Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_goes_wild": {
        name: "Leprechaun Goes Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_hills": {
        name: "Leprechaun Hills",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "leprechaun_joy": {
        name: "Leprechaun Joy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "leprechaun_riches": {
        name: "Leprechaun Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "leprechaun_song": {
        name: "Leprechaun Song",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "leprechaun_wish": {
        name: "Leprechaun Wish",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "leprechauns_diamond_dig": {
        name: "Leprechaun's Diamond Dig",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechauns_luck_emporium": {
        name: "Leprechaun's Luck Emporium",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "leprechauns_vault": {
        name: "Leprechaun's Vault",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "let_it_burn": {
        name: "Let It Burn",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "let_it_snow": {
        name: "Let it Snow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "let_it_spin": {
        name: "Let it Spin",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lets_get_ready_to_rumble": {
        name: "Let's Get Ready to Rumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "level20": {
        name: "Level20",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "liberty_and_freedom_hold_and_win_extreme_10000": {
        name: "Liberty and Freedom Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "liberty_and_freedom_hold_and_win_extreme_10000_live": {
        name: "Liberty and Freedom Hold and Win Extreme 10,000 Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "liberty_fireworks": {
        name: "Liberty Fireworks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "life_and_death": {
        name: "Life and Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lights": {
        name: "Lights",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "lights_camera_cash": {
        name: "Lights, Camera, Cash!",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "limbo": {
        name: "Limbo+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "limbo_crash": {
        name: "Limbo Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "limbo_xy": {
        name: "Limbo XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lines": {
        name: "Lines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lion_saga_odyssey": {
        name: "Lion Saga Odyssey",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lion_thunder": {
        name: "Lion Thunder",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lions_gigablox": {
        name: "Lions GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "little_farm": {
        name: "Little Farm",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "little_gem": {
        name: "Little Gem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "little_green_money": {
        name: "Little Green Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "little_witch_fortune": {
        name: "Little Witch Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "live_staging_tests": {
        name: "Live Staging Tests",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "lobster_bobs_crazy_crab_shack": {
        name: "Lobster Bob's Crazy Crab Shack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lobster_bobs_sea_food_and_win_it": {
        name: "Lobster Bob's Sea Food and Win It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lobster_house": {
        name: "Lobster House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lobster_pots": {
        name: "Lobster Pots",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "lock_and_pop": {
        name: "Lock and Pop",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "lockn_load": {
        name: "Lock'n Load",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "locktoberfest": {
        name: "Locktoberfest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "loco_the_monkey": {
        name: "Loco The Monkey",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "loki_loot": {
        name: "Loki Loot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lokis_riches": {
        name: "Loki's Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lolli_pop": {
        name: "Lolli Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "lollipop_drop_multimax": {
        name: "Lollipop Drop Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "lollipop_loot": {
        name: "Lollipop Loot",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "london_hunter": {
        name: "London Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "long_ball": {
        name: "Long Ball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "long_pao": {
        name: "Long Pao",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "looney_pop": {
        name: "Looney Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "loony_blox": {
        name: "Loony Blox",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "loot_and_labyrinths": {
        name: "Loot and Labyrinths",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "loot_crab": {
        name: "Loot Crab",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "looters": {
        name: "Looters",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "looting_raccoons": {
        name: "Looting Raccoons",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "lord_merlin_and_the_lady_of_the_lake": {
        name: "Lord Merlin and the Lady of the Lake",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lord_of_thunder": {
        name: "Lord of Thunder",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "los_muertos": {
        name: "Los Muertos",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "los_muertos_ii": {
        name: "Los Muertos II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lost_in_the_wild_reel_bingo": {
        name: "Lost in the Wild Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "lost_relics": {
        name: "Lost Relics",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "lost_treasure": {
        name: "Lost Treasure",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lost_treasure_of_tortuga": {
        name: "Lost Treasure of Tortuga",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "loti_fortune_spins": {
        name: "LOTI Fortune Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "loti_gold_spins": {
        name: "LOTI Gold Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lottoboom": {
        name: "LottoBoom",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "lotus_love": {
        name: "Lotus Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "love_and_luck_joker": {
        name: "Love and Luck Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "love_and_riches_el_dorado": {
        name: "Love and Riches El Dorado",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "love_goa": {
        name: "Love Goa",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "love_is_all_you_need": {
        name: "LOVE is all you need",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "love_is_in_the_fair": {
        name: "Love is in the Fair",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "love_island_hold_the_love": {
        name: "Love Island Hold the Love",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "love_island_instant_match": {
        name: "Love Island Instant Match",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "love_island_love_in_a_spin": {
        name: "Love Island Love in a Spin",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "love_joker": {
        name: "Love Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lu_fu_vortex": {
        name: "Lu Fu Vortex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "luchamigos": {
        name: "Luchamigos",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "luck_and_magic": {
        name: "Luck & Magic",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "luck_and_magic_scratch": {
        name: "Luck and Magic Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "luck_of_amazon": {
        name: "Luck of Amazon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "luck_of_the_dragon": {
        name: "Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "luck_reactor": {
        name: "Luck Reactor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_4_spirits": {
        name: "Lucky 4 Spirits",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "lucky_8_keno": {
        name: "Lucky 8 Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "lucky_8_merge_up": {
        name: "Lucky 8 Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_9": {
        name: "Lucky 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_aces": {
        name: "Lucky Aces",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "lucky_angler_a_snowy_catch": {
        name: "Lucky Angler: A Snowy Catch",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "lucky_apple_x1000": {
        name: "Lucky Apple x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lucky_ball": {
        name: "Lucky Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_bingo": {
        name: "Lucky Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_bonus_draw_keno": {
        name: "Lucky Bonus Draw Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "lucky_buddha": {
        name: "Lucky Buddha",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "lucky_bunny_eggs_bonanza": {
        name: "Lucky Bunny Eggs Bonanza",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "lucky_calico_mahjong": {
        name: "Lucky Calico Mahjong",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "lucky_card": {
        name: "Lucky Card",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_cat_and_maid_rush": {
        name: "Lucky Cat & Maid Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "lucky_cauldron": {
        name: "Lucky Cauldron",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "lucky_charms_trio": {
        name: "Lucky Charms Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lucky_clover_lady": {
        name: "Lucky Clover Lady",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "lucky_coming": {
        name: "Lucky Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_crew": {
        name: "Lucky Crew",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_crumbling": {
        name: "Lucky Crumbling",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_dama_muerta": {
        name: "Lucky Dama Muerta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_day_cheltenham_champions": {
        name: "Lucky Day: Cheltenham Champions",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_day_christmas_cashcade": {
        name: "Lucky Day: Christmas Cashcade",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_day_football_gold": {
        name: "Lucky Day: Football Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_day_mega_hallowin": {
        name: "Lucky Day: Mega Hallowin",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_day_summer_spike": {
        name: "Lucky Day: Summer Spike",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_diamonds": {
        name: "Lucky Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lucky_dragon_ball": {
        name: "Lucky Dragon Ball",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_dragon_multidice_x": {
        name: "Lucky Dragon MultiDice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_dragons": {
        name: "Lucky Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_ducky": {
        name: "Lucky Ducky",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_durian": {
        name: "Lucky Durian",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_farm": {
        name: "Lucky Farm",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "lucky_farm_bonanza": {
        name: "Lucky Farm Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_fifth": {
        name: "Lucky Fifth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "lucky_fire_blitz_megaways": {
        name: "Lucky Fire Blitz Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lucky_fire_blitz_win_boost": {
        name: "Lucky Fire Blitz Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lucky_fish": {
        name: "Lucky Fish",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_fishing_megaways": {
        name: "Lucky Fishing MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_fortune": {
        name: "Lucky Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_fortune_cat": {
        name: "Lucky Fortune Cat",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_gallops_mega": {
        name: "Lucky Gallops Mega",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "lucky_girls": {
        name: "Lucky Girls",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_goldbar": {
        name: "Lucky Goldbar",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "lucky_goldbricks": {
        name: "Lucky Goldbricks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_grace_and_charm": {
        name: "Lucky, Grace and Charm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_jaguar": {
        name: "Lucky Jaguar",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_jaguar_2": {
        name: "Lucky Jaguar 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_lady_leprechaun": {
        name: "Lucky Lady Leprechaun",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "lucky_ladys_clover": {
        name: "Lucky Lady's Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_lager_x9990": {
        name: "Lucky Lager X9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_lightning": {
        name: "Lucky Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_lions_wild_life": {
        name: "Lucky Lions: Wild Life",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_lu": {
        name: "Lucky Lu",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_lucifer": {
        name: "Lucky Lucifer",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucky_lucky": {
        name: "Lucky Lucky",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_macaw": {
        name: "Lucky Macaw",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_money": {
        name: "Lucky Money",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "lucky_neko": {
        name: "Lucky Neko",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "lucky_new_year": {
        name: "Lucky New Year",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_new_year_tiger_treasures": {
        name: "Lucky New Year: Tiger Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_number": {
        name: "Lucky Number",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_numbers_x12": {
        name: "Lucky Numbers x12",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x16": {
        name: "Lucky Numbers x16",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x20": {
        name: "Lucky Numbers x20",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x8": {
        name: "Lucky Numbers x8",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_oak": {
        name: "Lucky Oak",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_oasis": {
        name: "Lucky Oasis",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lucky_pack_2026_cup": {
        name: "Lucky Pack 2026 Cup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_penny": {
        name: "Lucky Penny",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lucky_penny_2": {
        name: "Lucky Penny 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lucky_penny_power_scatter": {
        name: "Lucky Penny Power Scatter",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "lucky_pharaoh": {
        name: "Lucky Pharaoh",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lucky_piggy": {
        name: "Lucky Piggy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "lucky_piper": {
        name: "Lucky Piper",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "lucky_porker": {
        name: "Lucky Porker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_porker_bonus_buy": {
        name: "Lucky Porker Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lucky_queen": {
        name: "Lucky Queen",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_reels": {
        name: "Lucky Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_rocket": {
        name: "Lucky Rocket",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "lucky_roulette": {
        name: "Lucky Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "lucky_scarab": {
        name: "Lucky Scarab",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "lucky_scratch": {
        name: "Lucky Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_shot": {
        name: "Lucky Shot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_star_keno": {
        name: "Lucky Star Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "lucky_streaks": {
        name: "Lucky Streaks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "lucky_sweets": {
        name: "Lucky Sweets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_tiger": {
        name: "Lucky Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "lucky_turtle": {
        name: "Lucky Turtle",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "lucky_waterfalls": {
        name: "Lucky Waterfalls",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "luckys_wild_pub": {
        name: "Lucky's Wild Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "luckys_wild_pub_2": {
        name: "Lucky's Wild Pub 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucy_luck_and_the_crimson_diamond": {
        name: "Lucy Luck and the Crimson Diamond",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucy_luck_and_the_quest_for_coins": {
        name: "Lucy Luck and the Quest for Coins",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucy_luck_and_the_temple_of_mysteries": {
        name: "Lucy Luck and the Temple of Mysteries",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lunar_wilds": {
        name: "Lunar Wilds",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "lure_of_fortune": {
        name: "Lure of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "luxor_of_cleopatra": {
        name: "Luxor of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "maaax_diamonds": {
        name: "Maaax Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_christmas_edition": {
        name: "Maaax Diamonds Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_deluxe": {
        name: "Maaax Diamonds Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_flaming_link": {
        name: "Maaax Diamonds Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_gdn": {
        name: "Maaax Diamonds GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mad_blast": {
        name: "Mad Blast",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "mad_cabs": {
        name: "Mad Cabs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mad_cabs_hold_and_win": {
        name: "Mad Cabs Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mad_cars": {
        name: "Mad Cars",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "madame_destiny": {
        name: "Madame Destiny",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "madame_destiny_megaways": {
        name: "Madame Destiny MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "madame_ink": {
        name: "Madame Ink",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "maestro": {
        name: "Maestro",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "mafia": {
        name: "Mafia",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "mafia_gold": {
        name: "Mafia Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mafioso": {
        name: "Mafioso",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "magawa_vs_mines": {
        name: "Magawa vs Mines",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "magic_apple": {
        name: "Magic Apple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "magic_apple_2": {
        name: "Magic Apple 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "magic_ball_multichance": {
        name: "Magic Ball: Multichance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "magic_candy_factory": {
        name: "Magic Candy Factory",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "magic_clovers": {
        name: "Magic Clovers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "magic_dice": {
        name: "Magic Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "magic_eggs": {
        name: "Magic Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fire": {
        name: "Magic Fire",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "magic_fruit_cherries": {
        name: "Magic Fruit: Cherries",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruit_dice": {
        name: "Magic Fruit Dice",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits": {
        name: "Magic Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_27": {
        name: "Magic Fruits 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_4": {
        name: "Magic Fruits 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_4_deluxe": {
        name: "Magic Fruits 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_81": {
        name: "Magic Fruits 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_deluxe": {
        name: "Magic Fruits Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_oranges": {
        name: "Magic Fruits Oranges",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot": {
        name: "Magic Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot_4": {
        name: "Magic Hot 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot_4_deluxe": {
        name: "Magic Hot 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_jewels": {
        name: "Magic Jewels",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "magic_journey": {
        name: "Magic Journey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magic_lab": {
        name: "Magic lab",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "magic_lamp": {
        name: "Magic Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "magic_lamp_bingo": {
        name: "Magic Lamp Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "magic_maid_cafe": {
        name: "Magic Maid Cafe",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "magic_money_maze": {
        name: "Magic Money Maze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magic_mummy_megaways": {
        name: "Magic Mummy Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "magic_oak": {
        name: "Magic Oak",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "magic_of_the_ring": {
        name: "Magic Of The Ring",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_of_the_ring_deluxe": {
        name: "Magic of the Ring Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_piggy": {
        name: "Magic Piggy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "magic_piggy_og": {
        name: "Magic Piggy OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "magic_poker": {
        name: "Magic Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_scratch": {
        name: "Magic Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "magic_spins": {
        name: "Magic Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars": {
        name: "Magic Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_3": {
        name: "Magic Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_5": {
        name: "Magic Stars 5",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_6": {
        name: "Magic Stars 6",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_9": {
        name: "Magic Stars 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stone": {
        name: "Magic Stone",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "magic_target": {
        name: "Magic Target",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_target_deluxe": {
        name: "Magic Target Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_wheel": {
        name: "Magic Wheel",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "magicians_secrets": {
        name: "Magician's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magikspell": {
        name: "Magikspell",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "maharaja_and_the_vampire": {
        name: "Maharaja and the Vampire",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "mahjong_88": {
        name: "Mahjong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mahjong_dragon_tower": {
        name: "Mahjong Dragon Tower",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "mahjong_master": {
        name: "Mahjong Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mahjong_master_2": {
        name: "Mahjong Master 2",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mahjong_panda": {
        name: "Mahjong Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_ways": {
        name: "Mahjong Ways",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mahjong_ways_2": {
        name: "Mahjong Ways 2",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mahjong_wins": {
        name: "Mahjong Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_bonus": {
        name: "Mahjong Wins Bonus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_super_scatter": {
        name: "Mahjong Wins Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_triple_pot": {
        name: "Mahjong Wins Triple Pot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_x": {
        name: "Mahjong X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "majestic_coins": {
        name: "Majestic Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "majestic_empire": {
        name: "Majestic Empire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "majestic_express_gold_run": {
        name: "Majestic Express Gold Run",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "majestic_fury_megaways": {
        name: "Majestic Fury Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_fury_megaways_unleashed": {
        name: "Majestic Fury Megaways Unleashed",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_fury_power_5": {
        name: "Majestic Fury Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_fury_win_stepper": {
        name: "Majestic Fury Win Stepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_meow": {
        name: "Majestic Meow",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "majestic_treasures": {
        name: "Majestic Treasures",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mammoth_gold_megaways": {
        name: "Mammoth Gold MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "maneki_88_fortunes": {
        name: "Maneki 88 Fortunes",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "maneki_88_gold": {
        name: "Maneki 88 Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "manic_fairy": {
        name: "Manic Fairy",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "manta_mayhem": {
        name: "Manta Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "maradona": {
        name: "Maradona",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "maradona_el_diez": {
        name: "Maradona El Diez",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "maradona_el_pibe_de_oro": {
        name: "Maradona: El Pibe De Oro",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "marching_legions": {
        name: "Marching Legions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "marlin_masters": {
        name: "Marlin Masters",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marlin_masters_atlantis": {
        name: "Marlin Masters: Atlantis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marlin_masters_og": {
        name: "Marlin Masters OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marlin_masters_the_big_haul": {
        name: "Marlin Masters: The Big Haul",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "martian_miner_infinity_reels": {
        name: "Martian Miner Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "marvelous_furlongs": {
        name: "Marvelous Furlongs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "marys_mining_mania": {
        name: "Mary's Mining Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mask_carnival": {
        name: "Mask Carnival",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "masked_mayhem": {
        name: "Masked Mayhem",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "masked_treasures": {
        name: "Masked Treasures",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "massive_luck": {
        name: "Massive Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "massive_luck_bonus_buy": {
        name: "Massive Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "master_chens_fortune": {
        name: "Master Chen's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "master_joker": {
        name: "Master Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "master_of_elements": {
        name: "Master Of Elements",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "master_tiger": {
        name: "Master Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "matsuri": {
        name: "Matsuri",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "maverick": {
        name: "Maverick",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "maverick_x": {
        name: "Maverick X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "mayan_destiny": {
        name: "Mayan Destiny",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mayan_empire": {
        name: "Mayan Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mayan_fire": {
        name: "Mayan Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mayan_riches_prophecy_of_gold": {
        name: "Mayan Riches Prophecy of Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "mayan_ritual": {
        name: "Mayan Ritual",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mayan_stackways": {
        name: "Mayan Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mayan_temple_riches": {
        name: "Mayan Temple Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "mayana": {
        name: "Mayana",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "mayas_treasure": {
        name: "Maya's treasure",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "maze_adventure": {
        name: "Maze Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "maze_desire_for_power": {
        name: "Maze: Desire for Power",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "maze_escape_megaways": {
        name: "Maze Escape MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "mechanical_clover": {
        name: "Mechanical Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mechanical_orange": {
        name: "Mechanical Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "medallion_megaways": {
        name: "Medallion MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "medieval_mania": {
        name: "Medieval Mania",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "medusa": {
        name: "Medusa",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "medusa_blessing": {
        name: "Medusa Blessing",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "medusa_hot1": {
        name: "Medusa Hot1",
        provider: "Hot Rise Games",
        providerSlug: "hot-rise-games"
    },
    "medusa_ii": {
        name: "Medusa II",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "medusa_mystic_reels_megaways": {
        name: "Medusa Mystic Reels Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "medusas_madness": {
        name: "Medusa's Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "medusas_stone": {
        name: "Medusa's Stone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mega_ace": {
        name: "Mega Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mega_baccarat": {
        name: "Mega Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_cash_stacks": {
        name: "Mega Cash Stacks",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "mega_cave": {
        name: "Mega Cave",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "mega_charged_cash": {
        name: "Mega Charged Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "mega_don_feeding_frenzy": {
        name: "Mega Don Feeding Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mega_don_triple_threat": {
        name: "Mega Don Triple Threat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mega_dragon": {
        name: "Mega Dragon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mega_fishing": {
        name: "Mega Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mega_flip": {
        name: "Mega Flip",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_fruits_777": {
        name: "Mega Fruits 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mega_greatest_catch": {
        name: "Mega Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mega_greatest_catch_blue_marlin": {
        name: "Mega Greatest Catch Blue Marlin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mega_greatest_catch_bonus_buy": {
        name: "Mega Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mega_heist": {
        name: "Mega Heist",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_laser_kitty_cubes": {
        name: "Mega Laser Kitty Cubes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "mega_masks": {
        name: "Mega Masks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_merry_gifts": {
        name: "Mega Merry Gifts",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mega_mine": {
        name: "Mega Mine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_money_machine": {
        name: "Mega Money Machine",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mega_mystery_mine": {
        name: "Mega Mystery Mine",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mega_pearl_gigablox": {
        name: "Mega Pearl Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mega_roulette": {
        name: "Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_roulette_3000": {
        name: "Mega Roulette 3000",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_roulette_brazilian": {
        name: "Mega Roulette Brazilian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_sevens": {
        name: "Mega Sevens",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "mega_sic_bac": {
        name: "Mega Sic Bac",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_sic_bo": {
        name: "Mega Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_sic_bo_lobby": {
        name: "Mega Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_wheel": {
        name: "Mega Wheel",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "megablox_777": {
        name: "MegaBlox 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "megablox_pyramids": {
        name: "Megablox Pyramids",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "megadon": {
        name: "Megadon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "megaways_jack": {
        name: "MegaWays Jack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "megaways_jack_and_the_magic_beans": {
        name: "MegaWays Jack and The Magic Beans",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "megaways_jack_frost": {
        name: "Megaways Jack Frost",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "megaways_mob": {
        name: "MegaWays Mob",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "meow_janken": {
        name: "Meow Janken",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "merge_hold_and_drop": {
        name: "Merge Hold and Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "merge_up": {
        name: "Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "merge_up_2": {
        name: "Merge Up 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "merlin_and_the_ice_queen_morgana": {
        name: "Merlin and the Ice Queen Morgana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlin_journey_of_flame": {
        name: "Merlin: Journey of Flame",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlin_realm_of_charm": {
        name: "Merlin Realm of Charm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlins_fortune": {
        name: "Merlin's Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "merlins_grimoire": {
        name: "Merlin's Grimoire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlins_mixtures_94": {
        name: "Merlin's Mixtures 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "mermaid_reef": {
        name: "Mermaid Reef",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mermaid_riches": {
        name: "Mermaid Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mermaids": {
        name: "Mermaids",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "mermaids_diamond": {
        name: "Mermaid's Diamond",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mermaids_treasure_love": {
        name: "Mermaid's Treasure Love",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "merry_megaways": {
        name: "Merry Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "merry_xmas": {
        name: "Merry Xmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "miami_beach": {
        name: "Miami Beach",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "miami_mayhem": {
        name: "Miami Mayhem",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "miami_multiplier": {
        name: "Miami Multiplier",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mice_and_magic_wonder_spin": {
        name: "Mice and Magic Wonder Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "midas_coins": {
        name: "Midas Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "midas_fortune": {
        name: "Midas Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "midas_king_of_gold": {
        name: "Midas King Of Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "midas_vs_medusa_wild_energy": {
        name: "Midas vs Medusa Wild Energy",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "midnight_gold": {
        name: "Midnight Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "midnight_hunt": {
        name: "Midnight Hunt",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "midnight_in_tokyo": {
        name: "Midnight in Tokyo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "midnight_jackpots_5000": {
        name: "Midnight Jackpots 5000",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "midnight_marauder": {
        name: "Midnight Marauder",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "midnight_pursuit": {
        name: "Midnight Pursuit",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "midnight_show": {
        name: "Midnight Show",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "might_of_freya_megaways": {
        name: "Might of Freya Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "might_of_ra": {
        name: "Might of Ra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_arthur": {
        name: "Mighty Arthur",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "mighty_crown_empire_of_gold": {
        name: "Mighty Crown: Empire of Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_crown_legacy_of_mars": {
        name: "Mighty Crown Legacy of Mars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_dragon": {
        name: "Mighty Dragon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mighty_fish_blue_marlin": {
        name: "Mighty Fish: Blue Marlin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_gorilla": {
        name: "Mighty Gorilla",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mighty_hot_777": {
        name: "Mighty Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_hot_amazonia": {
        name: "Mighty Hot: Amazonia",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_kong": {
        name: "Mighty Kong",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_mania": {
        name: "Mighty Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mighty_marlin": {
        name: "Mighty Marlin",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_marlin_super_reel": {
        name: "Mighty Marlin Super Reel",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_masks": {
        name: "Mighty Masks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mighty_medusa": {
        name: "Mighty Medusa",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "mighty_mountain": {
        name: "Mighty Mountain",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_munching_melons": {
        name: "Mighty Munching Melons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_symbols_crowns": {
        name: "Mighty Symbols Crowns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_diamonds": {
        name: "Mighty Symbols Diamonds",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_jokers": {
        name: "Mighty Symbols: Jokers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_sevens": {
        name: "Mighty Symbols: Sevens",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_gorilla": {
        name: "Mighty Wild Gorilla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_jaguar": {
        name: "Mighty Wild Jaguar",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther": {
        name: "Mighty Wild: Panther",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_diamond_edition": {
        name: "Mighty Wild: Panther Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_gold_edition": {
        name: "Mighty Wild Panther Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_platinum_edition": {
        name: "Mighty Wild: Panther Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wins": {
        name: "Mighty Wins",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "mighty_zeus": {
        name: "Mighty Zeus",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "mighty_zeus_reel_triple": {
        name: "Mighty Zeus Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "mighty_zeus_super_reels": {
        name: "Mighty Zeus Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "milkshake_xxxtreme": {
        name: "Milkshake XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "million_baccarat": {
        name: "Million Baccarat",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_blackjack_london_deal": {
        name: "Million Blackjack London Deal",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_blackjack_peek": {
        name: "Million Blackjack Peek",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_book": {
        name: "Million Book",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "million_dice": {
        name: "Million Dice",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_hilo": {
        name: "Million HiLo",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_mine": {
        name: "Million Mine",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_plinko": {
        name: "Million Plinko",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_tree": {
        name: "Million Tree",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "million_wheel": {
        name: "Million Wheel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "mindiana_jones": {
        name: "Mindiana Jones",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "mine_blown": {
        name: "Mine Blown",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "mine_field": {
        name: "Mine Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mine_gems": {
        name: "Mine Gems",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mine_mine_quest": {
        name: "Mine Mine Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "miner_donkey_trouble": {
        name: "Miner Donkey Trouble",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mines": {
        name: "Mines+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mines_cricket": {
        name: "Mines Cricket",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mines_gold": {
        name: "Mines Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mines_grand": {
        name: "Mines Grand",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "mines_supreme": {
        name: "Mines Supreme",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "minesweeper": {
        name: "Minesweeper",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "minesweeper_xy": {
        name: "Minesweeper XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mini_baccarat": {
        name: "Mini Baccarat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mining_rush": {
        name: "Mining Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "minted_coins": {
        name: "Minted Coins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "miracle_ring": {
        name: "Miracle Ring",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "mirage_city": {
        name: "Mirage City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mirror_joker": {
        name: "Mirror Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "misa_augur_swettie": {
        name: "Misa Augur Swettie",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "miss_candys_sweet_escape": {
        name: "Miss Candy's Sweet Escape",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "miss_cherry_fruits": {
        name: "Miss Cherry Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "miss_cherry_fruits_jackpot_party": {
        name: "Miss Cherry Fruits Jackpot Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mission_cash": {
        name: "Mission Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mister_payman": {
        name: "Mister Payman",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "mochimon": {
        name: "Mochimon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "moirai_blaze_scratch": {
        name: "Moirai Blaze Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mole_digger": {
        name: "Mole Digger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moleionaire": {
        name: "Moleionaire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "moley_moolah": {
        name: "Moley Moolah",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "money_blitz": {
        name: "Money Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_bunny_show": {
        name: "Money Bunny Show",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "money_cart": {
        name: "Money Cart",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_cart_2": {
        name: "Money Cart 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_cart_3": {
        name: "Money Cart 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_coming": {
        name: "Money Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "money_coming_2": {
        name: "Money Coming 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "money_jar": {
        name: "Money Jar",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "money_jar_2": {
        name: "Money Jar 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "money_maker": {
        name: "Money Maker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "money_mariachi_infinity_reels": {
        name: "Money Mariachi Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "money_minecarts": {
        name: "Money Minecarts",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "money_minter": {
        name: "Money Minter",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "money_minter_bonus_buy": {
        name: "Money Minter Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "money_money_money": {
        name: "Money Money Money",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_mouse": {
        name: "Money Mouse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_pot": {
        name: "Money Pot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "money_roll": {
        name: "Money Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_royale": {
        name: "Money Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "money_sleigh": {
        name: "Money Sleigh",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_stacks": {
        name: "Money Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_stacks_megaways": {
        name: "Money Stacks Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_time": {
        name: "Money Time",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "money_train": {
        name: "Money Train",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_2": {
        name: "Money Train 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_3": {
        name: "Money Train 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_4": {
        name: "Money Train 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_wheel": {
        name: "Money Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "monkey_27": {
        name: "Monkey 27",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "monkey_battle_for_the_scrolls": {
        name: "Monkey Battle for the Scrolls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "monkey_king": {
        name: "Monkey King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "monkey_king_777jackpot": {
        name: "Monkey King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "monkey_king_rush": {
        name: "Monkey King Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monkey_madness": {
        name: "Monkey Madness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monkey_mania": {
        name: "Monkey Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "monkey_party": {
        name: "Monkey Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "monkey_pop": {
        name: "Monkey Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "monkey_warrior": {
        name: "Monkey Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monkeypop_2": {
        name: "MonkeyPop 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "monkeys_wild_party": {
        name: "Monkeys Wild Party",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "monopoly_money_line": {
        name: "Monopoly Money Line",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "monster_blox": {
        name: "Monster Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "monster_hunt": {
        name: "Monster Hunt",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "monster_madness": {
        name: "Monster Madness",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "monster_mash_cash": {
        name: "Monster Mash Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "monster_quest": {
        name: "Monster Quest",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "monster_superlanche": {
        name: "Monster Superlanche",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monsters_vs_gigablox": {
        name: "Monsters vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "montezumas_quest": {
        name: "Montezumas Quest",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "moo_moo_cow": {
        name: "Moo Moo Cow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "moon_of_fortune": {
        name: "Moon of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "moon_of_thoth": {
        name: "Moon of Thoth",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "moon_princess": {
        name: "Moon Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_christmas_kingdom": {
        name: "Moon Princess: Christmas Kingdom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_origins": {
        name: "Moon Princess Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_power_of_love": {
        name: "Moon Princess Power of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_stargazing": {
        name: "Moon Princess Stargazing",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_trinity": {
        name: "Moon Princess Trinity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_sisters": {
        name: "Moon Sisters",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "moonlight_cats": {
        name: "Moonlight Cats",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "moonlight_panda": {
        name: "Moonlight Panda",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "moonshot": {
        name: "Moonshot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "moosey_money": {
        name: "Moosey Money",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "more_candy": {
        name: "More Candy",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "more_magic_apple": {
        name: "More Magic Apple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "more_or_less": {
        name: "More or Less",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "motley_crue": {
        name: "Motley Crue",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "motorhead_video_slot": {
        name: "Motorhead Video Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "mount_m": {
        name: "Mount M",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mount_magmas_njp": {
        name: "Mount Magmas (NJP)",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "mount_mazuma": {
        name: "Mount Mazuma",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mountain_spirit": {
        name: "Mountain Spirit",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "mouse_gold_mega_edition": {
        name: "Mouse Gold Mega Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mouse_gold_rush": {
        name: "Mouse Gold Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mow_money": {
        name: "Mow Money",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mow_money_multimax": {
        name: "Mow Money Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mr_bling": {
        name: "Mr Bling",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mr_hallowwin": {
        name: "Mr. Hallow-Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mr_nulls_wicked_wares": {
        name: "Mr Null's Wicked Wares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mr_oinksters_hold_and_win": {
        name: "Mr. Oinksters Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mr_oinksters_power_hit": {
        name: "Mr. Oinkster's Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mr_porky_banker_cash_stash": {
        name: "Mr Porky Banker: Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mr_thimble": {
        name: "Mr Thimble",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "mr_treasures_fortune": {
        name: "Mr Treasure's Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ms_robin_hood": {
        name: "Ms Robin Hood",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "muay_thai_champion": {
        name: "Muay Thai Champion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "muay_thai_unlimited_ii": {
        name: "Muay Thai Unlimited II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "muddy_waters": {
        name: "Muddy Waters",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "muerto_en_mictlan": {
        name: "Muerto En Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "muertos_multiplier_megaways": {
        name: "Muertos Multiplier MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "multi_machine": {
        name: "Multi Machine",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "multi_rush": {
        name: "Multi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "multifruit_81": {
        name: "MultiFruit 81",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "multihand_blackjack": {
        name: "Multihand Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "multihand_blackjack_pro": {
        name: "Multihand Blackjack Pro",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "multihand_blackjack_pro_2": {
        name: "Multihand Blackjack Pro 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "multiplier_mine": {
        name: "Multiplier Mine",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "multiplier_odyssey": {
        name: "Multiplier Odyssey",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mummy_hunter": {
        name: "Mummy Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mummy_megaways": {
        name: "Mummy MegaWays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "mummy_mia": {
        name: "Mummy Mia",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "mummy_money": {
        name: "Mummy Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mummy_princess": {
        name: "Mummy Princess",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "mummys_gold": {
        name: "Mummy's Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mummys_jewels": {
        name: "Mummy's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mummys_jewels_100": {
        name: "Mummy's Jewels 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "munchy_milo": {
        name: "Munchy Milo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "museum_mystery": {
        name: "Museum Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mustang_gold": {
        name: "Mustang Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mustang_gold_megaways": {
        name: "Mustang Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mustang_hold_and_win": {
        name: "Mustang Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mustang_trail": {
        name: "Mustang Trail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mustangs_and_stallions": {
        name: "Mustangs and Stallions",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mutagenes": {
        name: "Mutagenes",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "mutant_trawlers": {
        name: "Mutant Trawlers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "mx_mania": {
        name: "MX Mania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mysteries_of_the_east": {
        name: "Mysteries of the East",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mysterious": {
        name: "Mysterious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mysterious_egypt": {
        name: "Mysterious Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystery_egg_surprise": {
        name: "Mystery Egg Surprise",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_garden": {
        name: "Mystery Garden",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mystery_genie_fortunes_of_the_lamp": {
        name: "Mystery Genie Fortunes of the Lamp",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_heist": {
        name: "Mystery Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mystery_jack": {
        name: "Mystery Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_jack_deluxe": {
        name: "Mystery Jack Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_joker": {
        name: "Mystery Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_joker_6000": {
        name: "Mystery Joker 6000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_kindom_mystery_bells": {
        name: "Mystery Kindom: Mystery Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_mice": {
        name: "Mystery Mice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystery_mission_to_the_moon": {
        name: "Mystery Mission - To The Moon",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "mystery_motel": {
        name: "Mystery Motel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mystery_museum": {
        name: "Mystery Museum",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "mystery_of_the_nile": {
        name: "Mystery of the Nile",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "mystery_planet": {
        name: "Mystery Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mystery_wind": {
        name: "Mystery Wind",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "mystic_alaska": {
        name: "Mystic Alaska",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mystic_chief": {
        name: "Mystic Chief",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystic_dolphin_charge_up": {
        name: "Mystic Dolphin Charge Up",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "mystic_fortune": {
        name: "Mystic Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mystic_fortune_deluxe": {
        name: "Mystic Fortune Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mystic_magic": {
        name: "Mystic Magic",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "mystic_potion": {
        name: "Mystic Potion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mystic_rings": {
        name: "Mystic Rings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mystic_shaman": {
        name: "Mystic Shaman",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mystic_spells": {
        name: "Mystic Spells",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "mystic_totems": {
        name: "Mystic Totems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "mystical_forest": {
        name: "Mystical Forest",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mystical_spirits": {
        name: "Mystical Spirits",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "myth": {
        name: "Myth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "myth_of_dead": {
        name: "Myth of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mythic_maiden": {
        name: "Mythic Maiden",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "mythical_guardians": {
        name: "Mythical Guardians",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "napoleon_2_fat_stacks": {
        name: "Napoleon 2 Fat Stacks",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_deluxe": {
        name: "Napoleon Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_megaways": {
        name: "Napoleon Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_rise_of_an_empire": {
        name: "Napoleon: Rise of an Empire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_vs_rabbits": {
        name: "Napoleon Vs Rabbits",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "narcos": {
        name: "Narcos",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "naughty_girls_cabaret": {
        name: "Naughty Girls Cabaret",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "naughty_nicks_book": {
        name: "Naughty Nick's Book",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "naughty_santa": {
        name: "Naughty Santa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "naughty_wukong": {
        name: "Naughty Wukong",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "navajo_legend": {
        name: "Navajo Legend",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "necromancers_gate": {
        name: "Necromancer's Gate",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "neko_fortune": {
        name: "Neko Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "neo_tokyo": {
        name: "Neo Tokyo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "neon_capital": {
        name: "Neon Capital",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "neon_capital_bonus_buy": {
        name: "Neon Capital Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "neon_city": {
        name: "Neon City",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "neon_dreams": {
        name: "Neon Dreams",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "neon_jungle_scratch": {
        name: "Neon Jungle Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "neon_respin": {
        name: "Neon Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "neon_shapes": {
        name: "Neon Shapes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "neon_staxx": {
        name: "Neon Staxx",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "neon_wildfire": {
        name: "Neon Wildfire",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "neros_fortune": {
        name: "Nero's Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "nerves_of_steal": {
        name: "Nerves of Steal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "nest_egg_trio_bonus": {
        name: "Nest Egg Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "net_gains": {
        name: "Net Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "new_year_riches": {
        name: "New Year Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "new_years_bash": {
        name: "New Years Bash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "nezha": {
        name: "Nezha",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "nft_aviatrix": {
        name: "NFT Aviatrix",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "night_city": {
        name: "Night City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "night_club_81": {
        name: "Night Club 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "night_in_egypt": {
        name: "Night in Egypt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "night_of_the_living_tales": {
        name: "Night of the Living Tales",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "night_wolves": {
        name: "Night Wolves",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "nightfall": {
        name: "Nightfall",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "nightfall_hunting": {
        name: "Nightfall Hunting",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "nile_fortune": {
        name: "Nile Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "nile_mystery_doublemax": {
        name: "Nile Mystery Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "nine_tails": {
        name: "Nine Tails",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ninja_chacha": {
        name: "Ninja Chacha",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "ninja_crash": {
        name: "Ninja Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "ninja_fruits": {
        name: "Ninja Fruits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ninja_master": {
        name: "Ninja Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "ninja_vs_samurai": {
        name: "Ninja vs Samurai",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "nitro_nights": {
        name: "Nitro Nights",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "niuniu": {
        name: "NiuNiu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "no_comm_baccarat": {
        name: "No Comm Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "no_comm_speed_baccarat": {
        name: "No Comm Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "nordic_fire": {
        name: "Nordic Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "north_guardians": {
        name: "North Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "northern_sky": {
        name: "Northern Sky",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "northern_temple": {
        name: "Northern Temple",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "northern_temple_bonus_buy": {
        name: "Northern Temple Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "not_yet_another_irish_game_94": {
        name: "Not Yet Another Irish Game 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "nugget": {
        name: "Nugget",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "nugget_n_nonsense": {
        name: "Nugget N' Nonsense",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "nuke_world": {
        name: "Nuke World",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "number_king": {
        name: "Number King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "nuwa": {
        name: "Nuwa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "nuwa_deluxe": {
        name: "Nuwa Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "oasis_of_dead": {
        name: "Oasis of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "oasis_poker_classic": {
        name: "Oasis Poker Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "oath_of_steel": {
        name: "Oath of Steel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ocean_catch_bonus_buy": {
        name: "Ocean Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ocean_king_jackpot": {
        name: "Ocean King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "ocean_party": {
        name: "Ocean party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "oceans_call": {
        name: "Ocean's Call",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "oceans_treasure": {
        name: "Ocean's Treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "octo_attack": {
        name: "Octo Attack",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "octobeer_fortunes": {
        name: "Octobeer Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "october_pub": {
        name: "October Pub",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "octopus_treasure": {
        name: "Octopus Treasure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "odin_infinity_reels": {
        name: "Odin Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "odin_infinity_reels_megaways": {
        name: "Odin Infinity Reels Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "odin_lightning_blitz": {
        name: "Odin Lightning Blitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "odin_protector_of_realms": {
        name: "Odin: Protector of Realms",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "oiran_dream": {
        name: "Oiran Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oiran_dream_xmas": {
        name: "Oiran Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oiran_hearts": {
        name: "Oiran Hearts",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oishi_delights": {
        name: "Oishi Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "olaf_viking": {
        name: "Olaf Viking",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "old_fisherman": {
        name: "Old Fisherman",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "old_gold_miner_megaways": {
        name: "Old Gold Miner MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "old_west": {
        name: "Old West",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "olymp_fortunes": {
        name: "Olymp Fortunes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "olympian_legends": {
        name: "Olympian Legends",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "olympus_legend": {
        name: "Olympus Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "olympus_trueways": {
        name: "Olympus Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "olympus_unleashed": {
        name: "Olympus Unleashed",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "omnom": {
        name: "OmNom",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "one_blackjack": {
        name: "One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "one_blackjack_dutch": {
        name: "ONE Blackjack - Dutch",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "one_blackjack_ruby": {
        name: "ONE Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "one_coins": {
        name: "One Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "oodles_of_noodles": {
        name: "Oodles of Noodles",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "oof_the_goldmine_planet": {
        name: "OOF The Goldmine Planet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "open_it": {
        name: "Open It",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "opera_dynasty": {
        name: "Opera Dynasty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "oracle_of_gold": {
        name: "Oracle of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "orb_of_destiny": {
        name: "Orb of Destiny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "orbs_of_atlantis": {
        name: "Orbs of Atlantis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "orcas_wild_bonanza": {
        name: "Orca's Wild Bonanza",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "oriental_prosperity": {
        name: "Oriental Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "oriental_treasures": {
        name: "Oriental Treasures",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "out_of_the_ice": {
        name: "Out of the Ice",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "out_of_the_woods": {
        name: "Out of the Woods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "outlaws": {
        name: "Outlaws",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "outlaws_inc": {
        name: "Outlaws Inc.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "overdrive": {
        name: "Overdrive",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "ox_coin": {
        name: "Ox Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "ozzy_osbourne_video_slots": {
        name: "Ozzy Osbourne Video Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "pachin_girl": {
        name: "Pachin Girl",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "pack_and_cash": {
        name: "Pack and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "paddys_pooches": {
        name: "Paddy's Pooches",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "paddys_pool_party": {
        name: "Paddy's Pool Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "paint_scratch": {
        name: "Paint Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "pamper_me": {
        name: "Pamper Me",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "panda_fortune_2": {
        name: "Panda Fortune 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "panda_fortune_rush": {
        name: "Panda Fortune Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "panda_gold_scratch_50000": {
        name: "Panda Gold Scratch 50,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "panda_luck": {
        name: "Panda Luck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "panda_panda": {
        name: "Panda Panda",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pandas_fortune": {
        name: "Panda's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pandas_fortune_2": {
        name: "Panda's Fortune 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pandas_jackpot": {
        name: "Panda’s Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "pandas_run": {
        name: "Pandas Run",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "pandastic_adventure": {
        name: "Pandastic Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pandavas": {
        name: "Pandavas",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "pandemic_rising": {
        name: "Pandemic Rising",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pandoras_box_of_evil": {
        name: "Pandora's Box of Evil",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pandoras_treasure": {
        name: "Pandora’s Treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "pantera_rica": {
        name: "Pantera Rica",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "panthers_reign": {
        name: "Panthers Reign",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "papaya_pop": {
        name: "Papaya Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "paper_plane": {
        name: "Paper Plane",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "paper_plane_crash": {
        name: "Paper Plane Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "pappu": {
        name: "PAPPU",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "paradise_ticket": {
        name: "Paradise Ticket",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "paris_nights": {
        name: "Paris Nights",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "parthenon_quest_for_immortality": {
        name: "Parthenon: Quest for Immortality",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "party_ape": {
        name: "Party Ape",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "party_night": {
        name: "Party Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "patricks_club_three_pots": {
        name: "Patrick's Club Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "patricks_magic_field": {
        name: "Patrick's Magic Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "pay_dirt": {
        name: "Pay Dirt",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "pay_pig_10k_ways": {
        name: "Pay Pig 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "pay4d_speed_baccarat": {
        name: "PAY4D SPEED BACCARAT",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "payday_megaways": {
        name: "Payday MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "payday_pig": {
        name: "Payday Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "pearl_diver": {
        name: "Pearl Diver",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "pearl_lagoon": {
        name: "Pearl Lagoon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pearl_o_plinko": {
        name: "Pearl O Plinko",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pearl_o_plinko_mermaid": {
        name: "Pearl O Plinko Mermaid",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pearl_reef_gigablox_multimax": {
        name: "Pearl Reef Gigablox Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "pearls_of_bingo": {
        name: "Pearls of Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pearls_of_india": {
        name: "Pearls of India",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "peking_luck": {
        name: "Peking Luck",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "penalty": {
        name: "Penalty",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "penalty_duel": {
        name: "Penalty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "penalty_duel_with_julio_cesar": {
        name: "Penalty Duel with Julio Cesar",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "penalty_kicks": {
        name: "Penalty Kicks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "penalty_roulette": {
        name: "Penalty Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_series": {
        name: "Penalty Series",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_shoot_out_cup_mania": {
        name: "Penalty Shoot Out: Cup Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_shoot_out_super_cup": {
        name: "Penalty Shoot Out Super Cup",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_shoot_out_super_spin": {
        name: "Penalty Shoot Out Super Spin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_shootout": {
        name: "Penalty Shoot-out",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penalty_shootout_street": {
        name: "Penalty Shoot-out: Street",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "penguins_christmas_party_time": {
        name: "Penguins Christmas Party Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pengwins": {
        name: "PengWins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "penny_pelican": {
        name: "Penny Pelican",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "peppes_pepperoni_pizza_plaza": {
        name: "Peppe's Pepperoni Pizza Plaza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "perfect_catch": {
        name: "Perfect Catch",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "perfect_fishing": {
        name: "Perfect Fishing",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "perfect_gems": {
        name: "Perfect Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "perfect_strike": {
        name: "Perfect Strike",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "peter_hunter": {
        name: "Peter Hunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "phantom_pulse": {
        name: "Phantom Pulse",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "phantoms_mirror": {
        name: "Phantom's Mirror",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "pharaoh_royale": {
        name: "Pharaoh Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pharaoh_treasure": {
        name: "Pharaoh Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pharaohs_gaze_doublemax": {
        name: "Pharaoh's Gaze Doublemax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "pharaohs_last_wish": {
        name: "Pharaoh's Last Wish",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "pharaohs_rage_ultraspinz": {
        name: "Pharaoh's Rage Ultraspinz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "pharaos_riches": {
        name: "Pharao's Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "pharaos_riches_gdn": {
        name: "Pharao's Riches GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "pharaos_riches_rhfp": {
        name: "Pharao's Riches RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "phoenix_duelreels": {
        name: "Phoenix DuelReels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "phoenix_forge": {
        name: "Phoenix Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "phoenix_fury": {
        name: "Phoenix Fury",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "phoenix_inferno": {
        name: "Phoenix Inferno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "phoenix_reborn": {
        name: "Phoenix Reborn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "phoenix_rises": {
        name: "Phoenix Rises",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "phoenix_sun": {
        name: "Phoenix Sun",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "phoenix_up_cash": {
        name: "Phoenix Up Cash",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "photo_safari": {
        name: "Photo Safari",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pia": {
        name: "Pia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "picture_this_cute_christmas": {
        name: "Picture This Cute Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "picture_this_xxmas": {
        name: "Picture This XXmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "pied_piper": {
        name: "Pied Piper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pig_wizard_cash_lock": {
        name: "Pig Wizard Cash Lock",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "piggies_prize_party": {
        name: "Piggies Prize Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "piggy_bank_3_pots_bonanza": {
        name: "Piggy Bank 3 Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "piggy_bank_bills": {
        name: "Piggy Bank Bills",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "piggy_bank_cash": {
        name: "Piggy Bank Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "piggy_bank_farm": {
        name: "Piggy Bank Farm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_bank_hold_and_win": {
        name: "Piggy Bank Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "piggy_bank_millionaire": {
        name: "Piggy Bank Millionaire",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "piggy_bank_riches": {
        name: "Piggy Bank Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "piggy_bank_run_shriek_streak": {
        name: "Piggy Bank Run Shriek Streak",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "piggy_bank_stash": {
        name: "Piggy Bank Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "piggy_bankers": {
        name: "Piggy Bankers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "piggy_blitz": {
        name: "Piggy Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_blitz_casino_gold": {
        name: "Piggy Blitz Casino Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_blitz_disco_gold": {
        name: "Piggy Blitz Disco Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_clusters": {
        name: "Piggy Clusters",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "piggy_gold": {
        name: "Piggy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "piggy_heist": {
        name: "Piggy Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_plunder": {
        name: "Piggy Plunder",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "piggy_pop": {
        name: "Piggy Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "piggy_pop_grand_affair_2": {
        name: "Piggy Pop Grand Affair 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "piggy_riches": {
        name: "Piggy Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "piggy_riches_3_hog_heaven": {
        name: "Piggy Riches 3 Hog Heaven",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "piggy_rush": {
        name: "Piggy Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "piggypop_grand_affair": {
        name: "PiggyPop Grand Affair",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pilgrim_of_dead": {
        name: "Pilgrim of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pillage_the_village_10k_ways": {
        name: "Pillage The Village 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "pimped": {
        name: "Pimped",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pin_rush_x": {
        name: "Pin Rush X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "pinata_go_go": {
        name: "Pinata Go Go",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "pinata_loca": {
        name: "Pinata Loca",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "pinata_wins": {
        name: "Pinata Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pine_of_plinko": {
        name: "Pine of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "pine_of_plinko_2": {
        name: "Pine of Plinko 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "pineapple_crush": {
        name: "Pineapple Crush",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pinup_girls": {
        name: "Pinup Girls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirahna_pays": {
        name: "Pirahna Pays",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pirate_armada": {
        name: "Pirate Armada",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "pirate_coins": {
        name: "Pirate Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "pirate_gold": {
        name: "Pirate Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirate_gold_deluxe": {
        name: "Pirate Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirate_golden_age": {
        name: "Pirate Golden Age",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirate_kingdom_megaways": {
        name: "Pirate Kingdom Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "pirate_multi_coins": {
        name: "Pirate Multi Coins",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "pirate_queen": {
        name: "Pirate Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pirate_queen_2": {
        name: "Pirate Queen 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pirate_queen_treasure_raid": {
        name: "Pirate Queen: Treasure Raid",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "pirates_charm": {
        name: "Pirate's Charm",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pirates_gold": {
        name: "Pirate's Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "pirates_gold_jp": {
        name: "Pirates Gold JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "pirates_party": {
        name: "Pirates Party",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "pirates_plunder": {
        name: "Pirate's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pirates_pub": {
        name: "Pirates Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirates_treasure": {
        name: "Pirate's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "pixel_eater": {
        name: "Pixel Eater",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "pixel_paws": {
        name: "Pixel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pixel_poker": {
        name: "Pixel Poker",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "pixie_wings": {
        name: "Pixie Wings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pixiemagic_color_game": {
        name: "PixieMagic Color Game",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pixiepop": {
        name: "PixiePop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pizza_pizza_pizza": {
        name: "PIZZA PIZZA PIZZA",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pizza_time": {
        name: "Pizza Time",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "planet_fortune": {
        name: "Planet Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "planets_power": {
        name: "Planets Power",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "platinum_lightning": {
        name: "Platinum Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "platinum_lightning_deluxe": {
        name: "Platinum Lightning Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "platinum_roulette": {
        name: "Platinum Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "play_me": {
        name: "Play Me",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "playzia_coin_flip": {
        name: "Playzia Coin Flip",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia_magic_7": {
        name: "Playzia Magic 7",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia_plinko": {
        name: "Playzia Plinko",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia_wheel": {
        name: "Playzia Wheel",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "plenty_o_fish": {
        name: "Plenty o' Fish",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "plingoball": {
        name: "PlingoBall",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "plinko": {
        name: "Plinko+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "plinko_2": {
        name: "Plinko 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "plinko_2_halloween": {
        name: "Plinko 2 Halloween",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "plinko_blast": {
        name: "Plinko Blast",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "plinko_dice": {
        name: "Plinko Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "plinko_go": {
        name: "Plinko Go",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "plinko_of_mine": {
        name: "Plinko of Mine",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "plinko_xy": {
        name: "Plinko XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "plinkoman": {
        name: "Plinkoman",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "plunderland": {
        name: "Plunderland",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "plushie_frenzy": {
        name: "Plushie Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "plushie_peril": {
        name: "Plushie Peril",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "poco_loco_hot_hot_chili_climb": {
        name: "Poco Loco Hot Hot Chili Climb",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "poker_gamble_beat_the_dealer": {
        name: "Poker Gamble Beat the Dealer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "poker_king": {
        name: "Poker King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "poker_kingdom_win": {
        name: "Poker Kingdom Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "polar_buffalo_extreme_hold_and_win_25000": {
        name: "Polar Buffalo Extreme Hold and Win 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "polar_paws": {
        name: "Polar Paws",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pompeii_megareels_megaways": {
        name: "Pompeii Megareels Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pond_of_plinko": {
        name: "Pond of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "pool_shark": {
        name: "Pool Shark",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pop_cop": {
        name: "Pop Cop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "pop_monsters_cutesy_clash": {
        name: "Pop Monsters: Cutesy Clash",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pop_noir": {
        name: "Pop Noir",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_ogold": {
        name: "Pop o'Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_popcorns": {
        name: "Pop Popcorns",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "pop_rocks": {
        name: "Pop Rocks",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_till_you_drop": {
        name: "Pop TIll You Drop",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "pop_zen": {
        name: "Pop Zen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "port_of_fortune": {
        name: "Port of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "poseidon": {
        name: "Poseidon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pot_of_fortune": {
        name: "Pot of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "potion_of_madness": {
        name: "Potion of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "potion_power": {
        name: "Potion Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "potion_spells": {
        name: "Potion Spells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "potion_wizard": {
        name: "Potion Wizard",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pots_of_power_zeus": {
        name: "Pots of Power Zeus",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "power_ball_1_min": {
        name: "Power Ball 1 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_ball_2_min": {
        name: "Power Ball 2 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_ball_3_min": {
        name: "Power Ball 3 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_ball_4_min": {
        name: "Power Ball 4 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_ball_5_min": {
        name: "Power Ball 5 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_of_atlantis_trio": {
        name: "Power of Atlantis Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_elements": {
        name: "Power of Elements",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "power_of_god_medusa_extremely_light": {
        name: "Power of God: Medusa Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_egypt": {
        name: "Power of Gods: Egypt",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_hades": {
        name: "Power of Gods: Hades",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_medusa": {
        name: "Power of Gods: Medusa",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_the_pantheon": {
        name: "Power of Gods: The Pantheon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_valhalla": {
        name: "Power of Gods: Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_valhalla_extremely_light": {
        name: "Power of Gods: Valhalla Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_hercules_bonanza": {
        name: "Power of Hercules Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_merlin_megaways": {
        name: "Power of Merlin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_of_ninja": {
        name: "Power of Ninja",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_of_olympus": {
        name: "Power of Olympus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_rome": {
        name: "Power of Rome",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_sun_svarog": {
        name: "Power of Sun: Svarog",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_ten": {
        name: "Power of Ten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "power_of_thor_megaways": {
        name: "Power of Thor MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_paws": {
        name: "Power Paws",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "power_pets": {
        name: "Power Pets",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "power_play": {
        name: "Power Play",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "power_strike_hyper_hits_94": {
        name: "Power Strike Hyper Hits 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "power_sun": {
        name: "Power Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "power_sun_xxl": {
        name: "Power Sun XXL",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "power_vault": {
        name: "Power Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "powerspin": {
        name: "Powerspin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "powerup_roulette": {
        name: "PowerUp Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "powerups": {
        name: "Power-ups",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "pragmatic_live_lobby": {
        name: "Pragmatic Live Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic_play_live_lobby": {
        name: "Pragmatic Play Live Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pray_for_six": {
        name: "Pray for Six",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "pray_for_three": {
        name: "Pray for Three",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "precious_7": {
        name: "Precious 7",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "presto": {
        name: "Presto!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pride_fight": {
        name: "Pride Fight",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "primal_hunter_gigablox": {
        name: "Primal Hunter Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "primal_megaways": {
        name: "Primal Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "primal_rampage": {
        name: "Primal Rampage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prime_zone": {
        name: "Prime Zone",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "prince_of_purrwood": {
        name: "Prince of Purrwood",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "prince_treasure": {
        name: "Prince Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "princess_pea_and_royal_wild": {
        name: "Princess, Pea and Royal Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "princess_royal": {
        name: "Princess Royal",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "prism_of_gems": {
        name: "Prism of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prissy_princess": {
        name: "Prissy Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prive_lounge_baccarat": {
        name: "Prive Lounge Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "prive_lounge_blackjack": {
        name: "Prive Lounge Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "prive_lounge_russian_poker": {
        name: "Prive Lounge Russian Poker",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "professor_clanks_combinator": {
        name: "Professor Clank's Combinator",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "prospector_wilds": {
        name: "Prospector Wilds",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospector_wilds_gold_digga": {
        name: "Prospector Wilds: Gold Digga",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospector_wilds_hold_and_win": {
        name: "Prospector Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospector_wilds_megaways": {
        name: "Prospector Wilds Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospector_wilds_minecart_madness": {
        name: "Prospector Wilds Minecart Madness",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospector_wilds_wild_carts": {
        name: "Prospector Wilds: Wild Carts",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prosperity_fortune_tree": {
        name: "Prosperity Fortune Tree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "prosperity_horse": {
        name: "Prosperity Horse",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "prosperity_lion": {
        name: "Prosperity Lion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "prosperity_palace": {
        name: "Prosperity Palace",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prosperity_pearls": {
        name: "Prosperity Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "prosperity_reels": {
        name: "Prosperity Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "prost": {
        name: "Prost!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "psycho_candies": {
        name: "Psycho Candies",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "pub_kings": {
        name: "Pub Kings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pucker_up_prince": {
        name: "Pucker Up Prince",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "puebla_parade": {
        name: "Puebla Parade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pug_life": {
        name: "Pug Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "pulled_from_the_deep_ultranudge": {
        name: "Pulled from the Deep Ultranudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "pumped_up": {
        name: "Pumped Up",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "pumpkin_master": {
        name: "Pumpkin Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "pumpkin_patch": {
        name: "Pumpkin Patch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "punch_club": {
        name: "Punch Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "punk_penguin": {
        name: "Punk Penguin",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "punk_rocks": {
        name: "Punk Rocks",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "punto_banco_italia_tricolore": {
        name: "Punto Banco Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "puppy_payday": {
        name: "Puppy Payday",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "purple_diamonds": {
        name: "Purple Diamonds",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "purrfect_potions": {
        name: "Purrfect Potions",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "purrrminator": {
        name: "Purrrminator",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "pusoy_go": {
        name: "Pusoy Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "pyramid_bonanza": {
        name: "Pyramid Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pyramid_king": {
        name: "Pyramid King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pyramid_quest_for_immortality": {
        name: "Pyramid: Quest for Immortality",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "pyramid_rising_x33": {
        name: "Pyramid Rising x33",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "pyramids_of_cash_reel_bingo": {
        name: "Pyramids Of Cash Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "pyramids_of_gold": {
        name: "Pyramids of Gold",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "pyro_joker": {
        name: "Pyro Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "quackin_reels": {
        name: "Quackin Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "queen_of_bounty": {
        name: "Queen of Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "queen_of_embers": {
        name: "Queen of Embers",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "queen_of_gods": {
        name: "Queen of Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queen_of_gold": {
        name: "Queen of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queen_of_gold_scratch_100000": {
        name: "Queen of Gold Scratch 100,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queen_of_queens": {
        name: "Queen of Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "queen_of_queens_ii": {
        name: "Queen of Queens II",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "queen_of_sirens": {
        name: "Queen of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "queen_treasure": {
        name: "Queen Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "queenie": {
        name: "Queenie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queens_bow": {
        name: "Queen's Bow",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "queens_day_tilt": {
        name: "Queen's Day Tilt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "quest": {
        name: "Quest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "quests_of_olympus": {
        name: "Quests of Olympus",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "rabbit_garden": {
        name: "Rabbit Garden",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rabbit_hole_riches": {
        name: "Rabbit Hole Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rabid_randy": {
        name: "Rabid Randy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "raccoon_tales": {
        name: "Raccoon Tales",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "racing_royalty": {
        name: "Racing Royalty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rad_maxx": {
        name: "Rad Maxx",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rage": {
        name: "Rage",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "rage_of_the_seas": {
        name: "Rage of the Seas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "rage_to_riches": {
        name: "Rage to Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_bull": {
        name: "Raging Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "raging_pop": {
        name: "Raging Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "raging_rabbits": {
        name: "Raging Rabbits",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "raging_rex": {
        name: "Raging Rex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_rex_2": {
        name: "Raging Rex 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_rex_3": {
        name: "Raging Rex 3",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_riches": {
        name: "Raging Riches",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "raging_waterfall_megaways": {
        name: "Raging Waterfall Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ragnarok": {
        name: "Ragnarok",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ragnarok_40k": {
        name: "Ragnarok 40k",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "raid_the_piggy_bank": {
        name: "Raid the Piggy Bank",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "raiden_shogun": {
        name: "Raiden Shogun",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "raider_janes_crypt_of_fortune": {
        name: "Raider Jane's Crypt of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "raiders_of_the_sea": {
        name: "Raiders of the Sea",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "raiders_of_valhalla_megaways": {
        name: "Raiders of Valhalla Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "raigeki_rising_x30": {
        name: "Raigeki Rising x30",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "rainbow_3x3": {
        name: "Rainbow 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "rainbow_falls": {
        name: "Rainbow Falls",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rainbow_gold": {
        name: "Rainbow Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rainbow_power_potz_ultranudge": {
        name: "Rainbow Power Potz UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "rainbow_princess": {
        name: "Rainbow Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rainbow_reels": {
        name: "Rainbow Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rainbow_run_with_run_amok": {
        name: "Rainbow Run with Run Amok",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rainbow_rush": {
        name: "Rainbow Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "rainbow_wilds_megaways": {
        name: "Rainbow Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rainbow_wilds_scratch": {
        name: "Rainbow Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rainbowmania": {
        name: "Rainbowmania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rainforest_gold": {
        name: "Rainforest Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "rainforest_magic": {
        name: "Rainforest Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rainforest_magic_bingo": {
        name: "Rainforest Magic Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rainin_money": {
        name: "Rainin Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "raja_mantri_chor_sipahi": {
        name: "Raja Mantri Chor Sipahi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "rally_4_riches": {
        name: "Rally 4 Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rambo": {
        name: "Rambo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "ramesses_gold_10k_ways": {
        name: "Ramesses Gold 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "ramses_book": {
        name: "Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_christmas_edition": {
        name: "Ramses Book Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_deluxe": {
        name: "Ramses Book Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_easter_edition": {
        name: "Ramses Book Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_flaming_link": {
        name: "Ramses Book Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_gdn": {
        name: "Ramses Book GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_respins_of_amunre": {
        name: "Ramses Book Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_rhfp": {
        name: "Ramses Book RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_revenge": {
        name: "Ramses Revenge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "rapid_gems_777": {
        name: "Rapid Gems 777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "rapid_randy_dark_trails": {
        name: "Rapid Randy Dark Trails",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "rapunzels_tower": {
        name: "Rapunzel's Tower",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ras_reckoning": {
        name: "Ra's Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ras_relics_bonanza": {
        name: "Ra's Relics Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "rascal_riches": {
        name: "Rascal Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rat_king": {
        name: "Rat King",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "rat_riches": {
        name: "Rat Riches",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "raul_the_vampire": {
        name: "Raul the Vampire",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "rave_party_fever": {
        name: "Rave Party Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rave_up": {
        name: "Rave UP",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "razor_returns": {
        name: "Razor Returns",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "razor_shark": {
        name: "Razor Shark",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "razor_shark_jackpots": {
        name: "Razor Shark Jackpots",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "razor_ways": {
        name: "Razor Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "razortooth": {
        name: "Razortooth",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "reactoonz": {
        name: "Reactoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "reactoonz_100": {
        name: "Reactoonz 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "reactoonz_2": {
        name: "Reactoonz 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ready_yeti_go_rb": {
        name: "Ready Yeti Go RB",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready_yeti_go_reel_bingo": {
        name: "Ready Yeti Go Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready_yeti_go_respin": {
        name: "Ready Yeti Go Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready_yeti_respin": {
        name: "Ready Yeti Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready_yeti_respin_chasing_cheddar": {
        name: "Ready Yeti Respin Chasing Cheddar",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reapers": {
        name: "Reapers",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "rebel_paws": {
        name: "Rebel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reborn_of_zeus_3000": {
        name: "Reborn of Zeus 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "recycle_riches": {
        name: "Recycle Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "red_card": {
        name: "Red Card",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "red_cliff": {
        name: "Red Cliff",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "red_envelope_riches": {
        name: "Red Envelope Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "red_head_bounty": {
        name: "Red Head Bounty",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "red_hot_catch": {
        name: "Red Hot Catch",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_chilli": {
        name: "Red Hot Chilli",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_eruption": {
        name: "Red Hot Eruption",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_multipliers": {
        name: "Red Hot Multipliers",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "red_lights": {
        name: "Red Lights",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "red_queen": {
        name: "Red Queen",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "red_queen_blackjack": {
        name: "Red Queen Blackjack",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "red_rascal": {
        name: "Red Rascal",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "red_zone_blitz": {
        name: "Red Zone Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "red_zone_blitz_hold_and_win": {
        name: "Red Zone Blitz Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "redbeards_rum_runners_doublemax": {
        name: "Redbeards Rum Runners Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "redrose_sanctuary": {
        name: "Redrose Sanctuary",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "redrose_sanctuary_bonus_buy": {
        name: "Redrose Sanctuary Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "reef_pop": {
        name: "Reef Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reef_raider": {
        name: "Reef Raider",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "reel_banks": {
        name: "Reel Banks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "reel_bass_family": {
        name: "Reel Bass Family",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "reel_diamonds": {
        name: "Reel Diamonds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "reel_fruits": {
        name: "Reel Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "reel_goal_cash_towers": {
        name: "Reel Goal Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "reel_hero": {
        name: "Reel Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "reel_joke": {
        name: "Reel Joke",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "reel_love": {
        name: "Reel Love",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "reel_nightmare": {
        name: "Reel Nightmare",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "reel_of_ra": {
        name: "Reel of Ra",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "reel_rampage": {
        name: "Reel Rampage",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "reel_royale_showdown": {
        name: "Reel Royale Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "reel_rush": {
        name: "Reel Rush",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "reel_rush_2": {
        name: "Reel Rush 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "reel_rush_xxxtreme": {
        name: "Reel Rush XXXTreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "reel_steal": {
        name: "Reel Steal",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "reel_warriors": {
        name: "Reel Warriors",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reels": {
        name: "Reels",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "reels_2_riches": {
        name: "Reels 2 Riches",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reels_2_riches_reel_bingo": {
        name: "Reels 2 Riches Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reels_2_riches_reel_triple": {
        name: "Reels 2 Riches Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reels_paradise": {
        name: "Reels Paradise",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "regal_knights": {
        name: "Regal Knights",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "reign_of_dragons": {
        name: "Reign of Dragons",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "reign_of_maximus": {
        name: "Reign of Maximus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "reign_of_rome": {
        name: "Reign of Rome",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "release_the_bison": {
        name: "Release the Bison",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken": {
        name: "Release the Kraken",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken_2": {
        name: "Release the Kraken 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken_megaways": {
        name: "Release the Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "relic_hunters_and_the_book_of_faith": {
        name: "Relic Hunters and the Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "remember_remember": {
        name: "Remember Remember",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reno_7s": {
        name: "Reno 7's",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "resurrecting_riches": {
        name: "Resurrecting Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "retro_solitaire": {
        name: "Retro Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "retro_sweets": {
        name: "Retro Sweets",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "retro_tapes": {
        name: "Retro Tapes",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "retro_trader": {
        name: "Retro Trader",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "retropia": {
        name: "Retropia",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "retroverse": {
        name: "Retroverse",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "return_of_kong_megaways": {
        name: "Return of Kong Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "return_of_the_dead": {
        name: "Return of the Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "return_to_the_feature": {
        name: "Return To The Feature",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "returntovalhalla": {
        name: "ReturnToValhalla",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "revenge_of_loki_megaways": {
        name: "Revenge of Loki Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rhino_hold_and_win": {
        name: "Rhino Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "rhino_king": {
        name: "Rhino King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "rhino_king_777jackpot": {
        name: "Rhino King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "rhino_rampage": {
        name: "Rhino Rampage",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rich_panda": {
        name: "Rich Panda",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "rich_raptors": {
        name: "Rich Raptors",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "rich_reels": {
        name: "Rich Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rich_wilde_and_the_amulet_of_dead": {
        name: "Rich Wilde and The Amulet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_pearls_of_vishnu": {
        name: "Rich Wilde and the Pearls of Vishnu",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_shield_of_athena": {
        name: "Rich Wilde and the Shield of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_dead": {
        name: "Rich Wilde and the Tome of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_insanity": {
        name: "Rich Wilde and the Tome of Insanity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_madness": {
        name: "Rich Wilde and the Tome of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_wandering_city": {
        name: "Rich Wilde and the Wandering City",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_midgard_land_and_expand": {
        name: "Riches of Midgard: Land and Expand",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "riches_of_olympus": {
        name: "Riches of Olympus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "riches_of_ra": {
        name: "Riches of RA",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_robin": {
        name: "Riches of Robin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_zeus": {
        name: "Riches of Zeus",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "riddle_reels_a_case_of_riches": {
        name: "Riddle Reels: A Case of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ride_em_cowboy": {
        name: "Ride 'em Cowboy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ride_the_lightning": {
        name: "Ride the Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ring_of_odin": {
        name: "Ring of Odin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rings_of_prosperity": {
        name: "Rings of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rio_fantasia": {
        name: "Rio Fantasia",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rio_gems": {
        name: "Rio Gems",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "rip_city": {
        name: "RIP City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ripe_rewards": {
        name: "Ripe Rewards",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_apollo": {
        name: "Rise of Apollo",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rise_of_athena": {
        name: "Rise of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_atlantis": {
        name: "Rise of Atlantis",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rise_of_atlantis_2": {
        name: "Rise of Atlantis 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rise_of_atlantis_legacy": {
        name: "Rise of Atlantis Legacy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rise_of_dead": {
        name: "Rise of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_fortuna": {
        name: "Rise of Fortuna",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rise_of_giza_powernudge": {
        name: "Rise of Giza PowerNudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_gods_reckoning": {
        name: "Rise of Gods: Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_horus": {
        name: "Rise of Horus",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rise_of_maya": {
        name: "Rise of Maya",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "rise_of_merlin": {
        name: "Rise of Merlin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus": {
        name: "Rise of Olympus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_100": {
        name: "Rise of Olympus 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_1000": {
        name: "Rise of Olympus 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_bingo": {
        name: "Rise of Olympus Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_extreme": {
        name: "Rise of Olympus Extreme",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_origins": {
        name: "Rise of Olympus Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_orpheus": {
        name: "Rise of Orpheus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_pyramids": {
        name: "Rise of Pyramids",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai": {
        name: "Rise of Samurai",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_4": {
        name: "Rise of Samurai 4",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_iii": {
        name: "Rise of Samurai III",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_megaways": {
        name: "Rise of Samurai MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_the_pharaohs": {
        name: "Rise of the Pharaohs",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "rise_of_ymir": {
        name: "Rise of Ymir",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "river_n_blues": {
        name: "River n' Blues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "road_2_riches": {
        name: "Road 2 Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "road_trip": {
        name: "Road Trip",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "roadquake": {
        name: "Roadquake",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robber_strike": {
        name: "Robber Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "robbin_robin": {
        name: "Robbin Robin",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "robbits": {
        name: "Robbits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "robin_hood": {
        name: "Robin Hood",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "robin_hood_shifting_riches": {
        name: "Robin Hood: Shifting Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "robin_in_the_hood": {
        name: "Robin in the Hood",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "robin_nottingham_raiders": {
        name: "Robin - Nottingham Raiders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robin_sherwood_marauders": {
        name: "Robin - Sherwood Marauders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robinson": {
        name: "Robinson",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "robospin": {
        name: "Robospin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "robots_energy_conflict": {
        name: "Robots: Energy Conflict",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "roby_dick": {
        name: "Roby Dick",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "rocco_gallo": {
        name: "Rocco Gallo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rock_paper_scissors": {
        name: "Rock Paper Scissors",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "rock_paper_scissors_draw": {
        name: "Rock Paper Scissors Draw",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "rock_vegas": {
        name: "Rock Vegas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rock_vs_paper_vikings_mode": {
        name: "Rock vs Paper: Viking’s mode",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rocket_blast_megaways": {
        name: "Rocket Blast Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rocket_dice": {
        name: "Rocket Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rocket_dice_xy": {
        name: "Rocket Dice XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rocket_eruption_triple_blast": {
        name: "Rocket Eruption Triple Blast",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rocket_reels": {
        name: "Rocket Reels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rocket_stars": {
        name: "Rocket Stars",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rocketon": {
        name: "Rocketon",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "rockys_gold": {
        name: "Rocky's Gold",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "rodeo_drive": {
        name: "Rodeo Drive",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "roll_the_dice": {
        name: "Roll the Dice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "roll_to_luck": {
        name: "Roll to Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rolling_in_treasures": {
        name: "Rolling in Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rolling_roger": {
        name: "Rolling Roger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rolling_start_usa": {
        name: "Rolling Start USA",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "roma_x_10000": {
        name: "Roma X 10000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "roma_x_deluxe": {
        name: "Roma X Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "roman_empire": {
        name: "Roman Empire",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "roman_glory": {
        name: "Roman Glory",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "roman_legion": {
        name: "Roman Legion",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_deluxe": {
        name: "Roman Legion Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_extreme": {
        name: "Roman Legion Extreme",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_extreme_rhfp": {
        name: "Roman Legion Extreme RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_flaming_link": {
        name: "Roman Legion Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_gdn": {
        name: "Roman Legion GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_rule": {
        name: "Roman Rule",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "romanian_roulette": {
        name: "Romanian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "romax": {
        name: "RomaX",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "rome_the_conquerors": {
        name: "Rome - The Conquerors",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "rome_the_golden_age": {
        name: "Rome: The Golden Age",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "romeo_and_juliet": {
        name: "Romeo and Juliet",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ronaldinho_scores_shoot_and_win": {
        name: "Ronaldinho Scores Shoot and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronaldinho_spins": {
        name: "Ronaldinho Spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronaldinhos_streetball_bonanza": {
        name: "Ronaldinho's Streetball Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronin_stackways": {
        name: "Ronin Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ronins_honour": {
        name: "Ronin's Honour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rooster_rumble": {
        name: "Rooster Rumble",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rosy_orbit_treasure_turn": {
        name: "Rosy Orbit Treasure Turn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rot_stormo": {
        name: "Rot Stormo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "rotating_element": {
        name: "Rotating Element",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rotiki": {
        name: "RoTiki",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rotten": {
        name: "Rotten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "roulette": {
        name: "Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_azure": {
        name: "Roulette - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_classic": {
        name: "Roulette Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "roulette_diamond": {
        name: "Roulette Diamond",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "roulette_dutch": {
        name: "Roulette - Dutch",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_german": {
        name: "Roulette - German",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_india": {
        name: "Roulette India",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_indian": {
        name: "Roulette - Indian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_italia_tricolore": {
        name: "Roulette Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_italian": {
        name: "Roulette - Italian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_latina": {
        name: "Roulette Latina",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_lobby": {
        name: "Roulette Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_macao": {
        name: "Roulette Macao",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_neo": {
        name: "Roulette Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "roulette_romanian": {
        name: "Roulette - Romanian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_ruby": {
        name: "Roulette Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_russian": {
        name: "Roulette - Russian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_spanish": {
        name: "Roulette - Spanish",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_the_club": {
        name: "Roulette - The Club",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_turkish": {
        name: "Roulette - Turkish",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_x": {
        name: "Roulette X",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "royal_7_xxl_rhfp": {
        name: "Royal 7 XXL RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_beellion_hold_and_win": {
        name: "Royal Beellion Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_dragon": {
        name: "Royal Dragon",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "royal_dragon_infinity_reels": {
        name: "Royal Dragon Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "royal_easter": {
        name: "Royal Easter",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_fishing": {
        name: "Royal Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "royal_fruits_multilines": {
        name: "Royal Fruits MultiLines",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_highroad": {
        name: "Royal High-Road",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_masquerade": {
        name: "Royal Masquerade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "royal_nuts": {
        name: "Royal Nuts",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "royal_potato": {
        name: "Royal Potato",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "royal_princess": {
        name: "Royal Princess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "royal_quest": {
        name: "Royal Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "royal_roulette_500x": {
        name: "Royal Roulette 500x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_ruby_featurestorm": {
        name: "Royal Ruby FeatureStorm",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "royal_seven": {
        name: "Royal Seven",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_deluxe": {
        name: "Royal Seven Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_flaming_link": {
        name: "Royal Seven Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_gdn": {
        name: "Royal Seven GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_ultra": {
        name: "Royal Seven Ultra",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_ultra_flaming_link": {
        name: "Royal Seven Ultra Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl": {
        name: "Royal Seven XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl_easter_edition": {
        name: "Royal Seven XXL Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl_flaming_link": {
        name: "Royal Seven XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_wins": {
        name: "Royal Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "royale_seven_deluxe_xxl_deluxe": {
        name: "Royale Seven Deluxe XXL Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ruby_rush": {
        name: "Ruby Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rudis": {
        name: "Rudis",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "rudolphs_gone_rogue": {
        name: "Rudolph's Gone Rogue",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "rueda_de_chile": {
        name: "Rueda de Chile",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rueda_de_chile_bonus_buy": {
        name: "Rueda de Chile Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ruff_heist": {
        name: "Ruff Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ruffled_up": {
        name: "Ruffled Up",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rujak_bonanza": {
        name: "Rujak Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rum_and_raiders": {
        name: "Rum and Raiders",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rumble_in_the_shadows": {
        name: "Rumble in the Shadows",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "rummy": {
        name: "Rummy",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "runaway_train": {
        name: "Runaway Train",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "runes_of_destiny": {
        name: "Runes of Destiny",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "running_sushi": {
        name: "Running Sushi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rush_for_gold": {
        name: "Rush for Gold",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "rush_riches": {
        name: "Rush Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "russian_prive_lounge_blackjack": {
        name: "Russian Prive Lounge Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "russian_roulette": {
        name: "Russian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "rust_world": {
        name: "Rust World",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "rusty_and_curly": {
        name: "Rusty and Curly",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "saanp_seedhi": {
        name: "Saanp Seedhi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "sabaton": {
        name: "Sabaton",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sacred_buffalo": {
        name: "Sacred Buffalo",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "safari_coins_heart_of_africa": {
        name: "Safari Coins: Heart of Africa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "safari_gold_megaways": {
        name: "Safari Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "safari_king": {
        name: "Safari King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "safari_kingdom": {
        name: "Safari Kingdom",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "safari_of_wealth": {
        name: "Safari of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "safari_race": {
        name: "Safari Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "safari_rumble": {
        name: "Safari Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "safari_run": {
        name: "Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "safari_sun": {
        name: "Safari Sun",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "safari_wilds": {
        name: "Safari Wilds",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "sails_of_fortune": {
        name: "Sails of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "sails_of_gold": {
        name: "Sails of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sails_of_riches": {
        name: "Sails of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "saint_nicked_2": {
        name: "Saint Nicked 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "saint_nicked_3_present_tense": {
        name: "Saint Nicked 3 Present Tense",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "saiyan_mania": {
        name: "Saiyan Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sakura_fortune": {
        name: "Sakura Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_fortune_2": {
        name: "Sakura Fortune 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_fortune_epic_bloom": {
        name: "Sakura Fortune Epic Bloom",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_riches_60": {
        name: "Sakura Riches 60",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "samba": {
        name: "Samba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "samba_carnival": {
        name: "Samba Carnival",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "samurai_code": {
        name: "Samurai Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "samurai_ikusa": {
        name: "Samurai Ikusa",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "samurais_katana": {
        name: "Samurai's Katana",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "sanatorium_secrets": {
        name: "Sanatorium Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sand_and_ashes": {
        name: "Sand and Ashes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sands_of_destiny": {
        name: "Sands of Destiny",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "sands_of_eternity": {
        name: "Sands of Eternity",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "sands_of_eternity_2": {
        name: "Sands of Eternity 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "santa": {
        name: "Santa",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santa_hopper": {
        name: "Santa Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "santa_in_the_summer": {
        name: "Santa in the Summer",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "santa_in_vegas": {
        name: "Santa in Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "santa_vs_rudolf": {
        name: "Santa vs Rudolf",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "santa_yetti": {
        name: "Santa Yetti",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "santas_big_bash_megaways": {
        name: "Santa's Big Bash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "santas_express_hold_and_win": {
        name: "Santa's Express Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "santas_gift_frenzy": {
        name: "Santa's Gift Frenzy",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "santas_gift_rush": {
        name: "Santa's Gift Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "santas_great_gifts": {
        name: "Santa's Great Gifts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_inn": {
        name: "Santa's Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "santas_reels": {
        name: "Santa’s Reels",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "santas_sack": {
        name: "Santa's Sack",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "santas_secret_party": {
        name: "Santa's Secret Party",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "santas_slay": {
        name: "Santa's Slay",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_snowball_smash_instant_win": {
        name: "Santas Snowball Smash Instant Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "santas_stack": {
        name: "Santa's Stack",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "santas_vault": {
        name: "Santa's Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "santas_village": {
        name: "Santa's Village",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "santas_wonderland": {
        name: "Santa's Wonderland",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_xmas_rush": {
        name: "Santa's Xmas Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sari_sari_store": {
        name: "Sari Sari Store",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "sassy_santa_christmas_crash": {
        name: "Sassy Santa Christmas Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "savage_buffalo_spirit": {
        name: "Savage Buffalo Spirit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "savage_buffalo_spirit_megaways": {
        name: "Savage Buffalo Spirit Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "savanna_moon": {
        name: "Savanna Moon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "savannah_king": {
        name: "Savannah King",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "savannah_legend": {
        name: "Savannah Legend",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "savannah_strike": {
        name: "Savannah Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "savannah_strike_extra": {
        name: "Savannah Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "save_the_hamster": {
        name: "Save the Hamster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "scales_of_dead": {
        name: "Scales of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scarab_rising": {
        name: "Scarab Rising",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "scarab_rising_megaways": {
        name: "Scarab Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "scarab_temple": {
        name: "Scarab Temple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "scepter_of_anubis": {
        name: "Scepter of Anubis",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "scopa": {
        name: "Scopa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "scourge_of_rome": {
        name: "Scourge of Rome",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scratch_alpaca_bronze": {
        name: "Scratch Alpaca Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "scratch_alpaca_gold": {
        name: "Scratch Alpaca Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "scratch_alpaca_silver": {
        name: "Scratch Alpaca Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "scratch_bronze": {
        name: "SCRATCH! Bronze",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_dice": {
        name: "Scratch Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "scratch_em": {
        name: "Scratch 'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_gold": {
        name: "SCRATCH! Gold",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_map": {
        name: "Scratch Map",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "scratch_match": {
        name: "Scratch Match",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "scratch_platinum": {
        name: "SCRATCH! Platinum",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_silver": {
        name: "SCRATCH! Silver",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy": {
        name: "Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy_big": {
        name: "Scratchy Big",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy_mini": {
        name: "Scratchy Mini",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scroll_of_adventure": {
        name: "Scroll of Adventure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "scroll_of_dead": {
        name: "Scroll of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scroll_of_seth": {
        name: "Scroll of Seth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scruffy_duck": {
        name: "Scruffy Duck",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "scruffy_scallywags": {
        name: "Scruffy Scallywags",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "scudamores_super_stakes": {
        name: "Scudamore's Super Stakes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "sea_fantasy": {
        name: "Sea Fantasy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sea_hunter": {
        name: "Sea Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sea_of_plenty": {
        name: "Sea of Plenty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sea_of_spins": {
        name: "Sea of Spins",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "sea_of_spirits": {
        name: "Sea of Spirits",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "sea_of_wealth": {
        name: "Sea of Wealth",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "sea_of_wealth_hunt_for_coin": {
        name: "Sea of Wealth: Hunt for Coin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "season_of_fortune": {
        name: "Season of Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "season_sisters": {
        name: "Season Sisters",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "second_chance": {
        name: "Second Chance",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "second_strike": {
        name: "Second Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "secret_ball": {
        name: "Secret Ball",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "secret_bar_multidice_x": {
        name: "Secret Bar Multidice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "secret_book_of_amun_ra": {
        name: "Secret Book of Amun Ra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "secret_city_gold": {
        name: "Secret City Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "secret_of_anubis_doublemax": {
        name: "Secret of Anubis Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "secret_of_dead": {
        name: "Secret of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "secret_of_earth": {
        name: "Secret of Earth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "secret_of_goddess": {
        name: "Secret of Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "secret_of_the_stones": {
        name: "Secret of the Stones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "secret_treasure": {
        name: "Secret Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "secrets_of_atlantis": {
        name: "Secrets of Atlantis",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "secrets_of_christmas": {
        name: "Secrets of Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "secrets_of_cleopatra": {
        name: "Secrets of Cleopatra",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "serendipity": {
        name: "Serendipity",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "serendipity_deluxe_6": {
        name: "Serendipity Deluxe 6",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "serengeti_kings": {
        name: "Serengeti Kings",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "serpent_shrine": {
        name: "Serpent Shrine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "sevens_and_books": {
        name: "Sevens & Books",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sevens_and_jok3rs": {
        name: "Sevens and Jok3rs",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sevens_and_suns": {
        name: "Sevens & Suns",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sevens_fire": {
        name: "Sevens Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sevens_high": {
        name: "Sevens High",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sevens_high_ultra": {
        name: "Sevens High Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sevensevenseven": {
        name: "SevenSevenSeven",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "shadow_of_luxor": {
        name: "Shadow of Luxor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "shadow_raiders_multimax": {
        name: "Shadow Raiders Multimax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "shadow_summoner_elementals": {
        name: "Shadow Summoner Elementals",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "shamrock_miner": {
        name: "Shamrock Miner",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shamrock_money_pot_10k_ways": {
        name: "Shamrock Money Pot 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "shamrock_quest": {
        name: "Shamrock Quest",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shamrock_saints": {
        name: "Shamrock Saints",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "shanghai_beauty": {
        name: "Shanghai Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "shaolin_crew": {
        name: "Shaolin Crew",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "shaolin_fortunes": {
        name: "Shaolin Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shaolin_fortunes_100": {
        name: "Shaolin Fortunes 100",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shaolin_master": {
        name: "Shaolin Master",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "shaolin_soccer": {
        name: "Shaolin Soccer",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "shaolins_tiger": {
        name: "Shaolin's Tiger",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "shark_and_spark_hold_and_win": {
        name: "Shark and Spark Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "shark_bait_94": {
        name: "Shark Bait 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "shark_feast": {
        name: "Shark Feast",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shark_frenzy": {
        name: "Shark Frenzy",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "shark_hunter": {
        name: "Shark Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "shark_wash": {
        name: "Shark Wash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "shave_the_beard": {
        name: "Shave the Beard",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "shave_the_sheep": {
        name: "Shave the Sheep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sheriff_colt": {
        name: "Sheriff Colt",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "sherlock_a_scandal_in_bohemia": {
        name: "Sherlock: A Scandal in Bohemia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sherlock_bones": {
        name: "Sherlock Bones",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "sherwood_gold": {
        name: "Sherwood Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shiba_inu": {
        name: "Shiba Inu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "shield_of_sparta": {
        name: "Shield of Sparta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shields_of_gold_valkyrie_hold_and_win": {
        name: "Shields of Gold Valkyrie Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "shields_of_lambda": {
        name: "Shields of Lambda",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "shimmering_woods": {
        name: "Shimmering Woods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shining_hot_100": {
        name: "Shining Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_100_jackpot_play": {
        name: "Shining Hot 100 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_20": {
        name: "Shining Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_20_jackpot_play": {
        name: "Shining Hot 20 Jackpot play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_40": {
        name: "Shining Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_40_jackpot_play": {
        name: "Shining Hot 40 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_5": {
        name: "Shining Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_5_jackpot_play": {
        name: "Shining Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shinobi_spirit": {
        name: "Shinobi Spirit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "shippy_d_pop": {
        name: "Shippy D Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "shivering_strings": {
        name: "Shivering Strings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shogun": {
        name: "Shogun",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "shoguns_land": {
        name: "Shogun's Land",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shoguns_secret": {
        name: "Shogun's Secret",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "shoguns_secret_ccs": {
        name: "Shogun's Secret CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "shoot_piggy": {
        name: "Shoot Piggy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "si_xiang_scratch": {
        name: "Si Xiang Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sic_bo": {
        name: "Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sic_bo_888": {
        name: "Sic Bo 888",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "sic_bo_dragons": {
        name: "Sic Bo Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sic_bo_lobby": {
        name: "Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sicbo": {
        name: "SicBo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "side_strike": {
        name: "Side Strike",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sidewinder_doublemax": {
        name: "Sidewinder DoubleMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "sidewinder_xtra_power": {
        name: "Sidewinder Xtra Power",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "silicon_spinners": {
        name: "Silicon Spinners",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "silverback_gold": {
        name: "Silverback Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "simply_the_best": {
        name: "Simply the Best",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sin_city": {
        name: "Sin City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "sinbad": {
        name: "Sinbad",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sinbads_fortune": {
        name: "Sinbad's Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "single_deck_blackjack": {
        name: "Single Deck Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sir_blingalot": {
        name: "Sir Blingalot",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "siren_of_the_deep": {
        name: "Siren of the Deep",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "sirens_kingdom": {
        name: "Siren's Kingdom",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sirens_kingdom_scratch": {
        name: "Siren's Kingdom Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sirens_spell": {
        name: "Siren's Spell",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "sisters_of_the_sun": {
        name: "Sisters of the Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sit_n_win": {
        name: "Sit 'N Win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "sixsixsix": {
        name: "SixSixSix",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sizable_win": {
        name: "Sizable Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sizzling_777": {
        name: "Sizzling 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_777_deluxe": {
        name: "Sizzling 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_bells": {
        name: "Sizzling Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs": {
        name: "Sizzling Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_extremely_light": {
        name: "Sizzling Eggs Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_grand_gold_edition": {
        name: "Sizzling Eggs Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_grand_platinum_edition": {
        name: "Sizzling Eggs Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_kindom_bison": {
        name: "Sizzling Kindom: Bison",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_moon": {
        name: "Sizzling Moon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_spins": {
        name: "Sizzling Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "skaterboy": {
        name: "SkaterBoy",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "skull_kings_treasure": {
        name: "Skull King's Treasure",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "skull_lord": {
        name: "Skull Lord",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "skulls_up": {
        name: "Skulls UP!",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sky_barons": {
        name: "Sky Barons",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sky_coins": {
        name: "Sky Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sky_pearls": {
        name: "Sky Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sky_pirates": {
        name: "Sky Pirates",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "sky_sentinels": {
        name: "Sky Sentinels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "skylantis_2_wild_fight": {
        name: "Skylantis 2 Wild Fight",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "skylight_wonders": {
        name: "Skylight Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "skys_the_limit": {
        name: "Sky's the Limit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "slap_shot": {
        name: "Slap Shot",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "slashimi": {
        name: "Slashimi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "slayers_inc": {
        name: "Slayers Inc",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sleeping_dragon": {
        name: "Sleeping Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sleeping_dragon_ultra_dark": {
        name: "Sleeping Dragon Ultra Dark",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "slime_party": {
        name: "Slime Party",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "slingo_ante_up": {
        name: "Slingo Ante Up",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_big_spin_booster": {
        name: "Slingo Big Spin Booster",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_big_wheel": {
        name: "Slingo Big Wheel",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_capital_gains": {
        name: "Slingo Capital Gains",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_carnival": {
        name: "Slingo Carnival",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_cascade": {
        name: "Slingo Cascade",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_centurionslingo_maximus": {
        name: "Slingo Centurion/Slingo Maximus",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_classic": {
        name: "Slingo Classic",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_constitution_hill": {
        name: "Slingo Constitution Hill",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_da_vinci_diamonds": {
        name: "Slingo Da Vinci Diamonds",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_day_of_the_dab": {
        name: "Slingo Day of the Dab",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_deal_or_no_deal_uk": {
        name: "Slingo Deal Or No Deal (UK)",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_extreme": {
        name: "Slingo Extreme",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_fishing_bob": {
        name: "Slingo Fishing Bob",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_fluffy_favourites": {
        name: "Slingo Fluffy Favourites",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_fowl_play": {
        name: "Slingo Fowl Play",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_gold_cash": {
        name: "Slingo Gold Cash",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_golden_envelope": {
        name: "Slingo Golden Envelope",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_honey_crew": {
        name: "Slingo Honey Crew",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_hot_roll": {
        name: "Slingo Hot Roll",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_inca_trail": {
        name: "Slingo Inca Trail",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_journey_to_asgard": {
        name: "Slingo Journey to Asgard",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_lucky_joker": {
        name: "Slingo Lucky Joker",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_lucky_mcgold": {
        name: "Slingo Lucky McGold",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_lucky_streak": {
        name: "Slingo Lucky Streak",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_piggy_bank": {
        name: "Slingo Piggy Bank",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_pop": {
        name: "Slingo Pop",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_racing": {
        name: "Slingo Racing",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_reel_king": {
        name: "Slingo Reel King",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_reel_riches": {
        name: "Slingo Reel Riches",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_reveal": {
        name: "Slingo Reveal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_riches": {
        name: "Slingo Riches",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_river_re3ls": {
        name: "Slingo River Re3ls",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_santa_king": {
        name: "Slingo Santa King",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_shark_week_700": {
        name: "Slingo Shark Week 700",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_stampede": {
        name: "Slingo Stampede",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_starburst": {
        name: "Slingo Starburst",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_stinkin_rich": {
        name: "Slingo Stinkin Rich",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_sweet_bonanza": {
        name: "Slingo Sweet Bonanza",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_wild_adventure": {
        name: "Slingo Wild Adventure",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_wwtbam": {
        name: "Slingo WWTBAM",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_xing_yun_xian": {
        name: "Slingo Xing Yun Xian",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo_xxx_treme": {
        name: "Slingo XXX Treme",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingone_fishin": {
        name: "Slingone Fishin",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingoooal": {
        name: "Slingoooal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingoooal_championship": {
        name: "Slingoooal Championship",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slot_jam": {
        name: "Slot Jam",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "slot_machine": {
        name: "Slot Machine",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sloth_tumble": {
        name: "Sloth Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "slotomon_go": {
        name: "Slotomon Go",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "slots_lobby": {
        name: "Slots Lobby",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "slugger_time": {
        name: "Slugger Time",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "smash_and_crash": {
        name: "Smash and Crash",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "smash_street_wilds": {
        name: "Smash Street Wilds",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "smoking_dragon": {
        name: "Smoking Dragon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "smoking_hot_fortunes": {
        name: "Smoking Hot Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "smoking_hot_fruits": {
        name: "Smoking Hot Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_20_lines": {
        name: "Smoking Hot Fruits 20 Lines",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_stacks": {
        name: "Smoking Hot Fruits Stacks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_wild_respins": {
        name: "Smoking Hot Fruits Wild Respins",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_pistols": {
        name: "Smoking Pistols",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "smugglers_cove": {
        name: "Smugglers Cove",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snake_and_ladder": {
        name: "Snake and Ladder",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "snake_arena": {
        name: "Snake Arena",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "snake_arena_2": {
        name: "Snake Arena 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "snake_trio_bonus": {
        name: "Snake Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "snakes_and_ladders_live": {
        name: "Snakes and Ladders Live",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "snakes_and_ladders_megadice": {
        name: "Snakes and Ladders Megadice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snakes_and_ladders_snake_eyes": {
        name: "Snakes and Ladders Snake Eyes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snoop_dogg_dollars": {
        name: "Snoop Dogg Dollars",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "snow_party": {
        name: "Snow Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snow_scratcher": {
        name: "Snow Scratcher",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "snow_slingers": {
        name: "Snow Slingers",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sobeks_godly_spins": {
        name: "Sobek's Godly Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "soccer_hold_and_blitz": {
        name: "Soccer Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "soccer_solo_striker": {
        name: "Soccer Solo Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "soccermania": {
        name: "Soccermania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "soju_bomb": {
        name: "Soju Bomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "solar_nova": {
        name: "Solar Nova",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "solar_nova_hold_and_win": {
        name: "Solar Nova Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "solar_nova_megaways": {
        name: "Solar Nova Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sold_it": {
        name: "Sold it",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "sold_it_bonus_buy": {
        name: "Sold it Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "songkran_splash": {
        name: "Songkran Splash",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "sonic_reels": {
        name: "Sonic Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sos": {
        name: "S.O.S!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_candy_enhanced": {
        name: "Space Candy Enhanced",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "space_coins": {
        name: "Space Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "space_cows_to_the_moon": {
        name: "Space Cows to the Moo'n",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "space_force": {
        name: "Space Force",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "space_fortune": {
        name: "Space Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_gem": {
        name: "Space Gem",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "space_girl": {
        name: "Space Girl",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "space_goonz": {
        name: "Space Goonz",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_jammers": {
        name: "Space Jammers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "space_miners": {
        name: "Space Miners",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "space_race": {
        name: "Space Race",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "space_sam_walk_and_win": {
        name: "Space Sam Walk and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "space_spins": {
        name: "Space Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "space_stacks": {
        name: "Space Stacks",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "space_wars": {
        name: "Space Wars",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "space_wars_2": {
        name: "Space Wars 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "space_wars_megaways_xxxtreme": {
        name: "Space Wars Megaways XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "space_xy": {
        name: "Space XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "spaceman": {
        name: "Spaceman",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "spark_of_genius": {
        name: "Spark of Genius",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparkling_777s": {
        name: "Sparkling 777s",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "sparky_and_shortz": {
        name: "Sparky & Shortz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparky_and_shortz_hidden_joules": {
        name: "Sparky & Shortz Hidden Joules",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparta": {
        name: "Sparta",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "spartan_king": {
        name: "Spartan King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spear_of_athena": {
        name: "Spear of Athena",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spectrum": {
        name: "Spectrum",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "speed_auto_roulette": {
        name: "Speed Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_baccarat": {
        name: "Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_baccarat_korean": {
        name: "Speed Baccarat - Korean",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_blackjack_azure": {
        name: "Speed Blackjack - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_blackjack_emerald": {
        name: "Speed Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_blackjack_ruby": {
        name: "Speed Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_champion": {
        name: "Speed Champion",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "speed_crash": {
        name: "Speed Crash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "speed_freaks": {
        name: "Speed Freaks",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "speed_roulette": {
        name: "Speed Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_winner": {
        name: "Speed Winner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "spell_forged": {
        name: "Spell Forged",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "spellbinding_mystery": {
        name: "Spellbinding Mystery",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spellmaster": {
        name: "Spellmaster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sphinx_treasure": {
        name: "Sphinx Treasure",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spice_spice_baby": {
        name: "Spice Spice Baby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spin_and_score_megaways": {
        name: "Spin and Score MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spin_and_spell": {
        name: "Spin And Spell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "spin_carnival": {
        name: "Spin Carnival",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "spin_party": {
        name: "Spin Party",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spinata_grande": {
        name: "Spinata Grande",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "spinball": {
        name: "Spinball",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "spinfection": {
        name: "Spinfection",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spingotts_trio_bonus": {
        name: "Spingotts Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "spinions": {
        name: "Spinions",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "spinions_xmas_party": {
        name: "Spinions x-mas party",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "spinlotto": {
        name: "Spinlotto",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "spinlotto_scratch": {
        name: "Spinlotto Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "spinman": {
        name: "Spinman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spinman_hv": {
        name: "Spinman H.V.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spinnin_records_into_the_beat": {
        name: "Spinnin Records into the Beat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spinnin_records_raving_reels": {
        name: "Spinnin Records Raving Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spinning_buddha": {
        name: "Spinning Buddha",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "spino_cricket": {
        name: "Spino Cricket",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "spinsane": {
        name: "Spinsane",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "spinxiety": {
        name: "Spinxiety",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spire": {
        name: "Spire+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spirit_of_adventure": {
        name: "Spirit of adventure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spirit_of_the_beast": {
        name: "Spirit of the Beast",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "spirit_wolf_wins": {
        name: "Spirit Wolf Wins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "spirited_wonders": {
        name: "Spirited Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "splash_party": {
        name: "Splash Party",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "spooktacular_bonanza": {
        name: "Spooktacular Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "spooky_scary_scratchy": {
        name: "Spooky Scary Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "squeak": {
        name: "Squeak",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "squeeze_baccarat": {
        name: "Squeeze Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "st_louis_1904": {
        name: "St Louis 1904",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "stack_em": {
        name: "Stack 'Em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stack_em_scratch": {
        name: "Stack 'em Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stackem": {
        name: "Stack'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stacking_kong": {
        name: "StacKING Kong",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "stacking_kong_bonus": {
        name: "Stacking Kong Bonus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "stacking_kong_bonus_christmas": {
        name: "StacKing Kong Bonus Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "stacks_of_jacks": {
        name: "Stacks of Jacks",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "stadium_megaways": {
        name: "Stadium Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "stadium_of_riches": {
        name: "Stadium of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stampede_bonanza": {
        name: "Stampede Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "stampeding_strike": {
        name: "Stampeding Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "star_bounty": {
        name: "Star Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "star_guardians": {
        name: "Star Guardians",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "star_joker": {
        name: "Star Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "star_pirates_code": {
        name: "Star Pirates Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "star_pops": {
        name: "Star Pops",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "star_treasure": {
        name: "Star Treasure",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "star_trek_the_next_generation": {
        name: "Star Trek The Next Generation",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "starburst": {
        name: "Starburst",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "starburst_galaxy": {
        name: "Starburst Galaxy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "starburst_xxxtreme": {
        name: "Starburst XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "starlight": {
        name: "Starlight",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "starlight_archer_1000": {
        name: "Starlight Archer 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_christmas": {
        name: "Starlight Christmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess": {
        name: "Starlight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_1000": {
        name: "Starlight Princess 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_jackpot_play": {
        name: "Starlight Princess Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_pachi": {
        name: "Starlight Princess Pachi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_super_scatter": {
        name: "Starlight Princess Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "stars_and_stripes_hold_and_win": {
        name: "Stars and Stripes Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "starsign_clusters": {
        name: "Starsign Clusters",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "starspell": {
        name: "StarSpell",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "starz_megaways": {
        name: "Starz MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "static_nightmare": {
        name: "Static Nightmare",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "steam_tower": {
        name: "Steam Tower",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "steamin_reels": {
        name: "Steamin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "steampunk_plinko": {
        name: "Steampunk Plinko",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "steamrunners": {
        name: "Steamrunners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "steamworks_gears_of_fortune": {
        name: "Steamworks Gears of Fortune",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "steamworks_the_workshop": {
        name: "Steamworks the Workshop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "stellar_ways_": {
        name: "Stellar Ways -",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "stepping_diamonds": {
        name: "Stepping Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stick_em": {
        name: "Stick 'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stickermania_wild_rumble": {
        name: "Stickermania Wild Rumble",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "stickers": {
        name: "Stickers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "stickman_cash": {
        name: "Stickman Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sticky_bandits": {
        name: "Sticky Bandits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_3_most_wanted": {
        name: "Sticky Bandits 3 Most Wanted",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_thunder_rail": {
        name: "Sticky Bandits Thunder Rail",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_trail_of_blood": {
        name: "Sticky Bandits Trail of Blood",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_unchained": {
        name: "Sticky Bandits Unchained",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_wild_return": {
        name: "Sticky Bandits: Wild return",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bees": {
        name: "Sticky Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sticky_diamonds": {
        name: "Sticky Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_diamonds_easter_egg": {
        name: "Sticky Diamonds Easter Egg",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_diamonds_flaming_link_94": {
        name: "Sticky Diamonds Flaming Link 94",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_diamonds_rhfp": {
        name: "Sticky Diamonds RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_feet_reel_bingo": {
        name: "Sticky Feet Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "sticky_joker": {
        name: "Sticky Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stormborn": {
        name: "Stormborn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stormforged": {
        name: "Stormforged",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "strawberry_cocktail": {
        name: "Strawberry Cocktail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "street_fighter_ii_the_world_warrior_slot": {
        name: "Street Fighter II: The World Warrior Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "street_magic": {
        name: "Street Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "street_ninja": {
        name: "Street Ninja",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "street_power": {
        name: "Street Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "street_racer": {
        name: "Street Racer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "street_ratz_the_heist": {
        name: "Street Ratz The Heist",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "strength_of_hercules": {
        name: "Strength of Hercules",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "striking_hot_5": {
        name: "Striking Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "striking_hot_5_jackpot_play": {
        name: "Striking Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "strolling_staxx_cubic_fruits": {
        name: "Strolling Staxx: Cubic Fruits",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "stuffed_with_100s": {
        name: "Stuffed with 100s",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "sugar_crush": {
        name: "Sugar Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "sugar_merge_up": {
        name: "Sugar Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sugar_mix": {
        name: "Sugar Mix",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sugar_rush": {
        name: "Sugar Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_1000": {
        name: "Sugar Rush 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_jackpot_play": {
        name: "Sugar Rush Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_super_scatter": {
        name: "Sugar Rush Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_xmas": {
        name: "Sugar Rush Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_supreme_powernudge": {
        name: "Sugar Supreme Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sultan_spins": {
        name: "Sultan Spins",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "sumie": {
        name: "Sumi-E",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "summer_scratch": {
        name: "Summer Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sumo_supreme_megaways": {
        name: "Sumo Supreme Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sun_bingo_slingo": {
        name: "Sun Bingo Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "sun_of_egypt": {
        name: "Sun of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sun_of_egypt_2": {
        name: "Sun of Egypt 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sun_of_egypt_3": {
        name: "Sun of Egypt 3",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sun_of_egypt_4": {
        name: "Sun of Egypt 4",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sun_of_egypt_5": {
        name: "Sun of Egypt 5",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sun_of_fortune": {
        name: "Sun of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sun_princess": {
        name: "Sun Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sunlight_princess": {
        name: "Sunlight Princess",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "sunny_sevens": {
        name: "Sunny Sevens",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sunnydaze_asylum": {
        name: "Sunnydaze Asylum",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sunstone_riches": {
        name: "Sunstone Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "super_7_winner": {
        name: "Super 7 Winner",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "super_7s": {
        name: "Super 7s",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_ace": {
        name: "Super Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_ace_ii": {
        name: "Super Ace II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_ace_joker": {
        name: "Super Ace Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_baccarat": {
        name: "Super Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "super_bingo": {
        name: "Super Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_boost": {
        name: "Super Boost",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "super_cash_drop_giga_blox": {
        name: "Super Cash Drop Giga Blox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "super_charged_fruits": {
        name: "Super Charged Fruits",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "super_china_pots": {
        name: "Super China Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "super_duper": {
        name: "Super Duper",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "super_duper_cherry": {
        name: "Super Duper Cherry",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "super_duper_cherry_rhfp": {
        name: "Super Duper Cherry RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "super_egg_hunt": {
        name: "Super Egg Hunt",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "super_esabong": {
        name: "Super E-Sabong",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_flip": {
        name: "Super Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_flip_deluxe": {
        name: "Super Flip Deluxe",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_fruit_blast": {
        name: "Super Fruit Blast",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "super_fruit_smash": {
        name: "Super Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "super_golf_drive": {
        name: "Super Golf Drive",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "super_gummy_strike": {
        name: "Super Gummy Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_heli": {
        name: "Super Heli",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "super_hot": {
        name: "Super Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "super_hot_chilli": {
        name: "Super Hot Chilli",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "super_hot_teapots": {
        name: "Super Hot Teapots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "super_hotfire_diamonds": {
        name: "Super Hotfire Diamonds",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "super_joker": {
        name: "Super Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_rainbow_megaways": {
        name: "Super Rainbow Megaways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "super_rich": {
        name: "Super Rich",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "super_sake": {
        name: "Super Sake",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "super_sevens": {
        name: "Super Sevens",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "super_shamrock": {
        name: "Super Shamrock",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "super_sixer": {
        name: "Super Sixer",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "super_sixer_classic_scratch": {
        name: "Super Sixer Classic Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "super_sixer_xtreme": {
        name: "Super Sixer Xtreme",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "super_sticky_piggy": {
        name: "Super Sticky Piggy",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "super_strike": {
        name: "Super Strike",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "super_striker": {
        name: "Super Striker",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "super_tiki_strike": {
        name: "Super Tiki Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_triple_fortune": {
        name: "Super Triple Fortune",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "super_twister": {
        name: "Super Twister",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "super_upgrade_joker": {
        name: "Super Upgrade Joker",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "super_wheel": {
        name: "Super Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_wild_diamonds": {
        name: "Super Wild Diamonds",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "super_wildrix": {
        name: "Super Wildrix",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "super_x": {
        name: "Super X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "supermania": {
        name: "Supermania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "supermarket_spree": {
        name: "Supermarket Spree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "supernova": {
        name: "Supernova",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "superstar_sevens": {
        name: "Superstar Sevens",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "superstars": {
        name: "Superstars",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "supreme_diamond_xxl": {
        name: "Supreme Diamond XXL",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "supreme_zeus": {
        name: "Supreme Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "surf_zone": {
        name: "Surf Zone",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "surrender_multihand_blackjack": {
        name: "Surrender Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sushi_cat": {
        name: "Sushi Cat",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "sushicade": {
        name: "Sushicade",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "sweet_27": {
        name: "Sweet 27",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy": {
        name: "Sweet Alchemy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_100": {
        name: "Sweet Alchemy 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_2": {
        name: "Sweet Alchemy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_bingo": {
        name: "Sweet Alchemy Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_bonanza": {
        name: "Sweet Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_1000": {
        name: "Sweet Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_2500": {
        name: "Sweet Bonanza 2500",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_candyland": {
        name: "Sweet Bonanza Candyland",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sweet_bonanza_dice": {
        name: "Sweet Bonanza Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_jackpot_play": {
        name: "Sweet Bonanza Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_super_scatter": {
        name: "Sweet Bonanza Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_xmas": {
        name: "Sweet Bonanza Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_candy_blitz": {
        name: "Sweet Candy Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash": {
        name: "Sweet Candy Cash",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "sweet_candy_cash_megaways": {
        name: "Sweet Candy Cash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash_megaways_deluxe": {
        name: "Sweet Candy Cash Megaways Deluxe",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash_stash": {
        name: "Sweet Candy Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_christmas": {
        name: "Sweet Candy Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_fortune": {
        name: "Sweet Candy Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "sweet_candy_fortune_bonanza": {
        name: "Sweet Candy Fortune Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "sweet_craze": {
        name: "Sweet Craze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_crush": {
        name: "Sweet Crush",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sweet_dash": {
        name: "Sweet Dash",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "sweet_gold_3000": {
        name: "Sweet Gold 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sweet_gummy": {
        name: "Sweet Gummy",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "sweet_kingdom": {
        name: "Sweet Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_land": {
        name: "Sweet Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "sweet_magic": {
        name: "Sweet Magic",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "sweet_paradise": {
        name: "Sweet Paradise",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "sweet_powernudge": {
        name: "Sweet Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_rush_bonanza": {
        name: "Sweet Rush Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_rush_megaways": {
        name: "Sweet Rush Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sweet_samurai": {
        name: "Sweet Samurai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sweet_shop": {
        name: "Sweet Shop",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "sweet_spotz": {
        name: "Sweet Spotz",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "sweet_success_megaways": {
        name: "Sweet Success Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "sweet_sugar": {
        name: "Sweet Sugar",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "sweetello": {
        name: "Sweetello",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "sweetopia_royale": {
        name: "Sweetopia Royale",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "sweets_paradise_jp": {
        name: "Sweets Paradise JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "sweety_honey_fruity": {
        name: "Sweety Honey Fruity",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "swipe": {
        name: "Swipe",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "sword_master": {
        name: "Sword Master",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "sword_of_ares": {
        name: "Sword of Ares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sword_of_fortune": {
        name: "Sword of Fortune",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "symbols_of_egypt": {
        name: "Symbols of Egypt",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "taberna_de_los_muertos": {
        name: "Taberna De Los Muertos",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "taberna_de_los_muertos_ultra": {
        name: "Taberna De Los Muertos Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "taco_fury_xxxtreme": {
        name: "Taco Fury XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "tai_the_toad": {
        name: "Tai the Toad",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "taiko_beats": {
        name: "Taiko Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "taisho_samurai": {
        name: "Taisho Samurai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "take_5": {
        name: "Take 5",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "take_5_christmas_edition": {
        name: "Take 5 Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "take_5_gdn": {
        name: "Take 5 GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "take_5_rhfp": {
        name: "Take 5 RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "tale_of_kyubiko": {
        name: "Tale of Kyubiko",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tale_of_the_red_dragon": {
        name: "Tale of The Red Dragon",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "tales_of_asgard_freyas_wedding": {
        name: "Tales of Asgard: Freya's Wedding",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tales_of_asgard_lokis_fortune": {
        name: "Tales of Asgard: Loki's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tales_of_dr_dolittle": {
        name: "Tales of Dr. dolittle",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tales_of_mithrune_syns_fortune": {
        name: "Tales of Mithrune Syn's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "talismans_of_fortune": {
        name: "Talismans of Fortune",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tango_of_chaos": {
        name: "Tango of Chaos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "tao_tree_coins": {
        name: "Tao Tree Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tap_craze": {
        name: "Tap Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tarasque": {
        name: "Tarasque",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "tarot_treasures": {
        name: "Tarot Treasures",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "tarzan": {
        name: "Tarzan",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "tasty_bonanza": {
        name: "Tasty Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_bonanza_1000": {
        name: "Tasty Bonanza 1,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_bonanza_live": {
        name: "Tasty Bonanza Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_bonanza_max_scatter": {
        name: "Tasty Bonanza Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_trailz": {
        name: "Tasty Trailz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "tasty_treats": {
        name: "Tasty Treats",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "team_win_fast": {
        name: "Team Win Fast",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "techno_tumble": {
        name: "Techno Tumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ted": {
        name: "Ted",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "teen_patti": {
        name: "Teen Patti",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "teen_patti_diwali_special": {
        name: "Teen Patti Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "teenpatti": {
        name: "TeenPatti",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "telly_reels": {
        name: "Telly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "tempered_steel": {
        name: "Tempered Steel",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "templar_tumble": {
        name: "Templar Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "templar_tumble_dream_drop": {
        name: "Templar Tumble Dream Drop",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "temple_guardians": {
        name: "Temple Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "temple_of_dead": {
        name: "Temple of Dead",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_dead_bonus_buy": {
        name: "Temple of Dead Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_nudges": {
        name: "Temple of Nudges",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "temple_of_paw": {
        name: "Temple of Paw",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "temple_of_prosperity": {
        name: "Temple of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "temple_of_three": {
        name: "Temple of Three",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "temple_of_thunder": {
        name: "Temple of Thunder",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_thunder_2": {
        name: "Temple of Thunder 2",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_thunder_3": {
        name: "Temple of Thunder 3",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_thunder_ii": {
        name: "Temple of Thunder II",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_thunder_ii_bonus_buy": {
        name: "Temple of Thunder II Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "temple_of_tollan": {
        name: "Temple of Tollan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "temple_of_torment": {
        name: "Temple of Torment",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "temple_of_treasures_megaways": {
        name: "Temple of Treasures Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "temple_rush": {
        name: "Temple Rush",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "temple_treasure_holdandwin": {
        name: "Temple Treasure Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "temple_tumble_megaways": {
        name: "Temple Tumble MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "temple_x": {
        name: "Temple X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "temujin_treasures": {
        name: "Temujin Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "tennis_scratch": {
        name: "Tennis Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "tens_or_better_1_hand": {
        name: "Tens or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tens_or_better_10_hand": {
        name: "Tens or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tens_or_better_100_hand": {
        name: "Tens or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tens_or_better_5_hand": {
        name: "Tens or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tens_or_better_50_hand": {
        name: "Tens or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ternion": {
        name: "Ternion",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "testament": {
        name: "Testament",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "texas_holdem_poker": {
        name: "Texas Holdem Poker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "texas_holdem_poker_3d": {
        name: "Texas Hold'em Poker 3D",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "thai_baccarat": {
        name: "Thai Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "thai_hilo": {
        name: "Thai Hilo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "thai_river_wonders": {
        name: "Thai River Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "thai_roulette": {
        name: "Thai Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "thai_speed_baccarat": {
        name: "Thai Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "thats_rich": {
        name: "That's Rich",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_3_bears": {
        name: "The 3 Bears",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "the_alter_ego": {
        name: "The Alter Ego",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_awakening": {
        name: "The Awakening",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "the_belt_of_champion": {
        name: "The Belt Of Champion",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_belt_of_champion_bonus_buy": {
        name: "The Belt Of Champion Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_big_dawgs": {
        name: "The Big Dawgs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_big_deal": {
        name: "The Big Deal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_big_deal_deluxe": {
        name: "The Big Deal Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_big_dog_house": {
        name: "The Big Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_big_five": {
        name: "The Big Five",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "the_big_hit": {
        name: "The Big Hit",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "the_bingo_spot": {
        name: "The Bingo Spot",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "the_book_beyond": {
        name: "The Book Beyond",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_book_beyond_2": {
        name: "The Book Beyond 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_bounty_hunter": {
        name: "The Bounty Hunter",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "the_bowery_boys": {
        name: "The Bowery Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_chase_slingo": {
        name: "The Chase Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "the_chillies": {
        name: "The Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_choice_is_yours_megaways": {
        name: "The Choice is Yours Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "the_count": {
        name: "The Count",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_crime_file": {
        name: "The Crime File",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_cup": {
        name: "The Cup",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "the_curious_cabinet_scratch": {
        name: "The Curious Cabinet Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "the_dead_escape": {
        name: "The Dead Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_dog_house": {
        name: "The Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_dice_show": {
        name: "The Dog House Dice Show",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_dog_or_alive": {
        name: "The Dog House - Dog or Alive",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_jackpot_play": {
        name: "The Dog House Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_megaways": {
        name: "The Dog House MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_megaways_1000": {
        name: "The Dog House Megaways 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_megaways_jackpot_play": {
        name: "The Dog House Megaways Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_multihold": {
        name: "The Dog House Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_muttley_crew": {
        name: "The Dog House Muttley Crew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_royal_hunt": {
        name: "The Dog House Royal Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dragon_tiger": {
        name: "The Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_easter_catch": {
        name: "The Easter Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_emperors_tomb": {
        name: "The Emperor's Tomb",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_expandable": {
        name: "The Expandable",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_eye_of_horus": {
        name: "The Eye of Horus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "the_faces_of_freya": {
        name: "The Faces of Freya",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_fates_of_sisters": {
        name: "The Fates of Sisters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "the_goat": {
        name: "The G.O.A.T",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "the_golden_mummy_hold_and_win": {
        name: "The Golden Mummy Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "the_good_farmer": {
        name: "The Good Farmer",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "the_good_the_bad_and_the_ugly": {
        name: "The Good, The Bad and the Ugly",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "the_goonies": {
        name: "The Goonies",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "the_grand": {
        name: "The Grand",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_grand_show": {
        name: "The Grand Show",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "the_grape_escape": {
        name: "The Grape Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_great_chicken_escape": {
        name: "The Great Chicken Escape",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_great_conflict": {
        name: "The Great Conflict",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_great_fishing_adventure": {
        name: "The Great Fishing Adventure",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "the_great_fishing_adventure_bonanza": {
        name: "The Great Fishing Adventure Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "the_great_icescape": {
        name: "The Great Icescape",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "the_great_pigsby": {
        name: "The Great Pigsby",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_pigsby_megapays": {
        name: "The Great Pigsby Megapays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_pigsby_megaways": {
        name: "The Great Pigsby MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_stickup": {
        name: "The Great Stick-Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_greatest_catch": {
        name: "The Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_greatest_catch_bonus_buy": {
        name: "The Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_green_knight": {
        name: "The Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_green_knight_oath_of_thorns": {
        name: "The Green Knight Oath of Thorns",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_grim_reaper": {
        name: "The Grim Reaper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_hand_of_midas": {
        name: "The Hand of Midas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_hot_offer": {
        name: "The Hot Offer",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "the_invisible_man": {
        name: "The Invisible Man",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "the_knight_king": {
        name: "The Knight King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_last_dynasty": {
        name: "The Last Dynasty",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "the_last_sundown": {
        name: "The Last Sundown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_legend_of_musashi": {
        name: "The Legend of Musashi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "the_legend_of_shangrila_cluster_pays": {
        name: "The Legend of Shangri-La: Cluster Pays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "the_link": {
        name: "The Link",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "the_link_scratch": {
        name: "The Link Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "the_lost_idol_v2": {
        name: "The Lost Idol V2",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "the_mafiosi": {
        name: "The Mafiosi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "the_magic_cauldron": {
        name: "The Magic Cauldron",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_magic_cauldron_enchanted_brew": {
        name: "The Magic Cauldron: Enchanted Brew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_mighty_king": {
        name: "The Mighty King",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_mighty_toro": {
        name: "The Mighty Toro",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_money_men_megaways": {
        name: "The Money Men Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_paying_piano_club": {
        name: "The Paying Piano Club",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_perfect_scratch": {
        name: "The Perfect Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_price_is_right": {
        name: "The Price is Right",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "the_queens_banquet": {
        name: "The Queen's Banquet",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "the_red_queen": {
        name: "The Red Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_return_of_the_green_knight": {
        name: "The Return of the Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_runemakers": {
        name: "The Runemakers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "the_secret_of_amun_ra": {
        name: "The Secret of Amun Ra",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "the_secret_of_ba": {
        name: "The Secret of BA",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "the_shadow_order": {
        name: "The Shadow Order",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "the_slavs": {
        name: "The Slavs",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "the_soapranos": {
        name: "The Soapranos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "the_sword_and_the_grail": {
        name: "The Sword and The Grail",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_sword_and_the_grail_excalibur": {
        name: "The Sword and the Grail Excalibur",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_tiger_warrior": {
        name: "The Tiger Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_trolls_treasure": {
        name: "The Trolls' Treasure",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "the_tumbles": {
        name: "The Tumbles",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_tweety_house": {
        name: "The Tweety House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_ultimate_5": {
        name: "The Ultimate 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_vault_chase": {
        name: "The Vault Chase",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "the_vigilantes": {
        name: "The Vigilantes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "the_wild_chase": {
        name: "The Wild Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_wild_class": {
        name: "The Wild Class",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_wild_drifter": {
        name: "The Wild Drifter",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "the_wild_gang": {
        name: "The Wild Gang",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_wild_machine": {
        name: "The Wild Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_wild_wings_of_phoenix": {
        name: "The Wild Wings of Phoenix",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_wild_wings_of_phoenix_deluxe": {
        name: "The Wild Wings of Phoenix Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_wish_master": {
        name: "The Wish Master",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "the_wish_master_megaways": {
        name: "The Wish Master Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "the_wolfs_bane": {
        name: "The Wolf's Bane",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "theme_park_tickets_of_fortune": {
        name: "Theme Park Tickets of Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "theseus_rises": {
        name: "Theseus Rises",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "thief_in_the_palace": {
        name: "Thief In The Palace",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "thimbles": {
        name: "Thimbles",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "thor_10k_ways": {
        name: "Thor 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "thor_infinity_reels": {
        name: "Thor Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "thor_x": {
        name: "Thor X",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "thorfinns_journey": {
        name: "Thorfinn's Journey",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "thors_egg_hunt": {
        name: "Thor's Egg Hunt",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "thors_hammer_time": {
        name: "Thor's Hammer Time",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "three_card_poker": {
        name: "Three Card Poker",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "three_card_poker_deluxe": {
        name: "Three Card Poker Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "three_cards": {
        name: "Three Cards",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "three_crazy_piggies": {
        name: "Three Crazy Piggies",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "three_fortune_wishes": {
        name: "Three Fortune Wishes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "three_panditos_reel_bingo": {
        name: "Three Panditos Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "three_samurai": {
        name: "Three Samurai",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "three_star_fortune": {
        name: "Three Star Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "three_trojan_horses": {
        name: "Three Trojan Horses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "three_zombies": {
        name: "Three Zombies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "thrill_to_grill": {
        name: "Thrill To Grill",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "thrones_of_persia": {
        name: "Thrones of Persia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "thunder_eagle_hold_and_win_10000": {
        name: "Thunder Eagle Hold and Win 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "thunder_hawk": {
        name: "Thunder Hawk",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "thunder_mega_sevens": {
        name: "Thunder Mega Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "thunder_mega_sevens_bonus_buy": {
        name: "Thunder Mega Sevens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "thunder_tiger": {
        name: "Thunder Tiger",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "thunder_wheel": {
        name: "Thunder Wheel",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "thundering_hearts": {
        name: "Thundering Hearts",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "thunderscreech": {
        name: "Thunderscreech",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tic_tac_take": {
        name: "Tic Tac Take",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ticket_to_fortune": {
        name: "Ticket To Fortune",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "ticket_to_the_stars": {
        name: "Ticket to the stars",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ticket_to_wild": {
        name: "Ticket To Wild",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "tiger_doublemax": {
        name: "Tiger DoubleMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "tiger_gems": {
        name: "Tiger Gems",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "tiger_jungle": {
        name: "Tiger Jungle",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "tiger_kingdom": {
        name: "Tiger Kingdom",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tiger_scratch": {
        name: "Tiger Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "tiger_shrine": {
        name: "Tiger Shrine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tiger_tiger": {
        name: "Tiger Tiger",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "tiger_train": {
        name: "Tiger Train",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "tigers_glory": {
        name: "Tiger's Glory",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tigers_glory_ultra": {
        name: "Tiger's Glory Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tiggy_luck": {
        name: "Tiggy Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "tik_talkers": {
        name: "Tik Talkers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tiki_bar_reel_bingo": {
        name: "Tiki Bar Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "tiki_hut_megaways_jackpot_play": {
        name: "Tiki Hut Megaways Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "tiki_infinity_reels_megaways": {
        name: "Tiki Infinity Reels Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "tiki_pop": {
        name: "Tiki Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tiki_runner_2_doublemax": {
        name: "Tiki Runner 2 DoubleMax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "tiki_runner_clusters": {
        name: "Tiki Runner Clusters",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "tiki_runner_gigablox": {
        name: "Tiki Runner GigaBlox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "tiki_thunder": {
        name: "Tiki Thunder",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "tiki_tumble_bonus_buy": {
        name: "Tiki Tumble Bonus Buy",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "tikipop_spooky_temples": {
        name: "TikiPop Spooky Temples",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tile_master": {
        name: "Tile Master",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "timber_stacks": {
        name: "Timber Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "time_machine": {
        name: "Time Machine",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "tiny_toads": {
        name: "Tiny Toads",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "tipping_point_slingo": {
        name: "Tipping Point Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "titan_roulette": {
        name: "Titan roulette",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "titan_strike": {
        name: "Titan Strike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tnt_bonanza": {
        name: "TNT Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tnt_bonanza_2": {
        name: "TNT Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tnt_extravaganza": {
        name: "TNT Extravaganza",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "tnt_tumble": {
        name: "TNT Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tntina": {
        name: "TNTina",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "toads_bounty": {
        name: "Toad's Bounty",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tokyo_kombat": {
        name: "Tokyo Kombat",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "tokyo_sweeties": {
        name: "Tokyo Sweeties",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "tokyo_sweeties_jp": {
        name: "Tokyo Sweeties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "tomatina_bingo": {
        name: "Tomatina Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "tomb_of": {
        name: "Tomb Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "tomb_of_dead_power_4_slots": {
        name: "Tomb of Dead: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "tomb_of_gold": {
        name: "Tomb of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tomb_of_gold_ii": {
        name: "Tomb of Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tomb_of_gold_reimagined": {
        name: "Tomb of Gold Reimagined",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tomb_of_luxor": {
        name: "Tomb of Luxor",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "tomb_of_the_king": {
        name: "Tomb of the King",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "tome_of_madness_bingo": {
        name: "Tome Of Madness Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tongits_go": {
        name: "Tongits Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "tooty_fruity_fruits": {
        name: "Tooty Fruity Fruits",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "top_dawg": {
        name: "Top Dawg$",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "top_eagle": {
        name: "Top Eagle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "torii_tumble": {
        name: "Torii Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "toshi_ways_club": {
        name: "Toshi Ways Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "totally_hot": {
        name: "Totally Hot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "totem": {
        name: "Totem",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "totem_towers": {
        name: "Totem Towers",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "totem_warrior": {
        name: "Totem Warrior",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "totem_wonders": {
        name: "Totem Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "tower": {
        name: "Tower",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "tower_of_pizza": {
        name: "Tower Of Pizza",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tower_of_power": {
        name: "Tower of Power",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "tower_rush": {
        name: "Tower Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "tower_tumble": {
        name: "Tower Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "towering_fortunes": {
        name: "Towering Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "towering_pays_excalibur": {
        name: "Towering Pays Excalibur",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "towering_pays_valhalla": {
        name: "Towering Pays Valhalla",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "toy_of_legend": {
        name: "Toy of Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "track_n_gold": {
        name: "Track n' Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "trail_blazer": {
        name: "Trail Blazer",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "trailblazer": {
        name: "Trailblazer",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "train_heist_johnny_cash": {
        name: "Train Heist Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "train_of_riches_capital_express": {
        name: "Train of Riches Capital Express",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "train_strike_hold_and_win": {
        name: "Train Strike Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "train_to_rio_grande": {
        name: "Train to Rio Grande",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "tramp_day": {
        name: "Tramp Day",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "tramp_day_trueways": {
        name: "Tramp Day Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "trans_santas_sack": {
        name: "Trans Santa's Sack",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "trawler_fishin": {
        name: "Trawler Fishin'",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "treasure_comet": {
        name: "Treasure Comet",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "treasure_diver": {
        name: "Treasure Diver",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "treasure_explorer": {
        name: "Treasure Explorer",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "treasure_horse": {
        name: "Treasure Horse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "treasure_hunter": {
        name: "Treasure Hunter",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "treasure_island": {
        name: "Treasure Island",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "treasure_labyrinth": {
        name: "Treasure Labyrinth",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "treasure_mania": {
        name: "Treasure Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treasure_of_anubis": {
        name: "Treasure of Anubis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "treasure_of_horus_scratch": {
        name: "Treasure of Horus Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "treasure_quest": {
        name: "Treasure Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "treasure_snipes": {
        name: "Treasure Snipes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treasure_snipes_bonus_buy": {
        name: "Treasure Snipes Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treasure_snipes_christmas": {
        name: "Treasure Snipes: Christmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treasure_snipes_christmas_bonus_buy": {
        name: "Treasure Snipes: Christmas Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treasure_tomb": {
        name: "Treasure Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "treasure_tumble": {
        name: "Treasure Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "treasure_vault": {
        name: "Treasure Vault",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "treasure_wild": {
        name: "Treasure Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "treasures_of_aztec": {
        name: "Treasures of Aztec",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "treasures_of_kongar": {
        name: "Treasures of Kongar",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "treasures_of_osiris": {
        name: "Treasures of Osiris",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "treasures_of_the_dead": {
        name: "Treasures of the Dead",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "treasures_of_the_gods": {
        name: "Treasures of the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "treat_yo_elf": {
        name: "Treat Yo' Elf",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "treats_of_terror": {
        name: "Treats of Terror",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tree_of_fortune": {
        name: "Tree of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "tree_of_light": {
        name: "Tree of Light",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tree_of_light_bonus_buy": {
        name: "Tree of Light Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tree_of_light_fabled_fruits": {
        name: "Tree of Light Fabled Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tree_of_riches": {
        name: "Tree of Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "trees_of_treasure": {
        name: "Trees of Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "trex_treasure_hunt_megaways": {
        name: "T-Rex Treasure Hunt Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "trial_of_phoenix": {
        name: "Trial of Phoenix",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "trick_or_treat_joker": {
        name: "Trick or Treat Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "tricky_treats": {
        name: "Tricky Treats",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "trinity_impact": {
        name: "Trinity Impact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "triple_action_cash_strike": {
        name: "Triple Action Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "triple_bar_": {
        name: "Triple Bar -",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "triple_chili": {
        name: "Triple Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "triple_dragons": {
        name: "Triple Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_fire_pots_hold_and_win": {
        name: "Triple Fire Pots Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "triple_hit_gold_mine_hold_and_win": {
        name: "Triple Hit Gold Mine Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "triple_joker": {
        name: "Triple Joker",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "triple_launch_fortune_wild": {
        name: "Triple Launch Fortune Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "triple_pot_diamond": {
        name: "Triple Pot Diamond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_pot_god": {
        name: "Triple Pot God",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_pot_gold": {
        name: "Triple Pot Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_pot_plinko_hercules": {
        name: "Triple Pot Plinko Hercules",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_rampage": {
        name: "Triple Rampage",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "triple_snack_attack": {
        name: "Triple Snack Attack",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "triple_star": {
        name: "Triple Star",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "triple_thunder": {
        name: "Triple Thunder",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "triple_tigers": {
        name: "Triple Tigers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_up": {
        name: "Triple Up",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "troll_hunters": {
        name: "Troll Hunters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "troll_hunters_2": {
        name: "Troll Hunters 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "trollfufu_bonanza": {
        name: "Trollfufu Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "trollpot_5000": {
        name: "Trollpot 5000",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "trolls_gold": {
        name: "Troll's Gold",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tropical_pop_jackpot_play": {
        name: "Tropical Pop Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "tropical_thunder": {
        name: "Tropical Thunder",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "tropical_tiki": {
        name: "Tropical Tiki",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "troy_superways": {
        name: "Troy Superways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "truckers_vs_aliens": {
        name: "Truckers vs Aliens",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "true_dragon_x": {
        name: "True Dragon X",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "tsai_shen_10k_ways": {
        name: "Tsai Shen 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "tuk_tuk_thailand": {
        name: "Tuk Tuk Thailand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tundras_fortune": {
        name: "Tundra's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "turbo_mines": {
        name: "Turbo Mines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "turbo_play": {
        name: "Turbo Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "turbo_poker": {
        name: "Turbo Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "turbo_roulette": {
        name: "Turbo Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "turkish_mega_roulette": {
        name: "Turkish Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turkish_one_blackjack": {
        name: "Turkish ONE Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turkish_roulette": {
        name: "Turkish Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turn_your_fortune": {
        name: "Turn Your Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "tutan_keno": {
        name: "Tutan Keno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "tutans_treasure": {
        name: "Tutans Treasure",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "twentyone": {
        name: "Twenty-One",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "twilight_princess": {
        name: "Twilight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "twin_buffalo_hold_and_win": {
        name: "Twin Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "twin_happiness": {
        name: "Twin Happiness",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "twin_spin": {
        name: "Twin Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "twin_spin_megaways": {
        name: "Twin Spin Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "twin_spin_xxxtreme": {
        name: "Twin Spin XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "twin_wins": {
        name: "TWIN WINS",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "twisted_turbine": {
        name: "Twisted Turbine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "twister": {
        name: "Twister",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "two_can_party_superreels": {
        name: "Two Can Party SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "tyrants_fall": {
        name: "Tyrant's Fall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ufo_pyramids": {
        name: "UFO Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ukiyoe": {
        name: "Ukiyo-e",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "ultimate_hold_n_win": {
        name: "Ultimate Hold 'N' Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ultimate_striker": {
        name: "Ultimate Striker",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ultimate_texas_holdem": {
        name: "Ultimate Texas Hold'em",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "ultra_buffalo_hold_and_win": {
        name: "Ultra Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ultra_burn": {
        name: "Ultra Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ultra_fruit_smash": {
        name: "Ultra Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ultra_hold_and_spin": {
        name: "Ultra Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ultra_reels_fruteria": {
        name: "Ultra Reels Fruteria",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "ultras": {
        name: "Ultras",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "uncle_profit": {
        name: "Uncle Profit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "uncrossable_rush": {
        name: "Uncrossable Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "uncrossable_rush_eggster": {
        name: "Uncrossable Rush Eggster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "uncrossable_rush_xmas": {
        name: "Uncrossable Rush Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "undefeated_xerxes": {
        name: "Undefeated Xerxes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "unicorn_dreams": {
        name: "Unicorn Dreams",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "unicorn_reels": {
        name: "Unicorn Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "unlimited_treasures": {
        name: "Unlimited Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "unlimited_treasures_bonus_buy": {
        name: "Unlimited Treasures Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "unlimited_wishes": {
        name: "Unlimited Wishes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "usa_flip": {
        name: "USA Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "valentine_monchy": {
        name: "Valentine Monchy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "valentines_coins": {
        name: "Valentine's Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "valhalla": {
        name: "Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "valhalluck": {
        name: "Valhalluck",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "valkyries": {
        name: "Valkyries",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "valletta_megaways": {
        name: "Valletta Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "valley_of_dreams": {
        name: "Valley of Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "vampire_senpai": {
        name: "Vampire Senpai",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "vampires_charm": {
        name: "Vampire's Charm",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "vampires_fate": {
        name: "Vampire's Fate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "vampires_vs_wolves": {
        name: "Vampires vs Wolves",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vampy_party": {
        name: "Vampy Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "van_gogh": {
        name: "Van Gogh",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "van_helsings_book_of_the_undead": {
        name: "Van Helsing's Book Of The Undead",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "vault_raiders_doublemax": {
        name: "Vault Raiders DoubleMax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "vault_rush": {
        name: "Vault Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "vegans_vs_vampires": {
        name: "Vegans vs Vampires",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "vegas_ball_bonanza": {
        name: "Vegas Ball Bonanza",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vegas_blackjack": {
        name: "Vegas Blackjack",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "vegas_fortune": {
        name: "Vegas Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "vegas_gold": {
        name: "Vegas Gold",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "vegas_hold_and_win": {
        name: "Vegas Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "vegas_hot": {
        name: "Vegas Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_hot_81": {
        name: "Vegas Hot 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_hot_spots": {
        name: "Vegas Hot spots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "vegas_joker": {
        name: "Vegas Joker",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "vegas_magic": {
        name: "Vegas Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vegas_nights": {
        name: "Vegas Nights",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vegas_pig_live": {
        name: "Vegas Pig Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "vegas_reels_ii": {
        name: "Vegas Reels II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_solitaire": {
        name: "Vegas Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "vegas_triple_play_spin_n_win": {
        name: "Vegas Triple Play Spin n Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "vegas_vault": {
        name: "Vegas Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "vegas_wins": {
        name: "Vegas Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "velvet_gems": {
        name: "Velvet Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "velvet_riches": {
        name: "Velvet Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "veni_vidi_vici": {
        name: "Veni Vidi Vici",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "venice_festival": {
        name: "Venice Festival",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "victorious": {
        name: "Victorious",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "video_poker": {
        name: "Video Poker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "vietnamese_roulette": {
        name: "Vietnamese Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vietnamese_speed_baccarat": {
        name: "Vietnamese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "viking_apocalypse": {
        name: "Viking Apocalypse",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_clash": {
        name: "Viking Clash",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "viking_fall": {
        name: "Viking Fall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "viking_forge": {
        name: "Viking Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "viking_runecraft": {
        name: "Viking Runecraft",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_runecraft_100": {
        name: "Viking Runecraft 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_runecraft_bingo": {
        name: "Viking Runecraft Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_wilds_scratch": {
        name: "Viking Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "vikings_creed": {
        name: "Vikings Creed",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "vikings_plunder": {
        name: "Viking's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "vikings_unleashed_megaways": {
        name: "Vikings Unleashed MegaWays",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "vikings_unleashed_reloaded_megaways": {
        name: "Vikings Unleashed Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "vikings_video_slot": {
        name: "Vikings Video Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "vikram_aur_betaal": {
        name: "Vikram Aur Betaal",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "vip_auto_roulette": {
        name: "VIP Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vip_blackjack_emerald": {
        name: "VIP Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vip_blackjack_ruby": {
        name: "VIP Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vip_filthy_riches": {
        name: "VIP Filthy Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "vip_roulette": {
        name: "VIP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "viper_city_heist": {
        name: "Viper City Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "virtual_football_pro": {
        name: "Virtual Football Pro",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "virtual_soccer": {
        name: "Virtual Soccer",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "virus_mania": {
        name: "Virus Mania",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "volatile_vikings": {
        name: "Volatile Vikings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "volcanic_coins": {
        name: "Volcanic Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "volcano_goddess": {
        name: "Volcano Goddess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "volcano_riches": {
        name: "Volcano Riches",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "vomiting_unicorns": {
        name: "Vomiting Unicorns",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "voodoo_hex": {
        name: "Voodoo Hex",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "voodoo_magic": {
        name: "Voodoo Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "voodoo_people": {
        name: "Voodoo People",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "waikiki_hold_and_win": {
        name: "Waikiki Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "waikiki_scratch": {
        name: "Wai-Kiki Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "waltz_beauty": {
        name: "Waltz Beauty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wanted_los_desesperados": {
        name: "Wanted: Los Desesperados",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "war": {
        name: "War",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "war_for_olympus": {
        name: "War for Olympus",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "warlords_crystals_of_power": {
        name: "Warlords: Crystals of Power",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "warp_wreckers_power_glyph": {
        name: "Warp Wreckers Power Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "water_blox": {
        name: "Water Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "waves_of_poseidon": {
        name: "Waves of Poseidon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "way_of_the_tiger": {
        name: "Way of the Tiger",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "way_of_the_wolf_hold_and_win_extreme_10000": {
        name: "Way of the Wolf Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ways_of_fortune": {
        name: "Ways Of Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ways_of_the_qilin": {
        name: "Ways of the Qilin",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wbc_ring_of_riches": {
        name: "WBC Ring Of Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wealth_777": {
        name: "Wealth 777",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wealth_inn": {
        name: "Wealth Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "weird_science": {
        name: "Weird Science",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "welcome_to_hell_81": {
        name: "Welcome to Hell 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "west_coast_cash_infinity_reels": {
        name: "West Coast Cash Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "west_hunter_bingo": {
        name: "West Hunter Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "west_town": {
        name: "West Town",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "western_jack": {
        name: "Western Jack",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "western_reels": {
        name: "Western Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "western_sheriff": {
        name: "Western Sheriff",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "western_wilds": {
        name: "Western Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "western_wilds_hold_and_win": {
        name: "Western Wilds Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "western_wilds_megaways": {
        name: "Western Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "what_the_fruit": {
        name: "What the Fruit",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "whats_up_witches": {
        name: "What's Up Witches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wheel": {
        name: "Wheel",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "wheel_big_winner_millionaires_life": {
        name: "Wheel Big Winner Millionaires Life",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wheel_big_winner_power_tower": {
        name: "Wheel Big Winner Power Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wheel_big_winner_red_hot_spins": {
        name: "Wheel Big Winner Red Hot Spins",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wheel_of_happiness": {
        name: "Wheel of Happiness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wheel_of_luck_hold_and_win": {
        name: "Wheel of Luck Hold and Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wheel_of_mictlan": {
        name: "Wheel of Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wheel_of_time": {
        name: "Wheel of Time",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wheel_of_wonders": {
        name: "Wheel of Wonders",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "wheel_ogold": {
        name: "Wheel O'Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wheely_wheely_big_win": {
        name: "Wheely Wheely Big Win",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "whisker_jones": {
        name: "Whisker jones",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "whispering_winds": {
        name: "Whispering Winds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "who_wants_to_be_a_millionaire_roulette": {
        name: "Who Wants to be a Millionaire Roulette",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "whos_the_bride": {
        name: "Who's the Bride",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wicked_whiskers": {
        name: "Wicked Whiskers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "wicked_witch": {
        name: "Wicked Witch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_ace": {
        name: "Wild Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "wild_ape_3258": {
        name: "Wild Ape 3258",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_bandito": {
        name: "Wild Bandito",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_bandolier": {
        name: "Wild Bandolier",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_bard": {
        name: "Wild Bard",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_bazaar": {
        name: "Wild Bazaar",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_beach_party": {
        name: "Wild Beach Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_beans": {
        name: "Wild Beans",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_bison_charge": {
        name: "Wild Bison Charge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_blood": {
        name: "Wild Blood",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_blood_2": {
        name: "Wild Blood 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_booster": {
        name: "Wild Booster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_bounty_showdown": {
        name: "Wild Bounty Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_buccaneers_megaways": {
        name: "Wild Buccaneers MegaWays",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "wild_buccaneers_triple_treasure": {
        name: "Wild Buccaneers Triple Treasure",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "wild_buffalo": {
        name: "Wild Buffalo",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "wild_bullet": {
        name: "Wild Bullet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wild_bullets": {
        name: "Wild Bullets",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wild_card_gang": {
        name: "Wild Card Gang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash": {
        name: "Wild Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash_dice": {
        name: "Wild Cash Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash_x9990": {
        name: "Wild Cash x9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cauldron": {
        name: "Wild Cauldron",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_celebrity_bus_megaways": {
        name: "Wild Celebrity Bus Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_chapo": {
        name: "Wild Chapo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_chapo_2": {
        name: "Wild Chapo 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_chase_tokyo_go": {
        name: "Wild Chase: Tokyo Go",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_chicago": {
        name: "Wild Chicago",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_clusters": {
        name: "Wild Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_coaster": {
        name: "Wild Coaster",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_corrida": {
        name: "Wild Corrida",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "wild_depths": {
        name: "Wild Depths",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_diamond_7x": {
        name: "Wild Diamond 7x",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_duel": {
        name: "Wild Duel",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_falls": {
        name: "Wild Falls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_falls_2": {
        name: "Wild Falls 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_fireworks": {
        name: "Wild Fireworks",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_flow": {
        name: "Wild Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_frames": {
        name: "Wild Frames",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_girls": {
        name: "Wild Girls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_gladiator": {
        name: "Wild Gladiator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_gladiators": {
        name: "Wild Gladiators",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_guns": {
        name: "Wild Guns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_harlequin": {
        name: "Wild Harlequin",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_heart": {
        name: "Wild Heart",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_herd": {
        name: "Wild Herd",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "wild_hike": {
        name: "Wild Hike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_hop_and_drop": {
        name: "Wild Hop & Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_hour_league": {
        name: "Wild Hour League",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "wild_icy_fruits": {
        name: "Wild Icy Fruits",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "wild_island": {
        name: "Wild Island",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "wild_jack": {
        name: "Wild Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_jack_81": {
        name: "Wild Jack 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_joker": {
        name: "Wild Joker",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "wild_joker_stacks": {
        name: "Wild Joker Stacks",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "wild_lion": {
        name: "Wild Lion",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wild_lion_reel_bingo": {
        name: "Wild Lion Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wild_lion_reel_triple": {
        name: "Wild Lion Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wild_lion_superreels": {
        name: "Wild Lion SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wild_luchador": {
        name: "Wild Luchador",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_melon": {
        name: "Wild Melon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_million": {
        name: "Wild Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_mining_xxxtreme": {
        name: "Wild Mining XXXTreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_mirage": {
        name: "Wild Mirage",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_moon_thieves": {
        name: "Wild Moon Thieves",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_north": {
        name: "Wild North",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_north_radiant_skies": {
        name: "Wild North Radiant Skies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_one": {
        name: "Wild One",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_overlords": {
        name: "Wild Overlords",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wild_overlords_bonus_buy": {
        name: "Wild Overlords Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wild_pirates": {
        name: "Wild Pirates",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "wild_pixies": {
        name: "Wild Pixies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_pops": {
        name: "Wild Pops",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wild_pounce": {
        name: "Wild Pounce",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wild_racer": {
        name: "Wild Racer",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "wild_rails": {
        name: "Wild Rails",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_reel_royale": {
        name: "Wild Reel Royale",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wild_rover": {
        name: "Wild Rover",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "wild_rubies": {
        name: "Wild Rubies",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_rubies_christmas_edition": {
        name: "Wild Rubies Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_rubies_gdn": {
        name: "Wild Rubies GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_rubies_rhfp": {
        name: "Wild Rubies RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_silverback": {
        name: "Wild Silverback",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_skullz": {
        name: "Wild Skullz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_skyfire": {
        name: "Wild Skyfire",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_spells": {
        name: "Wild Spells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_storm_legionnaire": {
        name: "Wild Storm Legionnaire",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "wild_survivor": {
        name: "Wild Survivor",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_swarm": {
        name: "Wild Swarm",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "wild_swarm_2": {
        name: "Wild Swarm 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "wild_swarm_3_chocolate_eggs_94": {
        name: "Wild Swarm 3 Chocolate Eggs 94",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "wild_swarm_triple_hive": {
        name: "Wild Swarm Triple Hive",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "wild_tiger": {
        name: "Wild Tiger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_tiger_2": {
        name: "Wild Tiger 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_tigers_bounty": {
        name: "Wild Tiger's Bounty",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "wild_tome_of_the_woods": {
        name: "Wild Tome of the Woods",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_tribe_wall": {
        name: "Wild Tribe Wall",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_trigger": {
        name: "Wild Trigger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_trucks": {
        name: "Wild Trucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_turkey": {
        name: "Wild Turkey",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_turkey_megaways": {
        name: "Wild Turkey Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_walker": {
        name: "Wild Walker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_water": {
        name: "Wild Water",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_weather": {
        name: "Wild Weather",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_west_angel": {
        name: "Wild West Angel",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "wild_west_angel_rodeo": {
        name: "Wild West Angel Rodeo",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "wild_west_gold": {
        name: "Wild West Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_gold_blazing_bounty": {
        name: "Wild West Gold Blazing Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_gold_megaways": {
        name: "Wild West Gold MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_spirit": {
        name: "Wild West Spirit",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "wild_west_trueways": {
        name: "Wild West TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_white_whale": {
        name: "Wild White Whale",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "wild_whopper": {
        name: "Wild Whopper",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wild_wick": {
        name: "Wild Wick",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_wild_bananas": {
        name: "Wild Wild Bananas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_joker": {
        name: "Wild Wild Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_pearls": {
        name: "Wild Wild Pearls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_riches": {
        name: "Wild Wild Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_riches_returns": {
        name: "Wild Wild Riches Returns",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_vegas": {
        name: "Wild Wild Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_wild_west_the_great_train_heist": {
        name: "Wild Wild West: The Great Train Heist",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_wildebeest_wins": {
        name: "Wild Wildebeest Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_worlds": {
        name: "Wild Worlds",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wild_yield": {
        name: "Wild Yield",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wildchemy": {
        name: "Wildchemy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wilderland": {
        name: "Wilderland",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wildest_gambit": {
        name: "Wildest Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wildfire": {
        name: "Wildfire",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "wildfire_west": {
        name: "Wildfire West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wildhalla": {
        name: "Wildhalla",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "wildhound_derby": {
        name: "Wildhound Derby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wildies": {
        name: "Wildies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wildman_super_bonanza": {
        name: "Wildman Super Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wildndice": {
        name: "WildNDice",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "wildotron_3000": {
        name: "Wild-O-Tron 3000",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wilds_gone_wild": {
        name: "Wilds Gone Wild",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "william_hill_slingo": {
        name: "William Hill Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "willys_hot_chillies": {
        name: "Willy's Hot Chillies",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "win_and_go": {
        name: "Win and Go",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "win_and_replay": {
        name: "Win and Replay",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "win_blaster": {
        name: "Win Blaster",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_blaster_christmas_edition": {
        name: "Win Blaster Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_drop": {
        name: "Win Drop",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "win_shooter": {
        name: "Win Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_win_fish_prawn_crab": {
        name: "Win Win Fish Prawn Crab",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "win_win_won": {
        name: "Win Win Won",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "winabeest": {
        name: "Win-A-Beest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wings_of_iguazu": {
        name: "Wings of Iguazu",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wings_of_riches": {
        name: "Wings of Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "winning_bull": {
        name: "Winning Bull",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wino_mart": {
        name: "Win-O Mart",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "wins_of_fortune": {
        name: "Wins of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wins_of_mermaid_multi_power": {
        name: "Wins of Mermaid Multi Power",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "wins_of_winter": {
        name: "Wins of Winter",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "winter_champions": {
        name: "Winter Champions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "winter_fishing_club": {
        name: "Winter Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "winter_star": {
        name: "Winter Star",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "winter_star_bonus_buy": {
        name: "Winter Star Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "winter_trophy_hold_and_win": {
        name: "Winter Trophy Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wisdom_of_athena": {
        name: "Wisdom of Athena",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wisdom_of_athena_1000": {
        name: "Wisdom of Athena 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wisdom_of_athena_1000_xmas": {
        name: "Wisdom of Athena 1000 Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wish_upon_a_cashpot": {
        name: "Wish Upon a Cashpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wish_upon_a_jackpot": {
        name: "Wish Upon a Jackpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wish_upon_a_jackpot_megaways": {
        name: "Wish Upon a Jackpot Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "witch_heart_megaways": {
        name: "Witch Heart Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "witches_night": {
        name: "Witches Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "witches_tome": {
        name: "Witches Tome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "witchy_poppins": {
        name: "Witchy POPpins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wizard_of_gems": {
        name: "Wizard of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wizards_want_war": {
        name: "Wizards Want War!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wolf_begins": {
        name: "Wolf Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "wolf_cub": {
        name: "Wolf Cub",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "wolf_diamond": {
        name: "Wolf Diamond",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wolf_gold": {
        name: "Wolf Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_gold_4_pack": {
        name: "Wolf Gold 4 Pack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_gold_scratch_1000000": {
        name: "Wolf Gold Scratch 1,000,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_gold_ultimate": {
        name: "Wolf Gold Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_hiding": {
        name: "Wolf Hiding",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wolf_hiding_bonus_buy": {
        name: "Wolf Hiding Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wolf_legend_gold_megaways": {
        name: "Wolf Legend Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wolf_legend_megaways": {
        name: "Wolf Legend Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wolf_legend_spinboost": {
        name: "Wolf Legend Spinboost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wolf_moon": {
        name: "Wolf Moon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "wolf_night": {
        name: "Wolf Night",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "wolf_pack": {
        name: "Wolf Pack",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "wolf_peak": {
        name: "Wolf Peak",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "wolf_queen": {
        name: "Wolf Queen",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "wolf_sierra": {
        name: "Wolf Sierra",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wolf_strike": {
        name: "Wolf Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "wolf_strike_hold_and_win_extra": {
        name: "Wolf Strike Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "wonder_farm": {
        name: "Wonder Farm",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wonder_farm_bonus_buy": {
        name: "Wonder Farm Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "wonder_machine": {
        name: "Wonder Machine",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "wonders_of_christmas": {
        name: "Wonders of Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "world_cup": {
        name: "World Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "world_cup_roulette_platinum": {
        name: "World Cup Roulette Platinum",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "worms_of_valor": {
        name: "Worms of Valor",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wow_vegas_elvis_frog_trueways": {
        name: "WOW Vegas Elvis Frog Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wrappin_gold": {
        name: "Wrappin Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wukong_rush": {
        name: "Wukong Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "xdemon": {
        name: "X-Demon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "xdemon_bonus_buy": {
        name: "X-Demon Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "xibalba": {
        name: "Xibalba",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "xiyangyang": {
        name: "XiYangYang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "xmas_3x3": {
        name: "Xmas 3x3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "xmas_around_the_world": {
        name: "Xmas Around the World",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "xmas_joker": {
        name: "Xmas Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "xmas_keno_cat": {
        name: "Xmas Keno Cat",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "xmas_kenocat": {
        name: "Xmas KenoCat",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "xmas_magic": {
        name: "Xmas Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "xmas_pop_delight": {
        name: "Xmas Pop Delight",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "xmas_rush": {
        name: "Xmas Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "xploding_pumpkins": {
        name: "Xploding Pumpkins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "xtra_ball_keno": {
        name: "Xtra Ball Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "xwild": {
        name: "X-Wild",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "yakuza_honor": {
        name: "Yakuza Honor",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "yamashitas_treasure": {
        name: "Yamashita's Treasure",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "year_of_the_dragon_king": {
        name: "Year of the Dragon King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yeti_quest": {
        name: "Yeti Quest",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yi_sun_shin": {
        name: "Yi Sun Shin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yin_and_yang": {
        name: "Yin & Yang",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "yoho_gold": {
        name: "Yo-Ho Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "yokai": {
        name: "Yokai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "yokai_village": {
        name: "Yokai Village",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "yommi_rush": {
        name: "Yommi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "you_can_piggy_bank_on_it": {
        name: "You Can Piggy Bank On It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "young_buffalo_coins": {
        name: "Young Buffalo Coins",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "young_buffalo_song": {
        name: "Young Buffalo Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "young_deer_song": {
        name: "Young Deer Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "young_eagle_song": {
        name: "Young Eagle Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "young_wolf_song": {
        name: "Young Wolf Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "yum_yum_powerways": {
        name: "Yum Yum PowerWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yummy_kitchen": {
        name: "Yummy Kitchen",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "zeldars_fortunes": {
        name: "Zeldar's Fortunes",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "zeus": {
        name: "Zeus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "zeus_2": {
        name: "Zeus 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "zeus_deluxe": {
        name: "Zeus Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "zeus_diving_multipliers": {
        name: "Zeus Diving Multipliers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "zeus_goes_wild": {
        name: "Zeus Goes Wild",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "zeus_rising": {
        name: "Zeus Rising",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "zeus_thunder_tower": {
        name: "Zeus Thunder Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "zeus_vs_hades_gods_of_war": {
        name: "Zeus vs Hades - Gods of War",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_vs_hades_gods_of_war_250": {
        name: "Zeus vs Hades Gods of War 250",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_vs_typhoon": {
        name: "Zeus vs Typhoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_ze_zecond": {
        name: "Zeus Ze Zecond",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "zeuss_thunderstrike": {
        name: "Zeus's Thunderstrike",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "zodiac": {
        name: "Zodiac",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "zodiac_infinity_reels": {
        name: "Zodiac Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "zombie_apocalypse": {
        name: "Zombie Apocalypse",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "zombie_apopalypse": {
        name: "Zombie aPOPalypse",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "zombie_blasters": {
        name: "Zombie Blasters",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "zombie_carnival": {
        name: "Zombie Carnival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombie_circus": {
        name: "Zombie Circus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "zombie_knight": {
        name: "Zombie Knight",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "zombie_outbreak": {
        name: "Zombie Outbreak",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "zombie_road": {
        name: "Zombie Road",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "zombie_school_megaways": {
        name: "Zombie School Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombie_the_apocalypse": {
        name: "Zombie the Apocalypse",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "zombie_train": {
        name: "Zombie Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombies": {
        name: "Zombies",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
};
